module.exports = {
  login: {
    'UserName': 'UserName',
    'PassWord': 'PassWord\xa0',
    'Login': 'Login',
    'Account cannot be empty': 'Account cannot be empty'
  },
  homePage: {
    'Policy': 'Policy',
    'Product': 'Product',
    'Order': 'Order',
    'After-sales': 'After-sales',
    'Audit': 'Audit',
    'Finance and taxation': 'Finance and taxation',
    'Settings': 'Settings',
    'Announcement': 'Announcement',
    'Please enter a keyword': 'Please enter a keyword',
    'Publisher': 'Publisher',
    'Confirm deletion of selected records?': 'Confirm deletion of selected records?',
    'Notification': 'Notification',
    'Processed': 'Processed',
    'Personal Information': 'Personal Information',
    'Change Password': 'Change Password',
    'Edit Profile': 'Edit Profile',
    'Please enter the correct email format': 'Please enter the correct email format',
    'Phone': 'Phone',
    'Phone number must be a number': 'Phone number must be a number',
    'Original password': 'Original password',
    'New password': 'New password',
    'Inconsistent password entered twice!': 'Inconsistent password entered twice!',
    'Mobile phone number cannot be empty': 'Mobile phone number cannot be empty',
    'Please enter the correct mobile phone number': 'Please enter the correct mobile phone number',
    'Please enter your real name': 'Please enter your real name',
    'Mailbox format input error': 'Mailbox format input error',
    'Personal data modified successfully': 'Personal data modified successfully',
    'Failed to modify state': 'Failed to modify state',
    'Password change is successful, please log in to the system again': 'Password change is successful, please log in to the system again',
    'Pass': 'Pass',
    'Exit the system, whether to continue?': 'Exit the system, whether to continue?',
    'Please change the login password first': 'Please change the login password first',
    'ws I was destroyed, remove monitor > > >': 'ws I was destroyed, remove monitor > > >'
  },
  forgotPassword: {
    'Login': 'Login',
    'Enter login name': 'Enter login name',
    'Verify identity': 'Verify identity',
    'Next step': 'Next step',
    'Retrieve password method': 'Retrieve password method',
    'Mailbox Retrieval': 'Mailbox Retrieval',
    'Sent verification email': 'Sent verification email',
    'Sent verification email To': 'Sent verification email To',
    'The verification email is valid for 48 hours please log in to the mailbox ASAP to complete the verification': 'The verification email is valid for 48 hours, please log in to the mailbox ASAP to complete the verification.',
    'Password changed successfully, please re': 'Password changed successfully, please re',
    'Automatically jump to the login page after seconds': 'Automatically jump to the login page after seconds',
    'Inconsistent password entered twice !': 'Inconsistent password entered twice !',
    'Secret protection recovery': 'Secret protection recovery',
    'If the password cannot be retrieved please contact the administrator': 'If the password cannot be retrieved, please contact the administrator.'
  },
  account: {
    'Login must be letters or numbers': 'Login must be letters or numbers',
    'Confidentiality': 'Confidentiality',
    'Department': 'Department',
    'Position': 'Position',
    'Please select a position': 'Please select a position',
    'Character Name': 'Character Name',
    'Please select a role': 'Please select a role',
    'Please fill in the account number': 'Please fill in the account number',
    'The account number must be a combination of numbers and letters': 'The account number must be a combination of numbers and letters',
    'Please fill in the mobile phone number': 'Please fill in the mobile phone number',
    'Please fill in the correct mobile phone number': 'Please fill in the correct mobile phone number',
    'Please fill in the password': 'Please fill in the password',
    'Please fill in the password again': 'Please fill in the password again',
    'Inconsistent password filled in twice': 'Inconsistent password filled in twice',
    'Please fill in your real name': 'Please fill in your real name',
    'Please select a department name': 'Please select a department name',
    'Please select a job title': 'Please select a job title',
    'Please select a role name': 'Please select a role name',
    'Enabled': 'Enabled',
    'Deleted': 'Deleted',
    'Operation failed': 'Operation failed',
    'The mailbox format is incorrect': 'The mailbox format is incorrect',
    'Added/modified account successfully': 'Added/modified account successfully',
    'New account': 'New account',
    'Edit account': 'Edit account',
    'Article': 'Article',
    ',Failed: ': ',Failed :',
    'Status Success': 'Status Success',
    'Status Failed': 'Status Failed',
    'Are you sure the reset password is 123456 ?': 'Are you sure the reset password is 123456 ?',
    'Reset password to 123456': 'Reset password to 123456',
    'Failed to reset password': 'Failed to reset password',
    'Administrator account management': 'Administrator account management'
  },
  configuration: {
    'New system configuration': 'New system configuration',
    'Configuration name': 'Configuration name',
    'Configuration code': 'Configuration code',
    'Configuration value': 'Configuration value'
  },
  operatelog: {
    'Operation date': 'Operation date',
    'Clear data': 'Clear data',
    'Please select start date and end date': 'Please select start date and end date',
    'Confirm that the data is cleared according to the query conditions?': 'Confirm that the data is cleared according to the query conditions?',
    'Deleted successfully': 'Deleted successfully',
    'Bar data': 'Bar data'
  },
  orderlist: {
    '已起飞航班不支持操作': 'Operations are not supported for flights that have already taken off',
    'System pending': 'System pending',
    'System processing': 'System processing',
    'Abnormal order': 'Abnormal order',
    'Manual pending payment': 'Manual pending payment',
    'Manual pending processing': 'Manual pending processing',
    'Order status': 'Order status',
    'Start taking orders': 'Start taking orders',
    'Stop taking orders': 'Stop taking orders',
    'Platform': 'Platform',
    'Please select a platform': 'Please select a platform',
    'Departure Date': 'Departure Date',
    'Arrival Date': 'Arrival Date',
    'ID number': 'ID number',
    'Order Start': 'Order Start',
    'Creation start time': 'Creation start time',
    'Order End': 'Order End',
    'Creation end time': 'Creation end time',
    'Lock order type': 'Lock order type',
    'Lock single person': 'Lock single person',
    'Auditor': 'Auditor',
    'Verification status': 'Verification status',
    'Platform refund has been settled': 'Platform refund has been settled',
    'Purchase rebate settled': 'Purchase rebate settled',
    'Settlement completed': 'Settlement completed',
    'Audit start date': 'Audit start date',
    'Audit end date': 'Audit end date',
    'Auto refresh': 'Auto refresh',
    'Enter ticket': 'Enter ticket',
    'Batch Re-Occupy': 'Batch Re-Occupy',
    'Bulk Ticket Reset': 'Bulk Ticket Reset',
    'Batch modification class': 'Batch modification class',
    'Bulk Booking Instructions': 'Bulk Booking Instructions',
    'Batch platform collection verification account': 'Batch platform collection verification account',
    'Bulk Purchase Payment Verification': 'Bulk Purchase Payment Verification',
    'Latest Ticketing Time/Order Date': 'Latest Ticketing Time/Order Date',
    'Platform Information': 'Platform Information',
    'Platform order number': 'Platform order number',
    'Exception': 'Exception',
    'Appeal': 'Appeal',
    'Urge': 'Urge',
    'Order Status/Sub-Status': 'Order Status',
    'Flight information': 'Flight information',
    'Purchasing Information': 'Purchasing Information',
    'Expenditure Amount': 'Expenditure Amount',
    'PNR/AV status': 'PNR',
    'Total price/number of people': 'Total price/number of people',
    'Unlock': 'Unlock',
    'Drawer': 'Drawer',
    'Ticketing efficiency': 'Ticketing efficiency',
    'Latest ticket issuance': 'Latest ticket issuance',
    'Auditor/Audit status': 'Auditor/Audit status',
    'Platform collection has been settled': 'Platform collection has been settled',
    'Purchase payment settled': 'Purchase payment settled',
    'Are you sure to retake your seat?': 'Are you sure to retake your seat?',
    'Repay': 'Repay',
    'View': 'View',
    'Processing': 'Processing',
    'Are you sure to cancel the top?': 'Are you sure to cancel the top?',
    'Logs': 'Logs',
    'Cancel the top': 'Cancel the top',
    'Order Details': 'Order Details',
    'Order Information :': 'Order Information :',
    'Original order number': 'Original order number',
    'Parent order number': 'Parent order number',
    'Sub-order number': 'Sub-order number',
    'Brother order number': 'Brother order number',
    'Small code': 'Small code',
    'Child Code': 'Child Code',
    'Order Type': 'Order Type',
    'Order source': 'Order source',
    'Total price': 'Total price',
    'Contact phone number': 'Contact phone number',
    'Voyage': 'Voyage',
    'Nationality': 'Nationality',
    'Certificate valid period': 'ID expiration',
    'Purchase Records': 'Purchase Records',
    'Procurement channel': 'Procurement channel',
    'Automatic': 'Automatic',
    'Labor': 'Labor',
    'Transaction record': 'Transaction record',
    'Transaction Channel': 'Transaction Channel',
    'Transaction Amount': 'Transaction Amount',
    'Trading hours': 'Trading hours',
    'Ticket Log': 'Ticket Log',
    'Dispatch': 'Dispatch',
    'Account number': 'Account number',
    'Upload file': 'Upload file',
    'Ticket channel': 'Ticket channel',
    'Unlimited entry 0': 'Unlimited entry 0',
    'No coupon required': 'No coupon required',
    'Coupon useful or not': 'Coupon useful or not',
    'Purchase payment verification details': 'Purchase payment verification details',
    'Purchase payment verification import': 'Purchase payment verification import',
    'Audit account type': 'Audit account type',
    'Purchase Receipt Audit Account': 'Purchase Receipt Audit Account',
    'Platform refund verification account': 'Platform refund verification account',
    'Platform collection verification account': 'Platform collection verification account',
    'Purchase payment verification': 'Purchase payment verification',
    'Number of orders': 'Number of orders',
    'Time consuming': 'Time consuming',
    'File path': 'File path',
    'Export': 'Export',
    'Upload purchase payment verification details': 'Upload purchase payment verification details',
    'Directive': 'Directive',
    'Platform collection verification account details': 'Platform collection verification account details',
    'Platform collection and verification account import': 'Platform collection and verification account import',
    'Upload platform collection verification details': 'Upload platform collection verification details',
    'Class Code': 'Class Code',
    'Shared flights': 'Shared flights',
    'Child Booking Instructions': 'Child Booking Instructions',
    'Please fill in the class': 'Please fill in the class',
    'Please select the verification type': 'Please select the verification type',
    'Please select an account': 'Please select an account',
    'Designated cabin code cannot be empty': 'Designated cabin code cannot be empty',
    'Please select a reason for cancellation': 'Please select a reason for cancellation',
    'Please select a store': 'Please select a store',
    'Batch booking codes cannot be booked for different flight segments': 'Batch booking codes cannot be booked for different flight segments',
    'Please select at least one order': 'Please select at least one order',
    'The maximum number of people in the batch booking code can only be 9 people': 'The maximum number of people in the batch booking code can only be 9 people',
    'Reservation code successful': 'Reservation code successful',
    'Bulk booking instructions cannot be made for different flight segments': 'Bulk booking instructions cannot be made for different flight segments',
    'The maximum number of bulk booking orders can only be 9 people': 'The maximum number of bulk booking orders can only be 9 people',
    'Different airlines cannot modify in batches': 'Different airlines cannot modify in batches',
    'Failed to cancel the order, reason :': 'Failed to cancel the order, reason :',
    'The difference between the start date and the end date cannot be greater than 365 days': 'The difference between the start date and the end date cannot be greater than 365 days',
    'The difference between the start date and the end date cannot exceed 100 days': 'The difference between the start date and the end date cannot exceed 100 days',
    'Added successfully View scan results later': 'Added successfully View scan results later',
    'Are you sure to export the data?': 'Are you sure to export the data?',
    'Passenger Information not found': 'Passenger Information not found',
    'Failed to query purchase records': 'Failed to query purchase records',
    'Airline code configuration not found': 'Airline code configuration not found',
    'Updated order remarks successfully!': 'Updated order remarks successfully!',
    'Failed to fill': 'Failed to fill',
    'Ticket issued has been approved': 'Ticket issued has been approved',
    'There are orders that do not meet the conditions for re-occupation because they are not ticketed and cancelled': 'There are orders that do not meet the conditions for re-occupation because they are not ticketed and cancelled.',
    'The platform ticket number is:': 'The platform ticket number is:',
    'There are orders that do not meet the conditions for re-occupation,': 'There are orders that do not meet the conditions for re-occupation,',
    'There are orders that do not meet the conditions for ticketing reset because they are not ticketed and cancelled': 'There are orders that do not meet the conditions for ticketing reset because they are not ticketed and cancelled.',
    'There are orders that do not meet the conditions for ticket reset,': 'There are orders that do not meet the conditions for ticket reset,',
    'Different airlines cannot reset in batches': 'Different airlines cannot reset in batches',
    'System lock order': 'System lock order',
    'My lock list': 'My lock list',
    'Unlocked order': 'Unlocked order',
    'The verification end date must be greater than or equal to the start date': 'The verification end date must be greater than or equal to the start date',
    'The current limit selects 2 files, this time it is selected': 'The current limit selects 2 files, this time it is selected',
    'Please select upload file': 'Please select upload file',
    'Confirm that the data is exported according to the condition?': 'Confirm that the data is exported according to the condition?',
    'Day': 'd ',
    'hours': 'h ',
    'minutes': 'm ',
    'seconds': 's ',
    'Remaining': 'Remaining',
    'Beyond': 'Beyond ',
    'Age': 'Age',
    'Number of exceptions:': 'Number of exceptions:',
    'Are you sure you want to start taking orders?': 'Are you sure you want to start taking orders?',
    'Query employee dispatch abnormality': 'Query employee dispatch abnormality.',
    'Processing the refund order is full and cannot be dispatched': 'Processing the refund order is full and cannot be dispatched',
    'Are you sure you want to stop taking orders?': 'Are you sure you want to stop taking orders?',
    'Successful delivery of the order': 'Successful delivery of the order',
    'Cancel the top successfully': 'Cancel the top successfully',
    'ws I was destroyed, vue lifecycle>>>': 'ws I was destroyed, vue lifecycle>>>'
  },
  'Record of Refunds and Changes': 'Record of Refunds and Changes',
  'Login timeout, please log in again!': 'Login timeout, please log in again!',
  '首页': 'Home',
  '出票': 'Ticketing',
  '机票': 'Flight',
  '出票单查询': 'Ticket Inquiry',
  '待筛单': 'To be screened',
  '已锁待处理': 'Locked Pending Processing',
  '全部待处理': 'All pending',
  '出票完成': 'Completed',
  '订单取消': 'Cancelled',
  '票号验证': 'Ticket number verification',
  '异常客票': 'Abnormal ticket',
  'OPEN票': 'OPEN ticket',
  '航变信息': 'Flight change information',
  '行程单': 'Itinerary',
  '刷票订单': 'Ticket swipe order',
  '辅助下单': 'Auxiliary order placement',
  '航变订阅': 'Airchange Subscription',
  '航班动态': 'Flight News',
  '飞猪行李额解压': 'Flying Pig Baggage Allowance Uncompression',
  '改签': 'Exchange',
  '改签单查询': 'Change order inquiry',
  '已锁结算异常处理': 'Locked settlement exception handling',
  '已锁结算异常': 'Locked settlement exception',
  '已锁改签中': 'Locked and changed',
  '已锁未退票改签单': 'Locked Unrefunded Change Order',
  '全部结算异常待处理': 'All settlement exceptions pending',
  '全部改签中': 'All changing',
  '全部未退票改签单': 'All unrefunded ticket change orders',
  '改签取消': 'Change Cancel',
  '退票': 'Refund',
  '确认退票': 'Confirm Refund',
  '取消退票': 'Cancel Refund',
  '退票详情': 'Refund details',
  '退票单查询': 'Refund form inquiry',
  '已锁异常回款待处理': 'Locked abnormal refund pending processing',
  '已锁退票异常': 'Locked refund exception',
  '已锁结算异常待处理': 'Locked settlement exception pending',
  '全部异常回款待处理': 'All abnormal returns pending',
  '全部退票异常': 'All refunds are abnormal',
  '全部结算异常': 'All settlement exceptions',
  '核销异常待处理': 'Verification exception pending',
  '全部核销异常订单': 'All verification abnormal orders',
  '退票取消': 'Refund Cancellation',
  '辅助退票': 'Auxiliary refund',
  '退票费确认': 'Refund fee confirmation',
  '异常单': 'Exception order',
  '异常单查询': 'Exception single query',
  '已锁异常回款': 'Locked abnormal refund',
  '全部异常回款': 'All abnormal refunds',
  '异常取消': 'Abnormal Cancellation',
  '申诉单': 'Appeal Form',
  '申诉订单': 'Appeal Order',
  '报表': 'Report',
  '出票订单报表': 'Ticket Order Report',
  '改签订单报表': 'Change order report',
  '退票订单报表': 'Refund Order Report',
  '异常订单报表': 'Abnormal Order Report',
  '出票实时汇总报表': 'Ticket real-time summary report',
  '稽核': 'Audit',
  '改签待结算': 'Change to be settled',
  '改签已结算': 'Change settled',
  '退票已锁核销异常待处理': 'Refund locked verification exception pending',
  '退票全部核销异常待处理': 'Refund all verification exceptions pending',
  '退票待结算': 'Refund pending settlement',
  '退票已结算': 'Refund settled',
  '异常已锁核销异常待处理': 'Exception locked verification exception pending',
  '异常全部核销异常待处理': 'Exception All verification Exception pending',
  '异常待结算': 'Exceptional Pending Settlement',
  '异常已结算': 'Exception settled',
  '运价政策': 'Tariff Policy',
  '公布运价': 'Published Tariff',
  '官网运价': 'Official website freight',
  '官网运价NEW': 'Official website freight NEW',
  '航班周期管理': 'Flight Cycle Management',
  '公布运价扫描': 'Publish Tariff Scan',
  'Eterm数据扫描': 'Eterm Data Scan',
  'Eterm指令查询': 'Eterm command query',
  '疫情订单匹配': 'Epidemic order matching',
  '外部运价查询': 'External freight query',
  '出票规则': 'Ticketing Rules',
  '出票设置': 'Ticketing Settings',
  '出票账号管理': 'Ticketing account management',
  '出票过滤': 'Ticket filtering',
  '出票自动AV订座': 'Ticket automatic AV/reservation',
  '出票渠道管理': 'Ticketing channel management',
  '付款渠道管理': 'Payment channel management',
  '派单设置': 'Dispatch Settings',
  '退票规则': 'Refund Rules',
  '改签规则': 'Change Rules',
  '退票提醒时间设置': 'Refund reminder time setting',
  '退票提醒信息设置': 'Refund reminder information settings',
  '退票处理时限设置': 'Refund processing time limit setting',
  '航司退改规则': 'Airline refund rules',
  '自动退票规则': 'Airline refund rules',
  '产品管理': 'Product Management',
  '航司调价': 'Airline price adjustment',
  '航线调价': 'Route price adjustment',
  '产品日志': 'Product Log',
  '投放日志': 'Drop log',
  '航变国航': 'Air China',
  '航变东航': 'Aviation to China Eastern Airlines',
  '系统监控': 'System Monitoring',
  '报价接口查询': 'Quotation interface query',
  '直连接口状态': 'Direct Connect Interface Status',
  '比价查询': 'Price comparison query',
  '短信查询': 'SMS query',
  '系统配置': 'System configuration',
  '店铺管理': 'Store',
  '系统设置': 'System',
  '代理费管理': 'Agency fee management',
  '机场信息': 'Airport Information',
  '设置': 'Settings',
  '账号管理': 'Account',
  '角色管理': 'Role',
  '部门管理': 'Department',
  '岗位管理': 'Position',
  '公告管理': 'Announcement',
  '操作日志': 'Operation log',
  '渠道': 'Channel',
  '扫舱政策': 'Sweep Policy',
  '产品': 'Product',
  '调价设置': 'Price adjustment',
  '产品监控': 'Product Monitoring',
  '直连监控': 'Direct connection monitoring',
  '订单': 'Direct connection monitoring',
  '出票订单': 'Ticketing',
  '国际机票': 'International Ticket',
  '售后管理': 'After Sales',
  '退票订单': 'Refund',
  '改签订单': 'Exchange',
  '改签详情': 'Exchange Details',
  '异常订单': 'Abnormal',
  '账单': 'Bill',
  '商户现金明细': 'Merchant Cash Details',
  '资金交易明细': 'Merchant Cash Details',
  '财税': 'Finance and taxation',
  '业务报表': 'Business Report',
  '财务报表': 'Financial Statements',
  '权限控制': 'Permission',
  '基础配置': 'Basic configuration',
  '导出': 'Export',
  '查看': 'View',
  '日志': 'Log',
  '解锁': 'Unlock',
  '导入': 'Import',
  '处理': 'Processing',
  '批量确认': 'Batch Confirmation',
  '批量结算': 'Batch Settlement',
  '批量异常': 'Batch Exception',
  '重新占座': 'Re-occupy the seat ',
  '重新支付': 'Re-pay',
  '核账': 'Audit account',
  '订单详情': 'Order Details',
  '标记验证通过': 'Mark verification passed',
  '标记验证不通过': 'Mark verification failed',
  '忽略验证': 'Ignore validation',
  '核实通过': 'Verified through',
  '重新回填': 'Backfill',
  '已打印': 'Printed',
  '已快递': 'Express',
  '已取消': 'Cancelled',
  '已退票': 'Refunded',
  'Eterm指令': 'Eterm directive',
  '详情': 'Details',
  '编辑': 'Edit',
  '修改': 'Modify',
  '修改状态': 'Modify Status',
  '重新刷票': 'Re-swipe the ticket ',
  '已出票': 'Tickets issued',
  '取消刷票': 'Cancel the swipe',
  '开启': 'Open',
  '暂停': 'Pause',
  '删除': 'Delete',
  'Back': 'Back',
  '清除数据': 'Clear data',
  '新增': 'Add',
  '付款': 'Payment',
  '解压': 'Unzip',
  '取消置顶': 'Cancel overhead',
  '派单': 'Delivery order ',
  '账号规则': 'Account Rules',
  '系统派单设置编辑': 'System dispatch settings edit',
  '员工派单设置编辑': 'Employee dispatch settings edit',
  '产品设置': 'Product Settings',
  '航线过滤': 'Route filter',
  '航线白名单': 'Route whitelist',
  '拉单规则': 'Pull order rule',
  '重置密码': 'Reset-pw',
  '新增角色': 'Add Role',
  '指定用户': 'Designated user ',
  '新增部门': 'New',
  '删除部门': 'Delete',
  '保存': 'Save',
  '保存出票单': 'Save Ticket',
  '保存退票单': 'Save ticket refund',
  '保存改签单': 'Save the change',
  '拒绝出票': 'Refuse to ticket',
  '拒绝退票': 'Refund rejected',
  '拒绝改签': 'Refuse to change',
  '审核': 'Review',
  '结算': 'Settle',
  '添加': 'Add',
  '启用': 'Enable ',
  '禁用': 'Disable ',
  '上线': 'On-line',
  '录入出票单': 'Enter ticket',
  '录入退票单': 'Enter the refund form',
  '改签申请': 'Application for ticket change',
  '导出报表': 'Export report',
  '核销异常待结算': 'Verification exception pending settlement',
  '核销异常已结算': 'verification exception settled',
  '待确认': 'Pending confirmation',
  '待结算': 'Pending settlement',
  '已结算': 'Settled ',
  '已锁核销异常待处理': 'Locked verification exception pending',
  '全部核销异常待处理': 'All verification exceptions pending',
  '销售报表': 'Sales Report',
  '利润报表': 'Profit Statement',
  '交易报表': 'Transaction Statement',
  '出票单乘机人报表': 'Ticket passenger report',
  '复制': 'Copy ',
  '系统日志': 'System log',
  '订单乘机人人电话CTM': 'Order flight renren phone CTM',
  '订单联系人电话CTCT': 'Order contact phone CTCT',
  '去哪儿票号验证接口': 'Qunar ticket number verification interface',
  '航变监控': 'Aviation monitoring',
  '售后订单推送': 'After-sales order push',
  '异常自动重试': 'Exception auto retry',
  '退票单票号验证': 'Refund single ticket number verification',
  '出票利润群推送': 'Ticket profit group push',
  '订单统计': 'Order Statistics',
  '运营': 'Operation ',
  '菜单管理': 'Menu',
  '数据字典': 'Data dictionary',
  '字典配置': 'Dictionary',
  '新增菜单': 'Add',
  '权限设置': 'Permission',
  '资源管理': 'Resource',
  '商家管理': 'Merchant',
  '任务调度': 'Task Scheduling',
  '政策爬虫': 'policy python',
  '占座爬虫': 'Occupy a seat python',
  '缓存管理': 'Cache',
  '商家账号管理': 'Merchant account',
  '常旅客页面': 'Frequent Flyer Page',
  '数据': 'Data ',
  '财务': 'Finance ',
  '对账': 'Reconciliation ',
  '成人': 'Adult',
  '儿童': 'Child',
  '婴儿': 'Infant',
  '语言': 'Language',
  '手提': 'Carry-on',
  '托运': 'Checked',
  '请选择要操作的数据': 'Please select the data to operate',
  'Please enter username': 'Please enter username',
  'Please enter password': 'Please enter password',
  'Error': 'Error',
  'Password cannot be empty': 'Password cannot be empty',
  'Success': 'Success',
  'Home': 'Home',
  'Channel': 'Channel',
  'Search': 'Search',
  'Title': 'Title',
  'Release time': 'Release time',
  'Operation': 'OP',
  'Delete': 'Del',
  'Announcement details': 'Announcement details',
  'Attachment': 'Attachment',
  'Tip': 'Tip',
  'Login Name': 'Login Name',
  'Real Name': 'Real Name',
  'Gender': 'Gender',
  'Male': 'Male',
  'Female': 'Female',
  'Role Name': 'Role Name',
  'Job Number': 'Job Number',
  'Please fill in the job number': 'Please fill in the job number',
  'Mail': 'Mail',
  'Cancel': 'Cancel',
  'Save': 'Save',
  'Confirm Password': 'Confirm Password',
  'Please enter the password again': 'Please enter the password again',
  'Modified status successfully': 'Modified status successfully',
  'Yes': 'Yes',
  'Reset-pw': 'Reset-pw',
  'Password': 'Password',
  'Reset': 'Reset',
  'Failed': 'Failed',
  'Contact information': 'Contact',
  'Import': 'Import',
  'Add': 'Add',
  'Status': 'Status',
  'administrator': 'Administrator',
  'No': 'No',
  'Department Name': 'Department Name',
  'Job Title': 'Job Title',
  'Creation time': 'Creation time',
  'Edit': 'Edit',
  'Are you sure to delete?': 'Are you sure to delete?',
  'Please select a department': 'Please select a department',
  'Normal': 'Normal',
  'Disable': 'Disable',
  'Click to upload': 'Click to upload',
  'Only xlsx files can be uploaded': 'Only xlsx files can be uploaded',
  'Download Template': 'Download Template',
  'The current limit selects 1 file, this time it is selected': 'The current limit selects 1 file, this time it is selected',
  'Files selected': 'Files selected',
  'files': 'files',
  'Please select a file to upload': 'Please select a file to upload',
  'Modify': 'Modify',
  'OK': 'OK',
  'Remarks': 'Remarks',
  'Role Description': 'Role Description',
  'Permission': 'Permission',
  'Operator': 'Operator',
  'Start date': 'Start date',
  'End date': 'End date',
  'End date must be greater than or equal to start date': 'End date must be greater than or equal to start date',
  'dateTips': 'The difference between the start date and the end date cannot be greater than {days} days',
  'The difference between the start date and the end date cannot be greater than 31 days': 'The difference between the start date and the end date cannot be greater than 31 days',
  'Merchant': 'Merchant',
  'Shop': 'Shop',
  'Order Status': 'Order Status',
  'Policy Code': 'Policy Code',
  'Platform ticket number': 'Ticket number',
  'Arrival airport code': 'Arrival airport code',
  'Flight No': 'Flight No',
  'Class': 'Class',
  'Passenger Name': 'Passenger Name',
  'Ticket number': 'Ticket number',
  'Purchase Order Number': 'Purchase Order Number',
  'Change': 'Exchange',
  'Refund': 'Refund',
  'Share': 'Share',
  'Profit': 'Profit',
  'Passenger': 'Passenger',
  'Re-occupy the seat': 'Re-occupy the seat',
  'Ticket Reset': 'Ticket Reset',
  'Are you sure to pay again?': 'Are you sure to pay again?',
  'Audit account': 'Audit account',
  'Order number': 'Order number',
  'Booking no': 'Booking no',
  'Operation No': 'Operation No',
  'Big Code': 'Big Code',
  'Policy Type': 'Policy Type',
  'Order Date': 'Order Date',
  'Ticketing Date': 'Ticketing Date',
  'Exchange Date': 'Exchange Date',
  'Departure Airline': 'Departure Airline',
  'Contact Name': 'Contact Name',
  'Exception information': 'Exception information',
  'Order Remarks': 'Order Remarks',
  'Segment Information': 'Segment Information',
  'Segment': 'Segment',
  'Type': 'Type',
  'Departure time': 'Departure time',
  'Arrival time': 'Arrival time',
  'Passenger Information': 'Passenger Information',
  'Birthday': 'Date of birth',
  'Fare': 'Fare',
  'Sales Price': 'Sales Price',
  'Taxes': 'Taxes',
  'Purchase method': 'Purchase method',
  'Purchase account number': 'Purchase account number',
  'Purchase password': 'Purchase password',
  'Payment Amount': 'Payment Amount',
  'Offer Type': 'Offer Type',
  'Discount Amount': 'Discount Amount',
  'Offer logo': 'Offer logo',
  'Purchase time': 'Purchase time',
  'Trading serial number': 'Trading serial number',
  'Change Information': 'Change Information',
  'Refund information': 'Refund information',
  'Order Log': 'Order Log',
  'Payment Channel': 'Payment Channel',
  'Ticketing office': 'Ticketing office',
  'Ticketing Class': 'Ticketing Class',
  'Please select': 'Please select',
  'Lowest cabin': 'Lowest cabin',
  'Same cabin': 'Same cabin',
  'Downgrade': 'Downgrade',
  'Designated class': 'Designated class',
  'Designated cabin code': 'Designated cabin code',
  'Maximum loss amount': 'Maximum loss amount',
  'None': 'None',
  'Direct subtraction': 'Direct subtraction',
  'Coupon': 'Coupon',
  'Red Packet': 'Red Packet',
  'Coupon has no face value': 'Coupon has no face value',
  'Coupon Rules': 'Coupon Rules',
  'Product Type': 'Product Type',
  'Select All': 'Select All',
  'Modify order status': 'Modify order status',
  'Reason for cancellation': 'Reason for cancellation',
  'Payment timeout cancellation': 'Payment timeout cancellation',
  'Intercept Ticket Cancellation': 'Intercept Ticket Cancellation',
  'Unticketed Refund Cancellation': 'Unticketed Refund Cancellation',
  'Manual Cancellation': 'Manual Cancellation',
  'Unticketed Refund Purchased': 'Unticketed Refund Purchased',
  'Rejected Cancellation': 'Rejected Cancellation',
  'Booking Instructions': 'Booking Instructions',
  'Main flight': 'Main flight',
  'Adult Booking Instructions': 'Adult Booking Instructions',
  'Copy': 'Copy',
  'Please enter content': 'Please enter content',
  'Please select the ticketing class': 'Please select the ticketing class',
  'Please select the ticket channel': 'Please select the ticket channel',
  'Please select a payment channel': 'Please select a payment channel',
  'Maximum loss amount cannot be empty': 'Maximum loss amount cannot be empty',
  'Please select the offer type': 'Please select the offer type',
  'Please select the coupon rule': 'Please select the coupon rule',
  'Confirm cancellation of order?': 'Confirm cancellation of order?',
  'Submit': 'Submit',
  'Cancel the order successfully': 'Cancel the order successfully',
  'Children': 'Children',
  'There is a purchase record in processing, try again later': 'There is a purchase record in processing, try again later',
  'Copied to paste board': ' Copied to paste board',
  'To be screened': 'To be screened',
  'Waiting for seat confirmation': 'Waiting for seat confirmation',
  'noPay': 'noPay',
  'Waiting for ticket': 'Waiting for ticket',
  'Ticketing': 'Ticketing',
  'Purchasing': 'Purchasing',
  'Purchase Completed': 'Purchase Completed',
  'Purchase Failed': 'Purchase Failed',
  'Ticket issued successfully': 'Ticket issued successfully',
  'Cancelled': 'Cancel',
  'Pending': 'Pending',
  'Wait for system payment': 'Wait for system payment',
  'Waiting for manual payment': 'Waiting for manual payment',
  'Ticket swiping': 'Ticket swiping',
  'Successful ticket swiping': 'Successful ticket swiping',
  'Failed to swipe tickets': 'Failed to swipe tickets',
  'Filling in': 'Filling in',
  'Successful filling': 'Successful filling',
  'Pending appeal': 'Pending appeal',
  'In appeal': 'In appeal',
  'Appeal successful': 'Appeal successful',
  'Appeal failed': 'Appeal failed',
  'Gambling on the change': 'Gambling on the change',
  'Betting on the success of the flight': 'Betting on the success of the flight',
  'Betting on the flight to fail': 'Betting on the flight to fail',
  'Tickets issued': 'Tickets issued',
  'Downgraded': 'Downgraded',
  'Refunded': 'Refunded',
  'Changed': 'Changed',
  'Intercepting ticket issuance': 'Intercepting ticket issuance',
  'Failed to intercept ticket issuance': 'Failed to intercept ticket issuance',
  'Backfill failed': 'Backfill failed',
  'Asynchronous ticketing': 'Asynchronous ticketing',
  'Asynchronous Seat Occupancy': 'Asynchronous Seat Occupancy',
  'Asynchronous payment in progress': 'Asynchronous payment in progress',
  'Settlement': 'Settlement',
  'Lock': 'Lock',
  'Unlocked successfully': 'Unlocked successfully',
  'Unlock failed': 'Unlock failed',
  'Unticketed Cancellation': 'Unticketed Cancellation',
  'Re-payment successful': 'Re-payment successful',
  'Re-payment failure': 'Re-payment failure',
  'Youth Special': 'Youth Special',
  'Multi-person special offer': 'Multi-person special offer',
  'Self-selling price': 'Self-selling price',
  'Domestic surprise price': 'Domestic surprise price',
  'Economy Class': 'Economy Class',
  'Please fill in the correct number': 'Please fill in the correct number',
  'Please select a passenger': 'Please select a passenger',
  'Start and end dates cannot be empty': 'Start and end dates cannot be empty',
  'Ticket number can only be 13 digits': 'Ticket number can only be 13 digits',
  'Order source configuration not found': 'Order source configuration not found',
  'Query': 'Query',
  'All': 'All',
  'Special Offer': 'Special Offer',
  'New': 'New',
  '充值余额': 'Deposit funds',
  '使用充值余额': 'Use deposit funds',
  '充值余额结算': 'Deposit balance settlement',
  '充值余额不足': 'Insufficient deposit balance',
  '资金变动': 'Changes in Funds',
  '充提审核': 'Deposit&Withdrawal Review',
  '结算管理': 'Settlement',
  '资金账户': 'Funding Account',
  '出票费结算': 'Ticket Fee',
  '改签费结算': 'Exchange Fee',
  '退票费结算': 'Refund Fee',
  '出票费审核': 'Ticket Fee Review',
  '改签费审核': 'Exchange Fee Review',
  '退票费审核': 'Refund Fee Review',
  '现金账户明细': '',
  '供应商': 'Supplier',
  '采购商': 'Purchaser',
  '一级': 'First level',
  '二级': 'Secondary',
  '三级': 'tertiary',
  '异常': 'Abnormal',
  '正常': 'Normal',
  '授信结算': 'Credit Settlement',
  '授信结算明细': 'Credit Settlement Details',
  '授信结算单号': 'Settlement Number',
  '授信': 'Credit',
  'Credit limit': 'Credit limit',
  'Credit settlement period': 'Credit settlement period',
  'Credit balance': 'Credit balance',
  'Settlement time': 'Settlement time',
  'Payment deadline': 'Payment deadline',
  'Amount due': 'Amount due',
  'Pay amount': 'Pay amount',
  'Payer': 'Payer',
  'Bill Date': 'Bill Date',
  'Settle': 'Settle',
  'digit': 'digit',
  'nonnegative number': 'nonnegative number',
  'Supports up to': 'Supports up to',
  'decimal places': 'decimal places',
  'integer': 'integer',
  'positive': 'positive',
  '宝易': 'Baoyi',
  '微信': 'wechat',
  '易宝': 'Yibao',
  '支付宝': 'Alipay',
  '平安': 'Peace',
  '免审': 'Immunity from trial',
  '待审核': 'Pending review',
  '审核成功': 'Audit success',
  '审核失败': 'Audit failed',
  '已拒绝': 'Rejected',
  '充值': 'Recharge',
  '提现': 'Withdraw',
  '入账': '',
  '退票冻结现金': 'Refund Freeze',
  '退票解冻现金': 'Refund Unfreezing',
  '收款': 'Receipt',
  '冻结': 'Freeze',
  '解冻': 'Defrost',
  '追加保证金': 'Margin call',
  '退款': 'Refund',
  '授信还款': 'Repayment by credit',
  '授信变更': 'change of credit',
  '默认值': 'Default value',
  '已支付未销账': 'Paid and unwritten',
  '已支付已销账': 'Paid and written off',
  '退款未销账': 'refund outstanding',
  '退款已销账': 'Refund paid off',
  '收入': 'Income',
  '支出': 'Expenditure',
  '交易中': 'Trading ',
  '交易成功': 'Successful',
  '交易失败': 'Failed',
  '政策表': 'Policy Table',
  '国内始发': 'Domestic origin',
  '直飞SOTO程': 'Direct SOTO journey',
  '国内始发Add-On': 'Domestic Origin Add-On',
  '国外始发Add-On': 'Foreign Origin Add-On',
  '境外到境外': 'Overseas to overseas',
  '国内始发中转': 'Domestic origin transit',
  '国外始发中转': 'Foreign origin transit',
  '境外境外境外': 'Overseas Overseas Overseas',
  '境外境内境外': 'Overseas, domestic and overseas',
  '全球到全球': 'Global to Global',
  '全球中转全球': 'Global transit global',
  '单程': 'One way',
  '往返': 'Round trip',
  '单程/往返': 'One way/round trip',
  '挂起': 'Suspend',
  '系统挂起': 'System suspended',
  '无法使用': 'Unable to use',
  '正在审核': 'Reviewing',
  '境外电子': 'Overseas Electronics',
  '无需换编码': 'No need to change the code',
  '换编码出票': 'Change code to issue tickets',
  '大编出票(无需换编)': 'Large-scale ticket (no need to change)',
  '大编出票(需换编)': 'Large-scale ticket (need to be changed)',
  '无需换编出票(外放无位)': 'No need to change the ticket (no place to put it)',
  '原编出票': 'Original ticket issued',
  '换编出票': 'Exchange tickets',
  '相同地区配置可原编出票': 'The same regional configuration can be originally programmed to issue tickets',
  '是': 'Yes',
  '否': 'No',
  '现金': 'Cash',
  '支票': 'Cheque',
  '信用卡': 'Credit Card',
  'Abacus或Sabre': 'Abacus or Sabre',
  '留学生': 'International students',
  '移民': 'Immigrant',
  '劳工': 'Labor',
  '海员': 'Seaman',
  '青年': 'Youth',
  '老年': 'Old age',
  '探亲': 'Visiting relatives',
  '港澳台': 'Hong Kong, Macao and Taiwan',
  '外籍': 'Expatriate',
  '非汉字姓名': 'Non-Chinese character name',
  'Add-On': 'Add-On',
  '境外中转': 'Overseas transit',
  'OPEN': 'OPEN',
  '三方协议': 'Tripartite Agreement',
  '套票': 'Package',
  '整团': 'The whole group',
  '小团': 'Small group',
  '政策信息': 'Policy Information',
  '政策': 'Policy',
  '政策管理': 'Policy Management',
  '数据预览': 'Data Preview',
  '供应商订单': 'Order',
  '出票单报表': 'Ticket Report',
  '改签单报表': 'Exchange Report',
  '采购商订单': 'Order',
  '退票单报表': 'Refund Report',
  '交易记录': 'Transaction record',
  '订单支付页': 'Order Payment',
  '改签支付': 'Change Payment',
  'Ticket Failed': 'Ticket issuance failed',
  '核账日期类型': 'Audit date type',
  '采购付款核账时间': 'Purchase payment verification time',
  '成功': 'Success',
  '待处理': 'Pending',
  '等待系统支付': 'Wait for system payment',
  '等待人工支付': 'Wait for manual payment',
  '采购中': 'Purchasing',
  '采购完成': 'Procurement completed',
  '采购失败': 'Purchase failed',
  '刷票中': 'Ticket swiping',
  '刷票成功': 'Successful ticket swiping',
  '刷票失败': 'Failed to swipe tickets',
  '补位中': 'Filling in',
  '补位成功': 'Successful filling',
  '补位失败': 'Fill failed',
  '待申诉': 'Pending appeal',
  '申诉中': 'In appeal',
  '申诉成功': 'Appeal successful',
  '申诉失败': 'Appeal failed',
  '赌航变': 'Gambling on the change',
  '赌航变成功': 'Betting on the success of the flight',
  '赌航变失败': 'Failed to bet on shipping change',
  '已降舱': 'Downgraded',
  '支付超时取消': 'Payment timeout cancellation',
  '拦截出票取消': 'Intercept Ticket Cancellation',
  '未出票退款取消': 'Unticketed Refund Cancellation',
  '人工取消': 'Manual cancellation',
  '已改签': 'Changed',
  '拦截出票中': 'Intercepting the ticket',
  '拦截出票失败': 'Failed to intercept ticket issuance',
  '未出票退款已采购': 'Unticketed refund has been purchased',
  '回填失败': 'Backfill failed',
  '驳回取消': 'Reject Cancellation',
  '异步出票中': 'Asynchronous ticketing',
  '异步占座中': 'Asynchronous occupancy',
  '异步支付中': 'In asynchronous payment',
  '我的锁单': 'My lock list',
  '系统锁单': 'System lock order',
  '未锁单': 'Unlocked order',
  '等待座位确认': 'Waiting for seat confirmation',
  '待支付': 'Pending payment',
  '出票中': 'Issuing tickets',
  '出票失败': 'Failed',
  '测试商家': 'Test Merchant',
  '联程': 'Connection',
  '多程': 'Multi-way',
  '点击展开全部': 'Click To Expand All',
  '收起': 'Fold Up',
  '核账日期类型不为空': 'Verification date type is not empty',
  '币种': 'Currency',
  '新增币种': 'Add Currency',
  '人民币': 'CNY-Chinese Yuan',
  '马币': 'MYR-Ringgit',
  '美元': 'USD-United States Dollar',
  '新加坡元': 'SGD-Singapore Dollar',
  '印尼盾': 'IDR-Indonesia Rupiah',
  '请选择币种': 'Please select a currency',
  '更换币种成功': 'Successful currency change',
  '去程': 'Depart',
  '返程': 'Return',
  '中转': 'transfer',
  '待出票': 'Pending ticket issuance',
  '未查询到': 'Not found',
  '未开通': 'Not open',
  '可用余额不足': 'Insufficient balance',
  '汇率': 'Exchange rate',
  '汇率表': 'Exchange Rate',
  '关闭': 'Close',
  '机票预订': 'Home',
  '供应出票单查询': 'Ticketing',
  '采购出票单查询': 'Ticketing',
  '去支付': 'Pay',
  '国际机票查询': 'International Ticket Inquiry',
  '出票单详情': 'Ticket details',
  '国际机票预订': 'Home',
  '订单管理': 'Order',
  '调价规则': 'Price Adjustment',
  '低价看板': 'Comparison Board',
  '联系我们': 'Contact',
  '支付管理': 'Payment Info',
  '收款信息': 'Payee Info',
  'Coffee And Meeting': 'Coffee on us or request for an online meeting',
  'Contact Us For Form': 'Feel free to contact us for any enquiry else you may use the form below to reach us.',
  'SUBMIT FORM': 'SUBMIT FORM',
  'Operating Hours': 'Operating Hours',
  'Email': 'Email',
  'WhatsApp': 'WhatsApp',
  'Name': 'Name',
  'Your Message': 'Your Message',
  'Type Of Enquiry': 'Type Of Enquiry',
  '北京': 'Beijing',
  '巴黎': 'Paris',
  '东京': 'Tokyo',
  '首尔': 'Seoul',
  '纽约': 'New York',
  '香港': 'Hong Kong, China',
  '中国香港': 'Hong Kong, China',
  '中国澳门': 'Macau, China',
  '深圳': 'Shenzhen',
  '广州': 'Guangzhou',
  '上海': 'Shanghai',
  '阿伯丁': 'Aberdeen',
  '阿布贾': 'Abuja',
  '阿比让': 'Abidjan',
  '阿布扎比': 'Abu Dhabi',
  '爱丁堡': 'Edinburgh',
  '阿德莱德': 'Adelaide',
  '埃德蒙顿': 'Edmonton',
  '阿尔及尔': 'Algiers',
  '阿尔山': 'Arshan',
  '阿瓜迪亚': 'Aguadia',
  '艾哈迈达巴德': 'Ahmedabad',
  '安康': 'Well-being',
  '阿克拉': 'Accra',
  '奥克兰': 'Oakland',
  '安克雷奇': 'Anchorage',
  '阿克苏': 'Aksu',
  '埃克塞特': 'Exeter',
  '阿里': 'Ali',
  '奥兰多': 'Orlando',
  '阿拉尔': 'Aral',
  '阿拉木图': 'Almaty',
  '阿拉善盟': 'Alxa League',
  '阿勒泰': 'Altay',
  '安曼': 'Amman',
  '埃默拉尔德': 'Emerald',
  '阿姆利则': 'Amritsar',
  '阿姆斯特丹': 'Amsterdam',
  '阿皮亚': 'Apia',
  '安庆': 'Anqing',
  '鞍山': 'Anshan',
  '安顺': 'Anshun',
  '奥什': 'Osh',
  '阿什哈巴德': 'Ashgabat',
  '奥斯陆': 'Oslo',
  '奥斯汀': 'Austin',
  '安特卫普': 'Antwerp',
  '安阳': 'Anyang',
  '博鳌': 'Boao',
  '蚌埠': 'Bengbu',
  '槟城': 'Penang',
  '保定': 'Baoding',
  '班达伯格': 'Bundaberg',
  '布达佩斯': 'Budapest',
  '波尔多': 'Bordeaux',
  '贝尔法斯特': 'Belfast',
  '贝尔格莱德': 'Belgrade',
  '伯恩茅斯': 'Bournemouth',
  '布尔诺': 'Brno',
  '波尔图': 'Porto',
  '布法罗': 'Buffalo',
  '波哥大': 'Bogota',
  '巴格多格拉': 'Bagdogra',
  '北海': 'North Sea',
  '宝鸡': 'Baoji',
  '毕节': 'Bijie',
  '班吉': 'Bangui',
  '班加罗尔': 'Bangalore',
  '布加勒斯特': 'Bucharest',
  '北九州': 'Kitakyushu',
  '巴库': 'Baku',
  '别克斯': 'Vieques',
  '巴林': 'Bahrain',
  '巴里': 'Barry',
  '柏林': 'Berlin',
  '博乐': 'Bole',
  '巴厘巴板': 'Balikpapan',
  '布拉柴维尔': 'Brazzaville',
  '巴罗达': 'Baroda',
  '布莱顿': 'Brighton',
  '巴厘岛': 'Bali',
  '布拉格': 'Prague',
  '不来梅': 'Bremen',
  '博洛尼亚': 'Bologna',
  '布里斯班': 'Brisbane',
  '布鲁塞尔': 'Brussels',
  '布里斯托尔': 'Bristol',
  '贝鲁特': 'Beirut',
  '巴伦西亚': 'Valencia',
  '伯明翰': 'Birmingham',
  '巴马科': 'Bamako',
  '巴拿马城': 'Panama City',
  '博帕尔': 'Bhopal',
  '百色': 'Baise',
  '保山': 'Baoshan',
  '比绍': 'Bissau',
  '比萨': 'Pizza',
  '巴斯': 'Bath',
  '波士顿': 'Boston',
  '巴塞尔巴登': 'Basel-Baden',
  '比什凯克': 'Bishkek',
  '巴塞罗那': 'Barcelona',
  '包头': 'Baotou',
  '波特兰': 'Portland',
  '巴特那': 'Patna',
  '芭提雅': 'Pattaya',
  '本溪': 'Benxi',
  '巴亚尔塔港': 'Puerto Vallarta',
  '巴彦淖尔': 'Bayannaoer',
  '布宜诺斯艾利斯': 'Buenos Aires',
  '滨州': 'Binzhou',
  '亳州': 'Bozhou',
  '巴中': 'Bazhong',
  '博兹曼': 'Bozeman',
  '赤壁': 'Chibi',
  '茨城': 'Ibaraki',
  '昌都': 'Qamdo',
  '承德': 'Chengde',
  '常德': 'Changde',
  '成都': 'Chengdu',
  '昌迪加尔': 'Chandigarh',
  '赤峰': 'Chifeng',
  '冲绳': 'Okinawa',
  '楚雄': 'Chu Xiong',
  '朝阳': 'Chaoyang',
  '沧源': 'Cangyuan',
  '滁州': 'Chuzhou',
  '潮州': 'Chaozhou',
  '常州': 'Changzhou',
  '沧州': 'Cangzhou',
  '池州': 'Chizhou',
  '郴州': 'Chenzhou',
  '大安': 'Da an',
  '杜阿拉': 'Douala',
  '德班': 'Durban',
  '迪拜': 'Dubai',
  '大阪': 'Osaka',
  '都柏林': 'Dublin',
  '第比利斯': 'Tbilisi',
  '稻城': 'Daocheng',
  '丹东': 'Dandong',
  '达尔文': 'Darwin',
  '丹佛': 'Denver',
  '东莞': 'Dongguan',
  '敦煌': 'Dunhuang',
  '多哈': 'Doha',
  '敦化': 'Dunhua',
  '德黑兰': 'Tehran',
  '达卡': 'Dhaka',
  '达喀尔': 'Dakar',
  '德里': 'Delhi',
  '大连': 'Dalian',
  '大理': 'Dali',
  '都灵': 'Turin',
  '多伦多': 'Toronto',
  '德令哈': 'Delingha',
  '德勒斯登': 'Dresden',
  '达累斯萨拉姆': 'Dar es Salaam',
  '达拉斯-沃斯堡': 'Dallas-Fort Worth',
  '达曼': 'Daman',
  '达尼丁': 'Dunedin',
  '迪庆': 'Diqing',
  '大庆': 'Daqing',
  '大邱': 'Daegu',
  '杜尚别': 'Dushanbe',
  '杜塞尔多夫': 'Dusseldorf',
  '大石桥': 'Dashi Bridge',
  '大同': 'Datong',
  '底特律': 'Detroit',
  '德兴': 'Dexing',
  '德阳': 'Deyang',
  '东营': 'Dongying',
  '都匀': 'Duyun',
  '达州': 'Dazhou',
  '儋州': 'Danzhou',
  '德州': 'Texas',
  '恩德培': 'Entebbe',
  '鄂尔多斯': 'Ordos',
  '恩贾梅纳': 'N Djamena',
  '额济纳旗': 'Ejin Banner',
  '二连浩特': 'Erenhot',
  '恩施': 'Enshi',
  '鄂州': 'Ezhou',
  '费城': 'Philadelphia',
  '防城港': 'Fangchenggang',
  '福岛': 'Fukushima',
  '福鼎': 'Fuding',
  '福冈': 'Fukuoka',
  '富国岛': 'Phu Quoc Island',
  '奉化': 'Fenghua',
  '凤凰城': 'Phoenix',
  '费里敦': 'Freetown',
  '符拉迪沃斯托克': 'Vladivostok',
  '法兰克福': 'Frankfurt',
  '佛罗伦萨': 'Florence',
  '法罗群岛': 'Faroe Islands',
  '弗雷斯诺': 'Fresno',
  '福清': 'Fuqing',
  '佛山': 'Foshan',
  '釜山': 'Busan',
  '富山': 'Toyama',
  '阜新': 'Fuxin',
  '阜阳': 'Fuyang',
  '抚远': 'Fuyuan',
  '富蕴': 'Fuyun',
  '福州': 'Fuzhou',
  '抚州': 'Fuzhou',
  '广安': 'Guang an',
  '哥本哈根': 'Copenhagen',
  '关岛': 'Guam',
  '广岛': 'Hiroshima',
  '关丹': 'Kuantan',
  '哥德堡': 'Gothenburg',
  '哥打巴鲁': 'Kota Bharu',
  '哥打基纳巴卢': 'Kota Kinabalu',
  '瓜达拉哈拉': 'Guadalajara',
  '格尔木': 'Golmud',
  '贵港': 'Guigang',
  '广汉': 'Guanghan',
  '古晋': 'Kuching',
  '果洛': 'Golo',
  '桂林': 'Guilin',
  '哥伦布': 'Columbus',
  '格拉茨': 'Graz',
  '瓜拉丁加奴': 'Kuala Terengganu',
  '格莱斯顿': 'Gladstone',
  '格拉斯哥': 'Glasgow',
  '桂平': 'Guiping',
  '冈山': 'Okayama',
  '古瓦哈蒂': 'Guwahati',
  '高邮': 'Gaoyou',
  '广元': 'Guangyuan',
  '固原': 'Guyuan',
  '贵阳': 'Guiyang',
  '瓜亚基尔': 'Guayaquil',
  '甘孜': 'Ganzi',
  '赣州': 'Ganzhou',
  '光州': 'Gwangju',
  '淮安': 'Huai an',
  '汉堡': 'Burger',
  '鹤壁': 'Hebi',
  '淮北': 'Huaibei',
  '哈巴罗夫斯克': 'Khabarovsk',
  '哈博罗内': 'Gaborone',
  '霍巴特': 'Hobart',
  '汉川': 'Hanchuan',
  '河池': 'River Pond',
  '海参崴': 'Vladivostok',
  '邯郸': 'Handan',
  '海得拉巴': 'Hyderabad',
  '哈尔滨': 'Harbin',
  '赫尔辛基': 'Helsinki',
  '合肥': 'Hefei',
  '黄冈': 'Huanggang',
  '黑河': 'Black River',
  '怀化': 'Huaihua',
  '呼和浩特': 'Hohhot',
  '皇后镇': 'Queenstown',
  '黑角': 'Black Horn',
  '黄金海岸': 'Gold Coast',
  '海口': 'Haikou',
  '哈科特港': 'Port Harcourt',
  '葫芦岛': 'Huludao',
  '惠灵顿': 'Wellington',
  '海拉尔': 'Hailar',
  '哈里法克斯': 'Halifax',
  '哈拉雷': 'Harare',
  '哈密': 'Hami',
  '海曼岛': 'Hayman Island',
  '哈密尔顿': 'Hamilton',
  '汉密尔顿岛': 'Hamilton Island',
  '海宁': 'Haining',
  '河内': 'Hanoi',
  '淮南': 'Huainan',
  '火奴鲁鲁': 'Honolulu',
  '汉诺威': 'Hannover',
  '黄石': 'Yellowstone',
  '衡水': 'Hengshui',
  '黄山': 'Huangshan',
  '华沙': 'Warsaw',
  '华盛顿': 'Washington',
  '和田': 'Hotan',
  '哈特福德': 'Hartford',
  '红原': 'Red Plains',
  '海阳': 'Haiyang',
  '衡阳': 'Hengyang',
  '华阴': 'Huayin',
  '杭州': 'Hangzhou',
  '惠州': 'Huizhou',
  '菏泽': 'Heze',
  '汉中': 'Hanzhong',
  '贺州': 'Hezhou',
  '湖州': 'Huzhou',
  '胡占德': 'Huzhande',
  '胡志明市': 'Ho Chi Minh City',
  '吉安': 'Ji an',
  '金边': 'Phnom Penh',
  '贾巴尔普尔': 'Jabalpur',
  '吉布提': 'Djibouti',
  '金昌': 'Jinchang',
  '晋城': 'Jincheng',
  '吉达': 'Jeddah',
  '基多': 'Quito',
  '基督城': 'Christchurch',
  '加的夫': 'Cardiff',
  '吉大港': 'Chittagong',
  '加德满都': 'Kathmandu',
  '景德镇': 'Jingdezhen',
  '杰尔': 'Jerry',
  '加尔各答': 'Calcutta',
  '基辅': 'Kiev',
  '静冈': 'Shizuoka',
  '巨港': 'Palembang',
  '加格达奇': 'Gagdach',
  '井冈山': 'Jinggangshan',
  '金华': 'Jinhua',
  '景洪': 'Jinghong',
  '九江': 'Jiujiang',
  '晋江': 'Jinjiang',
  '基加利': 'Kigali',
  '旧金山': 'San Francisco',
  '杰克逊维尔': 'Jacksonville',
  '吉林': 'Jilin',
  '加拉加斯': 'Caracas',
  '基隆拿': 'Kelowna',
  '吉隆坡': 'Kuala Lumpur',
  '甲米': 'Krabi',
  '佳木斯': 'Jiamusi',
  '济宁': 'Jining',
  '金奈': 'Chennai',
  '济南': 'Jinan',
  '建瓯': 'Jian ou',
  '剑桥': 'Cambridge',
  '酒泉': 'Jiuquan',
  '句容': 'Jurong',
  '金斯顿': 'Kingston',
  '建三江': 'Build Sanjiang',
  '金沙萨': 'Kinshasa',
  '焦特布尔': 'Jodhpur',
  '鸡西': 'Jixi',
  '嘉兴': 'Jiaxing',
  '江油': 'Jiangyou',
  '揭阳潮汕': 'Jieyang Chaoshan',
  '嘉峪关': 'Jiayuguan',
  '济州': 'Jeju',
  '晋州': 'Jinzhou',
  '锦州': 'Jinzhou',
  '晋中': 'Jinzhong',
  '焦作': 'Jiaozuo',
  '荆州': 'Jingzhou',
  '九寨沟': 'Jiuzhaigou',
  '喀布尔': 'Kabul',
  '库车': 'Kuqa',
  '康定': 'Kangding',
  '卡迪夫': 'Cardiff',
  '卡尔加里': 'Calgary',
  '库尔勒': 'Korla',
  '凯恩斯': 'Cairns',
  '开封': 'Kaifeng',
  '科夫斯港': 'Port Coffs',
  '卡胡卢伊': 'Kahului',
  '克久拉霍': 'Khajuraho',
  '坎昆': 'Cancun',
  '科克': 'Cork',
  '开罗': 'Cairo',
  '科隆': 'Cologne',
  '凯里': 'Carey',
  '库莱布拉': 'Culebra',
  '克利夫兰': 'Cleveland',
  '克拉根福': 'Klagenfurt',
  '克拉克': 'Clark',
  '克拉科夫': 'Krakow',
  '卡利刻特': 'Calicite',
  '克莱蒙费朗': 'Clermont Ferrand',
  '克拉玛依': 'Karamay',
  '科伦坡': 'Colombo',
  '库拉索': 'Curacao',
  '昆明': 'Kunming',
  '卡诺': 'Kano',
  '科纳克里': 'Conakry',
  '喀纳斯': 'Kanas',
  '开普敦': 'Cape Town',
  '堪培拉': 'Canberra',
  '科钦': 'Cochin',
  '喀什': 'Kashgar',
  '昆山': 'Kunshan',
  '卡萨布兰卡': 'Casablanca',
  '奎屯': 'Kuitun',
  '喀土穆': 'Khartoum',
  '科托努': 'Cotonou',
  '卡塔尼亚': 'Catania',
  '考文垂': 'Coventry',
  '科威特': 'Kuwait',
  '六安': 'Lu an',
  '里昂': 'Lyon',
  '罗安达': 'Luanda',
  '来宾': 'Guest',
  '荔波': 'Libo',
  '赖布尔': 'Raipur',
  '卢布尔亚那': 'Lubljana',
  '拉巴特': 'Rabat',
  '利伯维尔': 'Libreville',
  '莱比锡': 'Leipzig',
  '列城': 'Leh',
  '澜沧': 'Lancang',
  '临沧': 'Lincang',
  '林茨': 'Linz',
  '娄底': 'Loudi',
  '伦敦': 'London',
  '罗德岱堡': 'Fort Lauderdale',
  '伦敦(加拿大）': 'London (Canada)',
  '鹿儿岛': 'Kagoshima',
  '廊坊': 'Langfang',
  '临汾': 'Linfen',
  '泸沽湖': 'Lugu Lake',
  '拉各斯': 'Lagos',
  '临海': 'Linhai',
  '漯河': 'Luohe',
  '拉合尔': 'Lahore',
  '丽江': 'Lijiang',
  '里加': 'Riga',
  '雷焦卡拉布里亚': 'Reggio Calabria',
  '里贾纳': 'Regina',
  '罗克汉普顿': 'Rockhampton',
  '勒克瑙': 'Lucknow',
  '兰卡威': 'Langkawi',
  '雷克雅未克': 'Reykjavik',
  '吕梁': 'Lu Liang',
  '罗利': 'Raleigh',
  '拉罗汤加': 'Rarotonga',
  '洛美': 'Lome',
  '利马': 'Lima',
  '罗马': 'Rome',
  '拉梅齐亚': 'Lamezia',
  '陇南': 'Longnan',
  '拉纳卡': 'Larnaca',
  '黎平': 'Li Ping',
  '六盘水': 'Liupanshui',
  '乐清': 'Yueqing',
  '兰契': 'Ranchi',
  '列日': 'Liege',
  '乐山': 'Leshan',
  '拉萨': 'Lhasa',
  '丽水': 'Yeosu',
  '里斯本': 'Lisbon',
  '卢森堡': 'Luxembourg',
  '洛杉矶': 'Los Angeles',
  '卢萨卡': 'Lusaka',
  '里士满': 'Richmond',
  '莱斯特': 'Lester',
  '拉斯维加斯': 'Las Vegas',
  '莱阳': 'Laiyang',
  '龙岩': 'Longyan',
  '辽阳': 'Liaoyang',
  '洛阳': 'Luoyang',
  '临沂': 'Linyi',
  '溧阳': 'Liyang',
  '耒阳': 'Leiyang',
  '利雅得': 'Riyadh',
  '里雅恩姆卡拉': 'Riam Mkala',
  '连云港': 'Lianyungang',
  '里约热内卢': 'Rio de Janeiro',
  '利兹': 'Leeds',
  '兰州': 'Lanzhou',
  '柳州': 'Liuzhou',
  '泸州': 'Luzhou',
  '林芝': 'Nyingchi',
  '迈阿密': 'Miami',
  '蒙彼利埃': 'Montpellier',
  '麻城': 'Macheng',
  '曼彻斯特': 'Manchester',
  '梅德福': 'Medford',
  '牡丹江': 'Mudanjiang',
  '马德里': 'Madrid',
  '麦地那': 'Medina',
  '墨尔本': 'Melbourne',
  '米尔迪拉': 'Mildura',
  '莫尔斯比港': 'Port Moresby',
  '密尔沃基': 'Milwaukee',
  '孟菲斯': 'Memphis',
  '曼谷': 'Bangkok',
  '名古屋': 'Nagoya',
  '漠河': 'Mohe',
  '麦凯': 'McKay',
  '麦夸里港': 'Port Macquarie',
  '棉兰': 'Medan',
  '米兰': 'Milan',
  '马累': 'Male',
  '马拉博': 'Malabo',
  '马拉加': 'Malaga',
  '马六甲': 'Malacca',
  '马拉喀什': 'Marrakech',
  '毛里求斯': 'Mauritius',
  '蒙罗维亚': 'Monrovia',
  '孟买': 'Mumbai',
  '茂名': 'Maoming',
  '明尼阿波利斯': 'Minneapolis',
  '慕尼黑': 'Munich',
  '马尼拉': 'Manila',
  '木浦': 'Mokpo',
  '眉山': 'Meishan',
  '芒市': 'Mangshi',
  '马赛': 'Marseille',
  '莫斯科': 'Moscow',
  '明斯克': 'Minsk',
  '马斯喀特': 'Muscat',
  '明斯特': 'Munster',
  '芒特艾萨': 'Mount Isa',
  '蒙特雷': 'Monterey',
  '蒙特利尔': 'Montreal',
  '蒙特雷(墨西哥)': 'Monterrey (Mexico)',
  '墨西哥城': 'Mexico City',
  '绵阳': 'Mianyang',
  '梅州': 'Meizhou',
  '满洲里': 'Manzhouli',
  '南安普顿': 'Southampton',
  '宁波': 'Ningbo',
  '内比都': 'Naypyidaw',
  '那不勒斯': 'Naples',
  '纽波特': 'Newport',
  '南昌': 'Nanchang',
  '南充': 'Nanchong',
  '纳迪': 'Nadi',
  '宁德': 'Ningde',
  '诺丁汉': 'Nottingham',
  '努尔苏丹（阿斯塔纳）': 'Nur-Sultan (Astana)',
  '那格浦尔': 'Nagpur',
  '内江': 'Neijiang',
  '南京': 'Nanjing',
  '牛津': 'Oxford',
  '努库阿洛法': 'Nuku alofa',
  '纽卡斯尔(澳大利亚)': 'Newcastle (Australia)',
  '纽卡斯尔(英国)': 'Newcastle (UK)',
  '宁蒗': 'Ninglang',
  '内罗毕': 'Nairobi',
  '纽伦堡': 'Nuremberg',
  '诺里奇': 'Norwich',
  '那拉提': 'Nalati',
  '南宁': 'Nanning',
  '南平': 'Nanping',
  '尼斯': 'Nice',
  '纳什维尔': 'Nashville',
  '南通': 'Nantong',
  '努瓦克肖特': 'Nouakchott',
  '诺维奇': 'Norwich',
  '南阳': 'Nanyang',
  '尼亚美': 'Niamey',
  '平度': 'Flatness',
  '平顶山': 'Pingdingshan',
  '普洱': 'Pu er',
  '普吉': 'Phuket',
  '盘锦': 'Panjin',
  '帕拉马里博': 'Paramaribo',
  '普利茅斯': 'Plymouth',
  '普罗瑟派恩': 'Protherpine',
  '浦那': 'Pune',
  '普宁': 'Puning',
  '平壤': 'Pyongyang',
  '珀斯': 'Perth',
  '蓬塞': 'Ponce',
  '莆田': 'Putian',
  '浦项': 'Pohang',
  '萍乡': 'Pingxiang',
  '匹兹堡': 'Pittsburgh',
  '攀枝花': 'Panzhihua',
  '青岛': 'Qingdao',
  '琼海': 'Qionghai',
  '秦皇岛': 'Qinhuangdao',
  '黔江': 'Qianjiang',
  '潜江': 'Qianjiang',
  '曲靖': 'Qujing',
  '清莱': 'Chiang Rai',
  '乞力马扎罗': 'Kilimanjaro',
  '清迈': 'Chiang Mai',
  '且末': 'At the end',
  '齐齐哈尔': 'Qiqihar',
  '庆阳': 'Qingyang',
  '清远': 'Qingyuan',
  '清州': 'Cheongju',
  '衢州': 'Quzhou',
  '青州': 'Qingzhou',
  '泉州': 'Quanzhou',
  '钦州': 'Qinzhou',
  '乔治王子城': 'Prince George',
  '赫米特': 'Hemet',
  '日喀则': 'Shigatse',
  '日内瓦': 'Geneva',
  '若羌': 'Ruoqiang',
  '荣市': 'Rongshi',
  '日照': 'Sunshine',
  '沙巴': 'Sabah',
  '塞班': 'Symbian',
  '圣芭芭拉': 'Santa Barbara',
  '圣彼得堡': 'St. Petersburg',
  '斯波坎': 'Spokane',
  '圣保罗': 'St Paul',
  '莎车': 'Shache',
  '斯德哥尔摩': 'Stockholm',
  '圣地亚哥(美国)': 'San Diego (USA)',
  '圣地亚哥(智利)': 'Santiago (Chile)',
  '萨尔斯堡': 'Salzburg',
  '索非亚': 'Sofia',
  '韶关': 'Shaoguan',
  '萨格勒布': 'Zagreb',
  '四会': 'Four Meetings',
  '圣胡安': 'San Juan',
  '圣何塞': 'San Jose',
  '石河子': 'Shihezi',
  '沙迦': 'Sharjah',
  '石家庄': 'Shijiazhuang',
  '萨克拉门托': 'Sacramento',
  '圣克鲁斯岛': 'Santa Cruz Island',
  '萨勒诺': 'Salerno',
  '斯利那加': 'Srinagar',
  '苏黎世': 'Zurich',
  '圣路易斯': 'St. Louis',
  '三明': 'Sanming',
  '厦门': 'Xiamen',
  '苏梅岛': 'Koh Samui',
  '三门峡': 'Sanmenxia',
  '萨那': 'Sana',
  '神农架': 'Shennongjia',
  '圣珀尔滕': 'St Pelten',
  '商丘': 'Shangqiu',
  '宿迁': 'Suqian',
  '上饶': 'Shangrao',
  '松山': 'Matsuyama',
  '泗水': 'Surabaya',
  '汕头': 'Shantou',
  '斯图加特': 'Stuttgart',
  '司徒加特': 'Stuart',
  '斯特拉斯堡': 'Strasbourg',
  '圣托马斯': 'St Thomas',
  '宿务': 'Cebu',
  '汕尾': 'Shanwei',
  '斯温顿': 'Swindon',
  '斯旺西': 'Swansea',
  '绍兴': 'Shaoxing',
  '沈阳': 'Shenyang',
  '三亚': 'Sanya',
  '十堰': 'Shiyan',
  '邵阳': 'Shaoyang',
  '松原': 'Matsubara',
  '朔州': 'Shuozhou',
  '随州': 'Suizhou',
  '苏州': 'Suzhou',
  '宿州': 'Suzhou',
  '泰安': 'Tai an',
  '廷布': 'Thimphu',
  '太仓': 'Taicang',
  '塔城': 'Tower City',
  '腾冲': 'Tengchong',
  '通化': 'Tonghua',
  '天津': 'Tianjin',
  '通辽': 'Tongliao',
  '塔林': 'Tallinn',
  '铜陵': 'Tongling',
  '铁岭': 'Iron Ridge',
  '吐鲁番': 'Turpan',
  '特里凡得琅': 'Trivandrum',
  '特拉维夫': 'Tel Aviv',
  '图卢兹': 'Toulouse',
  '天门': 'Tianmen',
  '图木舒克': 'Tumushuk',
  '塔那那利佛': 'Antananarivo',
  '突尼斯': 'Tunisia',
  '坦帕': 'Tampa',
  '铜仁': 'Tongren',
  '台山': 'Taishan',
  '天水': 'Tianshui',
  '唐山': 'Tangshan',
  '塔什干': 'Tashkent',
  '塔什库尔干': 'Tashkorgan',
  '汤斯维尔': 'Townsville',
  '太原': 'Taiyuan',
  '台州': 'Taizhou',
  '泰州': 'Taizhou',
  '文昌': 'Wenchang',
  '乌代布尔': 'Udaipur',
  '温得和克': 'Windhoek',
  '五大连池': 'Wudalianchi',
  '维尔纽斯': 'Vilnius',
  '潍坊': 'Weifang',
  '温哥华': 'Vancouver',
  '威海': 'Weihai',
  '芜湖': 'Wuhu',
  '乌海': 'Wuhai',
  '武汉': 'Wuhan',
  '瓦加杜古': 'Ouagadougou',
  '温岭': 'Wenling',
  '乌兰察布': 'Ulanqab',
  '乌兰浩特': 'Ulanhot',
  '乌鲁木齐': 'Urumqi',
  '维罗纳': 'Verona',
  '瓦拉纳西': 'Varanasi',
  '渭南': 'Weinan',
  '万宁': 'Mannings',
  '温尼伯': 'Winnipeg',
  '威尼斯': 'Venice',
  '乌戎潘当': 'Ujung Pandang',
  '文山': 'Wenshan',
  '巫山': 'Wushan',
  '渥太华': 'Ottawa',
  '万象': 'Vientiane',
  '无锡': 'Wuxi',
  '万鸦老': 'Old Man',
  '维也纳': 'Vienna',
  '武夷山': 'Wuyi Mountain',
  '温州': 'Wenzhou',
  '梧州': 'Wuzhou',
  '万州': 'Wanzhou',
  '吴忠': 'Wu Zhong',
  '西安': 'Xi an',
  '新奥尔良': 'New Orleans',
  '许昌': 'Xuchang',
  '西昌': 'Xichang',
  '宣城': 'Xuancheng',
  '锡尔赫特': 'Sylhet',
  '岘港': 'Da Nang',
  '孝感': 'Xiaogan',
  '夏河': 'Summer River',
  '新加坡': 'Singapore',
  '暹粒': 'Siem Reap',
  '锡林浩特': 'Xilinhot',
  '夏洛特': 'Charlotte',
  '咸宁': 'Xianning',
  '悉尼': 'Sydney',
  '西宁': 'Xining',
  '小松': 'Komatsu',
  '西双版纳': 'Xishuangbanna',
  '休斯顿': 'Houston',
  '仙台': 'Sendai',
  '湘潭': 'Xiangtan',
  '仙桃': 'Xiantao',
  '新潟': 'Niigata',
  '新乡': 'Xinxiang',
  '新西伯利亚': 'Novosibirsk',
  '辛辛那提': 'Cincinnati',
  '兴义': 'Xingyi',
  '信阳': 'Xinyang',
  '襄阳': 'Xiangyang',
  '新余': 'Xinyu',
  '西雅图': 'Seattle',
  '忻州': 'Xinzhou',
  '徐州': 'Xuzhou',
  '延安': 'Yan an',
  '雅安': 'Ya an',
  '宜宾': 'Yibin',
  '银川': 'Yinchuan',
  '伊春': 'Yichun',
  '运城': 'Yuncheng',
  '宜春': 'Yichun',
  '宜昌': 'Yichang',
  '盐城': 'Yancheng',
  '雅典': 'Athens',
  '印第安纳波利斯': 'Indianapolis',
  '亚的斯亚贝巴': 'Addis Ababa',
  '伊尔库茨克': 'Irkutsk',
  '云浮': 'Yunfu',
  '仰光': 'Yangon',
  '盐湖城': 'Salt Lake City',
  '约翰内斯堡': 'Johannesburg',
  '阳江': 'Yangjiang',
  '延吉': 'Yanji',
  '雅加达': 'Jakarta',
  '营口': 'Yingkou',
  '榆林': 'Yulin',
  '玉林': 'Yulin',
  '伊宁': 'Yining',
  '蔚山': 'Ulsan',
  '玉树': 'Yushu',
  '伊斯兰堡': 'Islamabad',
  '伊斯坦布尔': 'Istanbul',
  '鹰潭': 'Yingtan',
  '烟台': 'Yantai',
  '于田': 'Yu Tian',
  '亚特兰大': 'Atlanta',
  '义乌': 'Yiwu',
  '雅温得': 'Yaounde',
  '宜兴': 'Yixing',
  '玉溪': 'Yuxi',
  '岳阳': 'Yueyang',
  '永州': 'Yongzhou',
  '芽庄': 'Nha Trang',
  '扬州': 'Yangzhou',
  '伊兹密尔': 'Izmir',
  '朱巴': 'Juba',
  '淄博': 'Zibo',
  '长白山': 'Changbai Mountain',
  '长春': 'Changchun',
  '中国高雄': 'Kaohsiung, China',
  '中国金门': 'Golden Gate of China',
  '台北': 'Chinese Taipei',
  '中国台北': 'Chinese Taipei',
  '中国台南': 'Tainan, China',
  '中国台中': 'Taichung, China',
  '札幌': 'Sapporo',
  '珠海': 'Zhuhai',
  '湛江': 'Zhanjiang',
  '镇江': 'Zhenjiang',
  '芝加哥': 'Chicago',
  '张家界': 'Zhangjiajie',
  '张家口': 'Zhangjiakou',
  '周口': 'Zhoukou',
  '扎兰屯': 'Zhalantun',
  '驻马店': 'Zhumadian',
  '斋浦尔': 'Jaipur',
  '重庆': 'Chongqing',
  '长崎': 'Nagasaki',
  '肇庆': 'Zhaoqing',
  '长沙': 'Changsha',
  '中山': 'Zhongshan',
  '舟山': 'Zhoushan',
  '昭苏': 'Zhaosu',
  '昭通': 'Zhaotong',
  '中卫': 'Central Guard',
  '张掖': 'Zhangye',
  '资阳': 'Ziyang',
  '遵义茅台': 'Zunyi Moutai',
  '遵义新舟': 'Zunyi New Boat',
  '郑州': 'Zhengzhou',
  '长治': 'Changzhi',
  '株洲': 'Zhuzhou',
  '枣庄': 'Zaozhuang',
  '涿州': 'Zhuozhou',
  '漳州': 'Zhangzhou',
  '热门城市（可直接选择城市或输入城市中文/拼音）': 'Popular cities (you can directly select the city or enter the city Chinese/Pinyin)',
  '热门': 'Popular',
  '输入中文/拼音/↑↓键选择': 'Enter Chinese/Pinyin/↑ ↓ key to select',
  'ZIPAIR': 'ZIPAIR',
  '大溪地': 'Tahiti',
  '柳州白莲机场': 'Liuzhou Bailian Airport',
  '齐齐哈尔三家子机场': 'Qiqihar Sanjiazi Airport',
  '湛江机场': 'Zhanjiang Airport',
  '珠海三灶机场': 'Zhuhai Sanzao Airport',
  '遵义机场': 'Zunyi Airport',
  '西双版纳机场': 'Xishuangbanna Airport',
  '宁波栎社机场': 'Ningbo Lishe Airport',
  '漠河机场': 'Mohe Airport',
  '康定机场': 'Kangding Airport',
  '贵阳荔波机场': 'Guiyang Libo Airport',
  '长白山机场': 'Changbai Mountain Airport',
  '腾冲机场': 'Tengchong Airport',
  '大庆机场': 'Daqing Airport',
  '青海玉树机场': 'Qinghai Yushu Airport',
  '宁夏中卫机场': 'Ningxia Zhongwei Airport',
  '伊春林都机场': 'Yichun Lindu Airport',
  '鸡西兴凯湖机场': 'Jixi Xingkai Lake Airport',
  '宁夏固原六盘山机场': 'Ningxia Guyuan Liupanshan Airport',
  '新疆吐鲁番机场': 'Xinjiang Turpan Airport',
  '新疆博乐机场': 'Xinjiang Bole Airport',
  '阿勒泰机场': 'Altay Airport',
  '兴义机场': 'Xingyi Airport',
  '百色机场': 'Baise Airport',
  '安康机场': 'Ankang Airport',
  '阿克苏机场': 'Aksu Airport',
  '鞍山机场': 'Anshan Airport',
  '南京禄口机场': 'Nanjing Lukou Airport',
  '安庆天柱山机场': 'Anqing Tianzhushan Airport',
  '安顺黄果树机场': 'Anshun Huangguoshu Airport',
  '安阳北郊机场': 'Anyang Beijiao Airport',
  '包头二里半机场': 'Baotou Erli Airport',
  '蚌埠机场': 'Bengbu Airport',
  '北海福成机场': 'Beihai Fucheng Airport',
  '昌都邦达机场': 'Qamdo Bangda Airport',
  '保山云端机场': 'Baoshan Yunduan Airport',
  '那拉提机场': 'Narati Airport',
  '广州白云机场': 'Guangzhou Baiyun Airport',
  '常德桃花源机场': 'Changde Taohuayuan Airport',
  '郑州新郑机场': 'Zhengzhou Xinzheng Airport',
  '长春龙嘉机场': 'Changchun Longjia Airport',
  '朝阳机场': 'Chaoyang Airport',
  '酒泉机场': 'Jiuquan Airport',
  '赤峰土城子机场': 'Chifeng Tuchengzi Airport',
  '长治王村机场': 'Changzhi Wangcun Airport',
  '重庆江北机场': 'Chongqing Jiangbei Airport',
  '南宁吴圩机场': 'Nanning Wuxu Airport',
  '长海大长山岛机场': 'Changhai Dachangshan Island Airport',
  '长沙黄花机场': 'Changsha Huanghua Airport',
  '成都双流机场': 'Chengdu Shuangliu Airport',
  '常州奔牛机场': 'Changzhou Benniu Airport',
  '大同机场': 'Datong Airport',
  '达县达川河市坝机场': 'Daxian Dachuan River City Ba Airport',
  '丹东浪头机场': 'Dandong Langtou Airport',
  '南阳姜营机场': 'Nanyang Jiangying Airport',
  '东莞机场': 'Dongguan Airport',
  '迪庆香格里拉机场': 'Diqing Shangri-La Airport',
  '大连周水子机场': 'Dalian Zhoushuizi Airport',
  '大理荒草坝机场': 'Dali Huangcaoba Airport',
  '敦煌机场': 'Dunhuang Airport',
  '东营机场': 'Dongying Airport',
  '鄂尔多斯伊金霍洛机场': 'Ordos Ijinhuoluo Airport',
  '张家界大庸荷花机场': 'Zhangjiajie Dayong Lotus Airport',
  '南通兴东机场': 'Nantong Xingdong Airport',
  '大足机场': 'Dazu Airport',
  '恩施许家坪机场': 'Enshi Xujiaping Airport',
  '延安二十里铺机场': 'Yan an Ershilipu Airport',
  '福州长乐机场': 'Fuzhou Changle Airport',
  '绥芬河机场': 'Suifenhe Airport',
  '阜阳西关机场': 'Fuyang Xiguan Airport',
  '佛山机场': 'Foshan Airport',
  '富蕴可可托海机场': 'Fuyun Keketuohai Airport',
  '呼伦贝尔满洲里西郊机场': 'Hulunbuir Manzhouli Western Suburb Airport',
  '广汉机场': 'Guanghan Airport',
  '格尔木机场': 'Golmud Airport',
  '厦门高崎机场': 'Xiamen Gaoqi Airport',
  '广元盘龙机场': 'Guangyuan Panlong Airport',
  '海口美兰机场': 'Haikou Meilan Airport',
  '邯郸机场': 'Handan Airport',
  '北京首都机场': 'Beijing Capital Airport',
  '黑河机场': 'Heihe Airport',
  '呼和浩特白塔机场': 'Hohhot Baita Airport',
  '合肥新桥机场': 'Hefei Xinqiao Airport',
  '杭州萧山机场': 'Hangzhou Xiaoshan Airport',
  '怀化芷江机场': 'Huaihua Zhijiang Airport',
  '海拉尔东山机场': 'Hailar Dongshan Airport',
  '乌兰浩特依勒力特机场': 'Ulanhot Illerit Airport',
  '哈密机场': 'Hami Airport',
  '衡阳东江机场': 'Hengyang Dongjiang Airport',
  '南竿机场': 'Nangan Airport',
  '蓬莱机场': 'Penglai Airport',
  '哈尔滨太平机场': 'Harbin Taiping Airport',
  '韶关机场': 'Shaoguan Airport',
  '普陀山朱家尖机场': 'Putuo Mountain Zhujiajian Airport',
  '和田机场': 'Hotan Airport',
  '惠州惠东机场': 'Huizhou Huidong Airport',
  '黄岩路桥机场': 'Huangyan Road and Bridge Airport',
  '汉中西关机场': 'Hanzhong Xiguan Airport',
  '黎平机场': 'Liping Airport',
  '银川河东机场': 'Yinchuan Hedong Airport',
  '上海浦东机场': 'Shanghai Pudong Airport',
  '且末机场': 'Qiemo Airport',
  '庆阳西峰镇机场': 'Qingyang Xifeng Town Airport',
  '景德镇罗家机场': 'Jingdezhen Luojia Airport',
  '嘉峪关机场': 'Jiayuguan Airport',
  '井冈山机场': 'Jinggangshan Airport',
  '吉林二台子机场': 'Jilin Ertaizi Airport',
  '九江庐山机场': 'Jiujiang Lushan Airport',
  '攀枝花保安营机场': 'Panzhihua Baoanying Airport',
  '晋江机场': 'Jinjiang Airport',
  '佳木斯东郊机场': 'Jiamusi Dongjiao Airport',
  '济宁机场': 'Jining Airport',
  '锦州小岭子机场': 'Jinzhou Xiaolingzi Airport',
  '衢州机场': 'Quzhou Airport',
  '九寨沟黄龙机场': 'Jiuzhaigou Huanglong Airport',
  '库车机场': 'Kuqa Airport',
  '喀什机场': 'Kashgar Airport',
  '南昌昌北机场': 'Nanchang Changbei Airport',
  '喀纳斯机场': 'Kanas Airport',
  '昆明长水机场': 'Kunming Changshui Airport',
  '吉安机场': 'Ji an Airport',
  '赣州黄金机场': 'Ganzhou Golden Airport',
  '库尔勒机场': 'Korla Airport',
  '克拉玛依机场': 'Karamay Airport',
  '贵阳龙洞堡机场': 'Guiyang Longdongbao Airport',
  '桂林两江机场': 'Guilin Liangjiang Airport',
  '连城机场': 'Liancheng Airport',
  '光化机场': 'Gwanghua Airport',
  '如皋机场': 'Rugao Airport',
  '兰州中川机场': 'Lanzhou Zhongchuan Airport',
  '梁平机场': 'Liangping Airport',
  '丽江三义机场': 'Lijiang Sanyi Airport',
  '永州零陵机场': 'Yongzhou Lingling Airport',
  '临沧机场': 'Lincang Airport',
  '德宏芒市机场': 'Dehong Mangshi Airport',
  '庐山机场': 'Lushan Airport',
  '拉萨贡嘎机场': 'Lhasa Gongga Airport',
  '林西机场': 'Linxi Airport',
  '洛阳北郊机场': 'Luoyang Beijiao Airport',
  '上海虹桥机场': 'Shanghai Hongqiao Airport',
  '连云港白塔埠机场': 'Lianyungang Baitabu Airport',
  '临沂沭埠岭机场': 'Linyi Shubuling Airport',
  '三女河机场': 'Sanmuhe Airport',
  '淮安机场': 'Huai an Airport',
  '二连浩特赛乌苏机场': 'Erenhot Saiwusu Airport',
  '沈阳桃仙机场': 'Shenyang Taoxian Airport',
  '山海关机场': 'Shanhaiguan Airport',
  '秦皇岛机场': 'Qinhuangdao Airport',
  '荆州沙市机场': 'Jingzhou Shashi Airport',
  '泸州云龙机场': 'Luzhou Yunlong Airport',
  '西安咸阳机场': 'Xi an Xianyang Airport',
  '石家庄正定机场': 'Shijiazhuang Zhengding Airport',
  '揭阳潮汕机场': 'Jieyang Chaoshan Airport',
  '鄯善机场': 'Shanshan Airport',
  '思茅机场': 'Simao Airport',
  '三亚凤凰机场': 'Sanya Phoenix Airport',
  '儋州西庆机场': 'Danzhou Xiqing Airport',
  '苏州机场': 'Suzhou Airport',
  '深圳宝安机场': 'Shenzhen Bao an Airport',
  '青岛流亭机场': 'Qingdao Liuting Airport',
  '林芝机场': 'Nyingchi Airport',
  '塔城机场': 'Tacheng Airport',
  '铜仁大兴机场': 'Tongren Daxing Airport',
  '通辽机场': 'Tongliao Airport',
  '济南遥墙机场': 'Jinan Yaoqiang Airport',
  '通化机场': 'Tonghua Airport',
  '天津滨海机场': 'Tianjin Binhai Airport',
  '黄山屯溪机场': 'Huangshan Tunxi Airport',
  '太原武宿机场': 'Taiyuan Wusu Airport',
  '乌鲁木齐地窝堡机场': 'Urumqi Diwopu Airport',
  '牡丹江海浪机场': 'Mudanjiang Hailang Airport',
  '榆林西沙机场': 'Yulin Xisha Airport',
  '潍坊机场': 'Weifang Airport',
  '威海文登机场': 'Weihai Wendeng Airport',
  '芜湖机场': 'Wuhu Airport',
  '文山普者黑机场': 'Wenshan Puzhehei Airport',
  '温州永强机场': 'Wenzhou Yongqiang Airport',
  '乌海机场': 'Wuhai Airport',
  '武汉天河机场': 'Wuhan Tianhe Airport',
  '绵阳南郊机场': 'Mianyang Nanjiao Airport',
  '武夷山机场': 'Wuyishan Airport',
  '无锡硕放机场': 'Wuxi Shuofang Airport',
  '梧州长洲岛机场': 'Wuzhou Changzhou Island Airport',
  '万州五桥机场': 'Wanzhou Wuqiao Airport',
  '黄石机场': 'Yellowstone Airport',
  '兴城机场': 'Xingcheng Airport',
  '襄樊刘集机场': 'Xiangfan Liuji Airport',
  '西昌青山机场': 'Xichang Qingshan Airport',
  '锡林浩特机场': 'Xilinhot Airport',
  '兴宁机场': 'Xingning Airport',
  '梅县机场': 'Meixian Airport',
  '西宁曹家堡机场': 'Xining Caojiabao Airport',
  '邢台机场': 'Xingtai Airport',
  '徐州观音机场': 'Xuzhou Guanyin Airport',
  '宜宾菜坝机场': 'Yibin Caiba Airport',
  '运城关公机场': 'Yuncheng Guangong Airport',
  '南充高坪机场': 'Nanchong Gaoping Airport',
  '宜昌三峡机场': 'Yichang Three Gorges Airport',
  '伊宁机场': 'Yining Airport',
  '义乌机场': 'Yiwu Airport',
  '依兰机场': 'Yilan Airport',
  '延吉朝阳川机场': 'Yanji Chaoyangchuan Airport',
  '烟台莱山机场': 'Yantai Laishan Airport',
  '盐城南洋机场': 'Yancheng Nanyang Airport',
  '元谋机场': 'Yuanmou Airport',
  '北京南苑机场': 'Beijing Nanyuan Airport',
  '昭通机场': 'Zhaotong Airport',
  '张掖机场': 'Zhangye Airport',
  '天吉泰机场': 'Tianjitai Airport',
  '凯里黄平机场': 'Kaili Huangping Airport',
  '营口机场': 'Yingkou Airport',
  '明月山机场': 'Mingyueshan Airport',
  '重庆黔江舟白机场': 'Chongqing Qianjiang Zhoubai Airport',
  '琼海博鳌机场': 'Qionghai Boao Airport',
  '十堰武当山机场': 'Shiyan Wudang Mountain Airport',
  '临汾乔李机场': 'Linfen Qiaoli Airport',
  '扬州泰州机场': 'Yangzhou Taizhou Airport',
  '吕梁机场': 'Luliang Airport',
  '金昌金川机场': 'Jinchang Jinchuan Airport',
  '巴中恩阳机场': 'Bazhong Enyang Airport',
  '北京大兴机场': 'Beijing Daxing Airport',
  '澜沧景迈机场': 'Lancang Jingmai Airport',
  '广州白云国际机场': 'Guangzhou Baiyun International Airport',
  '北京首都国际机场': 'Beijing Capital International Airport',
  '北京大兴国际机场': 'Beijing Daxing International Airport',
  '深圳宝安国际机场': 'Shenzhen Bao an International Airport',
  '阿伯丁机场': 'Aberdeen Airport',
  '阿布贾国际机场': 'Abuja International Airport',
  '阿比让机场': 'Abidjan Airport',
  '阿布扎比国际机场': 'Abu Dhabi International Airport',
  '爱丁堡机场': 'Edinburgh Airport',
  '阿德莱德机场': 'Adelaide Airport',
  '埃德蒙顿国际机场': 'Edmonton International Airport',
  '阿尔及尔胡阿里· 布迈丁机场': 'Algiers Houari Boumedin Airport',
  '阿尔山伊尔施机场': 'Arshan Irsch Airport',
  '拉斐尔埃尔南德斯机场': 'Rafael Hernandez Airport',
  '艾哈迈达巴德国际机场': 'Ahmedabad International Airport',
  '安康富强机场': 'Ankang Fuqiang Airport',
  '阿克拉科托卡国际机场': 'Accra Kotoka International Airport',
  '奥克兰机场': 'Auckland Airport',
  '安克雷奇国际机场': 'Anchorage International Airport',
  '阿里昆莎机场': 'Alikunsa Airport',
  '奥兰多国际机场': 'Orlando International Airport',
  '阿拉尔塔里木机场': 'Altar Tarim Airport',
  '阿拉木图国际机场': 'Almaty International Airport',
  '阿拉善右旗巴丹吉林机场': 'Alxa Right Banner Badain Jaran Airport',
  '阿拉善左旗巴彦浩特机场': 'Alxa Left Banner Bayanhot Airport',
  '安曼阿莉娅王后国际机场': 'Amman Queen Alia International Airport',
  '埃默拉尔德机场': 'Emerald Airport',
  '阿姆利则拉贾桑西机场': 'Amritsar Rajasansi Airport',
  '阿姆斯特丹史基浦机场': 'Amsterdam Schiphol Airport',
  '阿皮亚法莱奥洛国际机场': 'Apia Faleolo International Airport',
  '鞍山腾鳌机场': 'Anshan Teng ao Airport',
  '奥什机场': 'Osh Airport',
  '阿什哈巴德国际机场': 'Ashgabat International Airport',
  '奥斯陆机场': 'Oslo Airport',
  '奥斯汀国际机场': 'Austin International Airport',
  '琼海博鳌国际机场': 'Qionghai Boao International Airport',
  '槟城机场': 'Penang Airport',
  '班达伯格机场': 'Bundaberg Airport',
  '布达佩斯费里海吉国际机场': 'Budapest Ferrihagi International Airport',
  '波尔多机场': 'Bordeaux Airport',
  '乔治· 贝斯特贝尔法斯特城市机场': 'George Best Belfast City Airport',
  '贝尔格莱德尼古拉· 特斯拉机场': 'Belgrade Nikola Tesla Airport',
  '波尔图机场': 'Porto Airport',
  '布法罗尼加拉机场': 'Buffalo Niagara Airport',
  '埃尔多拉多国际机场': 'El Dorado International Airport',
  '巴格多格拉机场': 'Bagdogra Airport',
  '毕节飞雄机场': 'Bijie Feixiong Airport',
  '班吉机场': 'Bangui Airport',
  '班加罗尔坎皮高达国际机场': 'Bangalore Campigao International Airport',
  '布加勒斯特亨利科安达机场': 'Bucharest Henri Coanda Airport',
  '北九州机场': 'Kitakyushu Airport',
  '巴库盖达尔· 阿利耶夫国际机场': 'Baku Heydar Aliyev International Airport',
  '安东尼奥里维拉罗德里格斯机场': 'Antonio Rivera Rodriguez Airport',
  '巴林国际机场': 'Bahrain International Airport',
  '巴里国际机场': 'Bari International Airport',
  '柏林泰格尔机场': 'Berlin Tegel Airport',
  '柏林舍内菲尔德机场': 'Berlin Sch枚nefeld Airport',
  '勃兰登堡机场': 'Brandenburg Airport',
  '博乐阿拉山口机场': 'Bole Alashankou Airport',
  '巴黎奥利机场': 'Paris Orly Airport',
  '巴黎戴高乐机场': 'Paris Charles de Gaulle Airport',
  '巴厘巴板塞平甘机场': 'Bali Papan Sepingan Airport',
  '马亚马亚机场': 'Maya Maya Airport',
  '巴罗达机场': 'Baroda Airport',
  '巴厘岛登巴萨努拉· 莱伊国际机场': 'Bali Denpasar Nullah Lay International Airport',
  '布拉格机场': 'Prague Airport',
  '不来梅机场': 'Bremen Airport',
  '博洛尼亚 - 博格潘尼格尔机场': 'Bologna-Borg Panigal Airport',
  '布里斯班机场': 'Brisbane Airport',
  '布鲁塞尔机场': 'Brussels Airport',
  '布里斯托尔机场': 'Bristol Airport',
  '贝鲁特拉菲克· 哈里里国际机场': 'Beirut Rafik Hariri International Airport',
  '巴伦西亚机场': 'Valencia Airport',
  '伯明翰机场': 'Birmingham Airport',
  '巴马科塞诺国际机场': 'Bamakoseno International Airport',
  '巴拿马城托库门国际机场': 'Panama City Tocumen International Airport',
  '博帕尔机场': 'Bhopal Airport',
  '百色巴马机场': 'Baise Bama Airport',
  '保山机场': 'Baoshan Airport',
  '奥斯瓦尔多 - 维埃拉机场': 'Osvaldo-Vieira Airport',
  '比萨伽利略· 伽利莱机场': 'Pisa Galileo Galilei Airport',
  '波士顿洛根国际机场': 'Boston Logan International Airport',
  '比什凯克马纳斯国际机场': 'Bishkek Manas International Airport',
  '巴塞罗那机场': 'Barcelona Airport',
  '包头东河机场': 'Baotou Donghe Airport',
  '波特兰机场': 'Portland Airport',
  '巴特那机场': 'Patna Airport',
  '芭提雅乌塔堡机场': 'Pattaya Utapao Airport',
  '巴亚尔塔港机场': 'Puerto Vallarta Airport',
  '巴彦淖尔天吉泰机场': 'Bayannur Tianjitai Airport',
  '豪尔赫纽伯里机场': 'Jorge Newbury Airport',
  '布宜诺斯艾利斯埃塞萨国际机场': 'Buenos Aires Ezeiza International Airport',
  '恩阳机场': 'Enyang Airport',
  '博兹曼机场': 'Bozeman Airport',
  '茨城机场': 'Ibaraki Airport',
  '承德普宁机场': 'Chengde Puning Airport',
  '成都双流国际机场': 'Chengdu Shuangliu International Airport',
  '成都天府国际机场': 'Chengdu Tianfu International Airport',
  '昌迪加尔机场': 'Chandigarh Airport',
  '赤峰玉龙机场': 'Chifeng Yulong Airport',
  '冲绳那霸机场': 'Okinawa Naha Airport',
  '沧源佤山机场': 'Cangyuan Washan Airport',
  '常州奔牛国际机场': 'Changzhou Benniu International Airport',
  '池州九华山机场': 'Chizhou Jiuhuashan Airport',
  '杜阿拉国际机场': 'Douala International Airport',
  '德班沙卡国王国际机场': 'Durban King Shaka International Airport',
  '迪拜国际机场': 'Dubai International Airport',
  '大阪国际机场': 'Osaka International Airport',
  '大阪关西机场': 'Osaka Kansai Airport',
  '都柏林机场': 'Dublin Airport',
  '第比利斯机场': 'Tbilisi Airport',
  '稻城亚丁机场': 'Daocheng Yading Airport',
  '丹东浪头国际机场': 'Dandong Langtou International Airport',
  '达尔文国际机场': 'Darwin International Airport',
  '丹佛国际机场': 'Denver International Airport',
  '多哈哈马德国际机场': 'Doha Hamad International Airport',
  '德黑兰伊玛目霍梅尼机场': 'Tehran Imam Khomeini Airport',
  '东京羽田国际机场': 'Tokyo Haneda International Airport',
  '东京成田国际机场': 'Tokyo Narita International Airport',
  '达卡国际机场': 'Dhaka International Airport',
  '达喀尔布莱兹迪亚涅国际机场': 'Dakar Blaise Diagne International Airport',
  '德里英迪拉· 甘地国际机场': 'Delhi Indira Gandhi International Airport',
  '大连周水子国际机场': 'Dalian Zhoushuizi International Airport',
  '大理机场': 'Dali Airport',
  '都灵机场': 'Turin Airport',
  '多伦多皮尔逊机场': 'Toronto Pearson Airport',
  '德令哈机场': 'Delingha Airport',
  '达累斯萨拉姆国际机场': 'Dar es Salaam International Airport',
  '达拉斯 - 沃斯堡国际机场': 'Dallas-Fort Worth International Airport',
  '达拉斯拉夫菲尔德机场': 'Dallas Loughfield Airport',
  '达曼法赫德国王国际机场': 'Dammam King Fahd International Airport',
  '达尼丁机场': 'Dunedin Airport',
  '大庆萨尔图机场': 'Daqing Saertu Airport',
  '大邱机场': 'Daegu Airport',
  '杜尚别国际机场': 'Dushanbe International Airport',
  '杜塞尔多夫机场': 'Dusseldorf Airport',
  '大同云冈机场': 'Datong Yungang Airport',
  '底特律韦内县大都会机场': 'Detroit Venet County Metropolitan Airport',
  '东营胜利机场': 'Dongying Shengli Airport',
  '达州河市机场': 'Dazhou Heshi Airport',
  '达州金垭机场': 'Dazhou Jinya Airport',
  '恩德培机场': 'Entebbe Airport',
  '鄂尔多斯伊金霍洛国际机场': 'Ordos Ijinhuoluo International Airport',
  '恩贾梅纳国际机场': 'N Djamena International Airport',
  '额济纳旗桃来机场': 'Ejin Banner Taolai Airport',
  '二连浩特赛乌苏国际机场': 'Erenhot Saiwusu International Airport',
  '鄂州花湖机场': 'Ezhou Huahu Airport',
  '费城机场': 'Philadelphia Airport',
  '福岛机场': 'Fukushima Airport',
  '福冈机场': 'Fukuoka Airport',
  '富国岛杜恩当机场': 'Phu Quoc Doondang Airport',
  '凤凰城空港国际机场': 'Phoenix Airport International Airport',
  '隆吉国际机场': 'Lungi International Airport',
  '符拉迪沃斯托克机场': 'Vladivostok Airport',
  '法兰克福机场': 'Frankfurt Airport',
  '佩雷托拉机场': 'Peretola Airport',
  '瓦加尔机场': 'Vagar Airport',
  '弗雷斯诺约塞米蒂国际机场': 'Fresno Yosemite International Airport',
  '釜山金海国际机场': 'Busan Gimhae International Airport',
  '富山机场': 'Toyama Airport',
  '抚远东极机场': 'Fuyuan Dongji Airport',
  '福州长乐国际机场': 'Fuzhou Changle International Airport',
  '哥本哈根机场': 'Copenhagen Airport',
  '关岛国际机场': 'Guam International Airport',
  '广岛机场': 'Hiroshima Airport',
  '关丹机场': 'Kuantan Airport',
  '哥德堡兰德维特机场': 'Gothenburg Landwitt Airport',
  '哥打巴鲁苏丹伊斯梅尔· 佩特拉机场': 'Kota Baru Sultan Ismail Petra Airport',
  '沙巴哥打基纳巴卢机场': 'Sabah Kota Kinabalu Airport',
  '瓜达拉哈拉机场': 'Guadalajara Airport',
  '古晋机场': 'Kuching Airport',
  '果洛玛沁机场': 'Golomachin Airport',
  '桂林两江国际机场': 'Guilin Liangjiang International Airport',
  '哥伦布港机场': 'Port Columbus Airport',
  '格拉茨机场': 'Graz Airport',
  '瓜拉丁加奴苏丹马哈茂德机场': 'Kuala Terengganu Sultan Mahmoud Airport',
  '格莱斯顿机场': 'Gladstone Airport',
  '格拉斯哥国际机场': 'Glasgow International Airport',
  '冈山机场': 'Okayama Airport',
  '古瓦哈蒂机场': 'Guwahati Airport',
  '固原六盘山机场': 'Guyuan Liupanshan Airport',
  '贵阳龙洞堡国际机场': 'Guiyang Longdongbao International Airport',
  '瓜亚基尔国际机场': 'Guayaquil International Airport',
  '甘孜格萨尔机场': 'Ganz Gesar Airport',
  '光州机场': 'Gwangju Airport',
  '淮安涟水机场': 'Huai an Lianshui Airport',
  '汉堡机场': 'Hamburg Airport',
  '哈巴罗夫斯克诺维机场': 'Khabarovsk Novi Airport',
  '塞雷茨· 哈马爵士国际机场': 'Sir Seretz Hama International Airport',
  '霍巴特机场': 'Hobart Airport',
  '河池金城江机场': 'Hechi Jinchengjiang Airport',
  '海得拉巴拉吉夫· 甘地国际机场': 'Hyderabad Rajiv Gandhi International Airport',
  '哈尔滨太平国际机场': 'Harbin Taiping International Airport',
  '赫尔辛基万塔机场': 'Helsinki-Vantaa Airport',
  '合肥新桥国际机场': 'Hefei Xinqiao International Airport',
  '黑河瑷珲机场': 'Heihe Aihui Airport',
  '呼和浩特白塔国际机场': 'Hohhot Baita International Airport',
  '皇后镇机场': 'Queenstown Airport',
  '黑角机场': 'Pointe Noire Airport',
  '黄金海岸机场': 'Gold Coast Airport',
  '海口美兰国际机场': 'Haikou Meilan International Airport',
  '哈科特港机场': 'Port Harcourt Airport',
  '惠灵顿机场': 'Wellington Airport',
  '海拉尔东山国际机场': 'Hailar Dongshan International Airport',
  '斯坦菲尔德国际机场': 'Stanfield International Airport',
  '哈拉雷国际机场': 'Harare International Airport',
  '哈密尔顿机场': 'Hamilton Airport',
  '汉密尔顿岛机场': 'Hamilton Island Airport',
  '河内内排国际机场': 'Hanoi Noi Bai International Airport',
  '火奴鲁鲁檀香山国际机场': 'Honolulu Honolulu International Airport',
  '汉诺威机场': 'Hannover Airport',
  '黄山屯溪国际机场': 'Huangshan Tunxi International Airport',
  '华沙萧邦机场': 'Warsaw Chopin Airport',
  '华盛顿里根国家机场': 'Washington Reagan National Airport',
  '华盛顿杜勒斯国际机场': 'Washington Dulles International Airport',
  '哈特福德布拉德利国际机场': 'Hartford Bradley International Airport',
  '阿坝红原机场': 'Aba Hongyuan Airport',
  '衡阳南岳机场': 'Hengyang Nanyue Airport',
  '杭州萧山国际机场': 'Hangzhou Xiaoshan International Airport',
  '惠州平潭机场': 'Huizhou Pingtan Airport',
  '菏泽牡丹机场': 'Heze Mudan Airport',
  '汉中城固机场': 'Hanzhong Chenggu Airport',
  '胡占德机场': 'Khuchand Airport',
  '胡志明市新山一国际机场': 'Ho Chi Minh City Tan Son Nhat International Airport',
  '金边机场': 'Phnom Penh Airport',
  '贾巴尔普尔机场': 'Jabalpur Airport',
  '吉布提 - 安布利国际机场': 'Djibouti-Ambouli International Airport',
  '吉达阿卜杜勒阿齐兹国王国际机场': 'King Abdulaziz International Airport, Jeddah',
  '基多国际机场': 'Quito International Airport',
  '基督城国际机场': 'Christchurch International Airport',
  '加的夫机场': 'Cardiff Airport',
  '吉大港机场': 'Chittagong Airport',
  '加德满都特里布万国际机场': 'Kathmandu Tribhuvan International Airport',
  '加尔各答机场': 'Kolkata Airport',
  '基辅茹良尼国际机场': 'Kiev Juryani International Airport',
  '静冈机场': 'Shizuoka Airport',
  '苏丹马赫穆德巴达鲁丁二世机场': 'Sultan Mahmoud Badaruddin II Airport',
  '加格达奇机场': 'Gagdach Airport',
  '泉州晋江机场': 'Quanzhou Jinjiang Airport',
  '基加利国际机场': 'Kigali International Airport',
  '旧金山机场': 'San Francisco Airport',
  '杰克逊维尔国际机场': 'Jacksonville International Airport',
  '加拉加斯西蒙玻利瓦尔机场': 'Caracas Simon Bolivar Airport',
  '基隆拿国际机场': 'Kelowna International Airport',
  '吉隆坡国际机场': 'Kuala Lumpur International Airport',
  '甲米机场': 'Krabi Airport',
  '济宁曲阜机场': 'Jining Qufu Airport',
  '金奈国际机场': 'Chennai International Airport',
  '济南遥墙国际机场': 'Jinan Yaoqiang International Airport',
  '建三江湿地机场': 'Jiansanjiang Wetland Airport',
  '金沙萨恩吉利机场': 'Kinshasa Ngili Airport',
  '焦特布尔机场': 'Jodhpur Airport',
  '揭阳潮汕国际机场': 'Jieyang Chaoshan International Airport',
  '济州岛国际机场': 'Jeju Island International Airport',
  '锦州锦州湾机场': 'Jinzhou Jinzhou Bay Airport',
  '九寨黄龙机场': 'Jiuzhai Huanglong Airport',
  '喀布尔国际机场': 'Kabul International Airport',
  '库车龟兹机场': 'Kuqa Qiuci Airport',
  '卡尔加里国际机场': 'Calgary International Airport',
  '凯恩斯机场': 'Cairns Airport',
  '科夫斯港机场': 'Coffs Harbour Airport',
  '卡胡卢伊国际机场': 'Kahului International Airport',
  '克久拉霍机场': 'Khajuraho Airport',
  '坎昆国际机场': 'Cancun International Airport',
  '科克机场': 'Cork Airport',
  '开罗国际机场': 'Cairo International Airport',
  '科隆波恩机场': 'Cologne Bonn Airport',
  '库莱布拉机场': 'Culebra Airport',
  '克利夫兰霍普金斯国际机场': 'Cleveland Hopkins International Airport',
  '克拉克国际机场': 'Clark International Airport',
  '克拉科夫机场': 'Krakow Airport',
  '卡利卡特国际机场': 'Calicut International Airport',
  '克莱蒙费朗奥弗涅机场': 'Clermont-Ferrand-Auvergne Airport',
  '科伦坡班达拉奈克国际机场': 'Colombo Bandaranaike International Airport',
  '哈托国际机场': 'Hato International Airport',
  '昆明长水国际机场': 'Kunming Changshui International Airport',
  '卡诺国际机场': 'Kano International Airport',
  '科纳克里机场': 'Conakry Airport',
  '开普敦国际机场': 'Cape Town International Airport',
  '堪培拉机场': 'Canberra Airport',
  '科钦国际机场': 'Cochin International Airport',
  '卡萨布兰卡穆罕默德五世国际机场': 'Casablanca Mohammed V International Airport',
  '卡萨布兰卡安法机场': 'Casablanca Anfa Airport',
  '喀土穆国际机场': 'Khartoum International Airport',
  '科托努机场': 'Cotonou Airport',
  '卡塔尼亚机场': 'Catania Airport',
  '科威特机场': 'Kuwait Airport',
  '里昂机场': 'Lyon Airport',
  '罗安达二月四日机场': 'Luanda 4th February Airport',
  '荔波机场': 'Libo Airport',
  '赖布尔机场': 'Raipur Airport',
  '卢布尔亚那机场': 'Ljubljana Airport',
  '塞尔机场': 'Searle Airport',
  '利伯维尔莱昂姆巴机场': 'Libreville Leonmba Airport',
  '列城机场': 'Leh Airport',
  '伦敦希思罗机场': 'London Heathrow Airport',
  '伦敦盖特威克机场': 'London Gatwick Airport',
  '伦敦城机场': 'London City Airport',
  '罗德岱堡好莱坞国际机场': 'Fort Lauderdale Hollywood International Airport',
  '鹿儿岛机场': 'Kagoshima Airport',
  '临汾尧都机场': 'Linfen Yaodu Airport',
  '宁蒗泸沽湖机场': 'Ninglang Lugu Lake Airport',
  '拉各斯机场': 'Lagos Airport',
  '拉合尔阿拉马· 伊克巴勒国际机场': 'Lahore Allama Iqbal International Airport',
  '里加机场': 'Riga Airport',
  '里贾纳机场': 'Regina Airport',
  '罗克汉普顿机场': 'Rockhampton Airport',
  '勒克瑙机场': 'Lucknow Airport',
  '兰卡威国际机场': 'Langkawi International Airport',
  '雷克雅未克国际机场': 'Reykjavik International Airport',
  '吕梁大武机场': 'Luliang Dawu Airport',
  '罗利达勒姆机场': 'Raleigh Durham Airport',
  '拉罗汤加机场': 'Rarotonga Airport',
  '洛美机场': 'Lom茅 Airport',
  '利马机场': 'Lima Airport',
  '罗马菲乌米奇诺机场': 'Rome Fiumicino Airport',
  '陇南成县机场': 'Longnan Chengxian Airport',
  '拉纳卡机场': 'Larnaca Airport',
  '六盘水月照机场': 'Liupanshui Yuezhao Airport',
  '兰契机场': 'Ranchi Airport',
  '拉萨贡嘎国际机场': 'Lhasa Gongga International Airport',
  '里斯本机场': 'Lisbon Airport',
  '卢森堡机场': 'Luxembourg Airport',
  '洛杉矶机场': 'Los Angeles Airport',
  '卢萨卡机场': 'Lusaka Airport',
  '里士满国际机场': 'Richmond International Airport',
  '拉斯维加斯麦卡伦机场': 'Las Vegas McCarran Airport',
  '龙岩连城冠豸山机场': 'Longyan Liancheng Guanzhishan Airport',
  '临沂启阳机场': 'Linyi Qiyang Airport',
  '利雅得哈立德国王机场': 'Riyadh King Khalid Airport',
  '里雅恩姆卡拉机场': 'Riam Mkala Airport',
  '连云港花果山机场': 'Lianyungang Huaguoshan Airport',
  '里约热内卢加利昂国际机场': 'Rio de Janeiro Galeon International Airport',
  '利兹机场': 'Leeds Airport',
  '兰州中川国际机场': 'Lanzhou Zhongchuan International Airport',
  '林芝米林机场': 'Nyingchi Mirin Airport',
  '迈阿密机场': 'Miami Airport',
  '蒙彼利埃机场': 'Montpellier Airport',
  '曼彻斯特机场': 'Manchester Airport',
  '梅德福机场': 'Medford Airport',
  '马德里机场': 'Madrid Airport',
  '麦地那国际机场': 'Medina International Airport',
  '墨尔本机场': 'Melbourne Airport',
  '墨尔本爱华隆机场': 'Melbourne Avalon Airport',
  '米尔迪拉机场': 'Mildura Airport',
  '莫尔斯比港机场': 'Port Moresby Airport',
  '密尔沃基米切尔将军国际机场': 'Milwaukee General Mitchell International Airport',
  '孟菲斯机场': 'Memphis Airport',
  '廊曼国际机场': 'Don Mueang International Airport',
  '曼谷素万那普国际机场': 'Bangkok Suvarnabhumi International Airport',
  '名古屋中部国际机场': 'Nagoya Chubu Centrair International Airport',
  '漠河古莲机场': 'Mohe Gulian Airport',
  '麦凯机场': 'Mackay Airport',
  '麦夸里港机场': 'Port Macquarie Airport',
  '棉兰瓜拉纳穆国际机场': 'Medan Guaranamu International Airport',
  '米兰利纳特机场': 'Milan Linate Airport',
  '米兰马尔彭萨国际机场': 'Milan Malpensa International Airport',
  '马累机场': 'Male Airport',
  '马拉博国际机场': 'Malabo International Airport',
  '马拉加机场': 'Malaga Airport',
  '马六甲国际机场': 'Malacca International Airport',
  '梅纳拉机场': 'Menara Airport',
  '毛里求斯普莱桑斯国际机场': 'Mauritius Plessance International Airport',
  '罗伯茨国际机场': 'Roberts International Airport',
  '孟买贾特拉帕蒂· 希瓦吉国际机场': 'Mumbai Chhatrapati Shivaji International Airport',
  '明尼阿波利斯圣保罗机场': 'Minneapolis St. Paul Airport',
  '慕尼黑机场': 'Munich Airport',
  '马尼拉机场': 'Manila Airport',
  '马赛普罗旺斯机场': 'Marseille Provence Airport',
  '莫斯科谢诺梅杰沃机场': 'Moscow Shenomedevo Airport',
  '莫斯科伏努科沃机场': 'Moscow Vnukovo Airport',
  '明斯克机场': 'Minsk Airport',
  '马斯喀特机场': 'Muscat Airport',
  '芒特艾萨机场': 'Mount Isa Airport',
  '蒙特雷地区机场': 'Monterey Regional Airport',
  '蒙特利尔特鲁多国际机场': 'Montreal Trudeau International Airport',
  '蒙特雷机场': 'Monterey Airport',
  '墨西哥城国际机场': 'Mexico City International Airport',
  '梅州梅县机场': 'Meizhou Meixian Airport',
  '满洲里西郊机场': 'Manzhouli Xijiao Airport',
  '宁波栎社国际机场': 'Ningbo Lishe International Airport',
  '内比都国际机场': 'Naypyidaw International Airport',
  '那不勒斯国际机场': 'Naples International Airport',
  '南昌昌北国际机场': 'Nanchang Changbei International Airport',
  '纳迪机场': 'Nadi Airport',
  '努尔苏丹纳扎尔巴耶夫国际机场': 'Nursultan Nazarbayev International Airport',
  '那格浦尔索内格翁机场': 'Nagpur Sonegon Airport',
  '南京禄口国际机场': 'Nanjing Lukou International Airport',
  '努库阿洛法费阿阿莫国际机场': 'Nuku alofa amo International Airport',
  '纽卡斯尔威廉姆顿机场': 'Newcastle Williamton Airport',
  '纽卡斯尔机场': 'Newcastle Airport',
  '内罗毕乔莫· 肯雅塔机场': 'Nairobi Jomo Kenyatta Airport',
  '纽伦堡机场': 'Nuremberg Airport',
  '诺里奇机场': 'Norwich Airport',
  '南宁吴圩国际机场': 'Nanning Wuxu International Airport',
  '尼斯蓝色海岸机场': 'Nice C么te d Azur Airport',
  '纳什维尔国际机场': 'Nashville International Airport',
  '南通兴东国际机场': 'Nantong Xingdong International Airport',
  '努瓦克肖特机场': 'Nouakchott Airport',
  '纽约拉瓜迪机场': 'New York LaGuardia Airport',
  '纽约纽瓦克机场': 'New York Newark Airport',
  '纽约肯尼迪机场': 'New York JFK Airport',
  '哈马尼迪奥里国际机场': 'Hammaniori International Airport',
  '普洱思茅机场': 'Pu er Simao Airport',
  '普吉机场': 'Phuket Airport',
  '帕拉马里博国际机场': 'Paramaribo International Airport',
  '普罗瑟派恩机场': 'Protherpine Airport',
  '浦那机场': 'Pune Airport',
  '平壤顺安国际机场': 'Pyongyang Sunan International Airport',
  '珀斯机场': 'Perth Airport',
  '梅塞迪塔机场': 'Mesadita Airport',
  '浦项机场': 'Pohang Airport',
  '匹兹堡国际机场': 'Pittsburgh International Airport',
  '青岛胶东国际机场': 'Qingdao Jiaodong International Airport',
  '秦皇岛北戴河国际机场': 'Qinhuangdao Beidaihe International Airport',
  '黔江武陵山机场': 'Qianjiang Wulingshan Airport',
  '清莱国际机场': 'Chiang Rai International Airport',
  '乞力马扎罗国际机场': 'Kilimanjaro International Airport',
  '清迈国际机场': 'Chiang Mai International Airport',
  '庆阳机场': 'Qingyang Airport',
  '清州国际机场': 'Cheongju International Airport',
  '乔治王子城机场': 'Prince George Airport',
  '日喀则和平机场': 'Shigatse Peace Airport',
  '日内瓦机场': 'Geneva Airport',
  '若羌楼兰机场': 'Ruoqiang Loulan Airport',
  '荣市机场': 'Rongshi Airport',
  '日照山字河机场': 'Rizhao Shanzihe Airport',
  '塞班机场': 'Symbian Airport',
  '圣芭芭拉机场': 'Santa Barbara Airport',
  '圣彼得堡机场': 'St. Petersburg Airport',
  '斯波坎国际机场': 'Spokane International Airport',
  '圣保罗国际机场': 'Sao Paulo International Airport',
  '莎车机场': 'Shache Airport',
  '斯德哥尔摩阿兰达国际机场': 'Stockholm Arlanda International Airport',
  '圣地亚哥机场': 'San Diego Airport',
  '圣地亚哥（ 智利） 机场': 'Santiago (Chile) Airport',
  '金浦国际机场': 'Seoul Gimpo International Airport',
  '仁川机场': 'Seoul Incheon Airport',
  '仁川国际机场': 'Seoul Incheon Airport',
  '索非亚机场': 'Sofia Airport',
  '韶关丹霞机场': 'Shaoguan Danxia Airport',
  '萨格勒布机场': 'Zagreb Airport',
  '上海虹桥国际机场': 'Shanghai Hongqiao International Airport',
  '上海浦东国际机场': 'Shanghai Pudong International Airport',
  '路易斯姆诺兹马灵国际机场': 'Luis Mnoz Maling International Airport',
  '费尔南多路易斯里巴斯多米尼奇机场': 'Fernando Luis Ribas Dominic Airport',
  '圣何塞机场': 'San Jose Airport',
  '圣何塞安圣玛丽亚国际机场': 'San Jose An Santa Maria International Airport',
  '石河子花园机场': 'Shihezi Garden Airport',
  '沙迦国际机场': 'Sharjah International Airport',
  '石家庄正定国际机场': 'Shijiazhuang Zhengding International Airport',
  '萨克拉门托国际机场': 'Sacramento International Airport',
  '亨利洛尔森机场': 'Henry Lorson Airport',
  '斯利那加国际机场': 'Srinagar International Airport',
  '苏黎世机场': 'Zurich Airport',
  '兰伯特圣路易斯国际机场': 'Lambert St. Louis International Airport',
  '三明沙县机场': 'Sanmingsha County Airport',
  '厦门高崎国际机场': 'Xiamen Gaoqi International Airport',
  '苏梅岛机场': 'Koh Samui Airport',
  '萨那机场': 'Sana a Airport',
  '神农架红坪机场': 'Shennongjia Hongping Airport',
  '上饶三清山机场': 'Shangrao Sanqingshan Airport',
  '松山机场': 'Songshan Airport',
  '泗水机场': 'Surabaya Airport',
  '斯图加特机场': 'Stuttgart Airport',
  '斯特拉斯堡机场': 'Strasbourg Airport',
  '塞里尔金机场': 'Serilkin Airport',
  '马克坦国际机场': 'Maktan International Airport',
  '沈阳桃仙国际机场': 'Shenyang Taoxian International Airport',
  '三亚凤凰国际机场': 'Sanya Phoenix International Airport',
  '邵阳武冈机场': 'Shaoyang Wugang Airport',
  '松原查干湖机场': 'Songyuan Chagan Lake Airport',
  '廷布机场': 'Thimphu Airport',
  '腾冲驼峰机场': 'Tengchong Hump Airport',
  '通化三源浦机场': 'Tonghua Sanyuanpu Airport',
  '天津滨海国际机场': 'Tianjin Binhai International Airport',
  '塔林伦纳特· 梅里塔林机场': 'Tallinn Lennart Meritarin Airport',
  '吐鲁番交河机场': 'Turpan Jiaohe Airport',
  '特里凡得琅国际机场': 'Trivandrum International Airport',
  '本古里安国际机场': 'Ben Gurion International Airport',
  '布拉格纳克机场': 'Pragnac Airport',
  '图木舒克唐王城机场': 'Tumushuk Tang Wangcheng Airport',
  '塔那那利佛伊瓦图国际机场': 'Antananarivo Ivatu International Airport',
  '突尼斯机场': 'Tunis Airport',
  '坦帕机场': 'Tampa Airport',
  '铜仁凤凰机场': 'Tongren Phoenix Airport',
  '天水麦积山机场': 'Tianshui Maijishan Airport',
  '唐山三女河机场': 'Tangshan Sannuhe Airport',
  '塔什干机场': 'Tashkent Airport',
  '塔什库尔干红其拉甫机场': 'Tashkorgan Khunchirav Airport',
  '汤斯维尔机场': 'Townsville Airport',
  '太原武宿国际机场': 'Taiyuan Wusu International Airport',
  '台州路桥机场': 'Taizhou Luqiao Airport',
  '乌代布尔机场': 'Udaipur Airport',
  '霍齐亚· 库塔科国际机场': 'Hosea Kutako International Airport',
  '五大连池德都机场': 'Wudalianchi Dedu Airport',
  '维尔纽斯机场': 'Vilnius Airport',
  '温哥华机场': 'Vancouver Airport',
  '威海大水泊国际机场': 'Weihai Dashuibo International Airport',
  '芜湖宣州机场': 'Wuhu Xuanzhou Airport',
  '武汉天河国际机场': 'Wuhan Tianhe International Airport',
  '瓦加杜古国际机场': 'Ouagadougou International Airport',
  '乌兰察布机场': 'Ulanqab Airport',
  '乌兰浩特机场': 'Ulanhot Airport',
  '乌鲁木齐地窝堡国际机场': 'Urumqi Diwopu International Airport',
  '瓦拉纳西机场': 'Varanasi Airport',
  '温尼伯国际机场': 'Winnipeg International Airport',
  '威尼斯机场': 'Venice Airport',
  '乌戎潘当苏丹哈桑丁机场': 'Ujung Pandang Sultan Hassandin Airport',
  '重庆巫山机场': 'Chongqing Wushan Airport',
  '渥太华机场': 'Ottawa Airport',
  '万象瓦岱机场': 'Vientiane Wattay Airport',
  '无锡苏南硕放国际机场': 'Wuxi Sunan Shuofang International Airport',
  '万鸦老美娜多机场': 'Manado Lao Menado Airport',
  '维也纳机场': 'Vienna Airport',
  '温州龙湾国际机场': 'Wenzhou Longwan International Airport',
  '西安咸阳国际机场': 'Xi an Xianyang International Airport',
  '新奥尔良机场': 'New Orleans Airport',
  '奥斯马尼国际机场': 'Osmani International Airport',
  '岘港国际机场': 'Da Nang International Airport',
  '夏河机场': 'Xiahe Airport',
  '新加坡樟宜机场': 'Singapore Changi Airport',
  '暹粒吴哥机场': 'Siem Reap Angkor Airport',
  '夏洛特道格拉斯国际机场': 'Charlotte Douglas International Airport',
  '悉尼金斯福德· 史密斯机场': 'Sydney Kingsford Smith Airport',
  '小松机场': 'Komatsu Airport',
  '西双版纳嘎洒国际机场': 'Xishuangbanna Gasa International Airport',
  '休斯顿霍比机场': 'Houston Hobby Airport',
  '乔治· 布什洲际机场': 'George Bush Intercontinental Airport',
  '仙台机场': 'Sendai Airport',
  '新潟机场': 'Niigata Airport',
  '新西伯利亚机场': 'Novosibirsk Airport',
  '辛辛那提 - 北肯塔基国际机场': 'Cincinnati-Northern Kentucky International Airport',
  '兴义万峰林机场': 'Xingyi Wanfenglin Airport',
  '信阳明港机场': 'Xinyang Minggang Airport',
  '襄阳刘集机场': 'Xiangyang Liuji Airport',
  '西雅图机场': 'Seattle Airport',
  '忻州五台山机场': 'Xinzhou Wutaishan Airport',
  '徐州观音国际机场': 'Xuzhou Guanyin International Airport',
  '延安南泥湾机场': 'Yan an Nanniwan Airport',
  '宜宾五粮液机场': 'Yibin Wuliangye Airport',
  '银川河东国际机场': 'Yinchuan Hedong International Airport',
  '宜春明月山机场': 'Yichun Mingyueshan Airport',
  '雅典国际机场': 'Athens International Airport',
  '印第安纳波利斯国际机场': 'Indianapolis International Airport',
  '亚的斯亚贝巴博莱国际机场': 'Addis Ababa Bole International Airport',
  '伊尔库茨克国际机场': 'Irkutsk International Airport',
  '仰光国际机场': 'Yangon International Airport',
  '盐湖城国际机场': 'Salt Lake City International Airport',
  '约翰内斯堡奥利弗· 雷金纳德· 坦博国际机场': 'Johannesburg Oliver Reginald Tambo International Airport',
  '延吉朝阳川国际机场': 'Yanji Chaoyangchuan International Airport',
  '雅加达苏加诺 - 哈达国际机场': 'Jakarta Soekarno-Hatta International Airport',
  '营口兰旗机场': 'Yingkou Lanqi Airport',
  '榆林榆阳机场': 'Yulin Yuyang Airport',
  '玉林福绵机场': 'Yulin Fumian Airport',
  '玉树巴塘机场': 'Yushu Batang Airport',
  '伊斯兰堡国际机场': 'Islamabad International Airport',
  '伊斯坦布尔机场': 'Istanbul Airport',
  '烟台蓬莱国际机场': 'Yantai Penglai International Airport',
  '于田万方机场': 'Yutian Wanfang Airport',
  '亚特兰大哈兹菲尔德 - 杰克逊国际机场': 'Atlanta Hartsfield-Jackson International Airport',
  '希马伦国际机场': 'Himalon International Airport',
  '岳阳三荷机场': 'Yueyang Sanhe Airport',
  '金兰国际机场': 'Cam Ranh International Airport',
  '扬州泰州国际机场': 'Yangzhou Taizhou International Airport',
  '伊兹密尔机场': 'Izmir Airport',
  '朱巴国际机场': 'Juba International Airport',
  '长春龙嘉国际机场': 'Changchun Longjia International Airport',
  '中国澳门国际机场': 'Macau International Airport, China',
  '中国高雄国际机场': 'China Kaohsiung International Airport',
  '中国金门尚义机场': 'China Kinmen Shangyi Airport',
  '中国台北松山机场': 'Chinese Taipei Songshan Airport',
  '中国台北桃园国际机场': 'Chinese Taipei Taoyuan International Airport',
  '台南机场': 'Tainan Airport',
  '中国台中清泉岗机场': 'Taichung, China Qingquangang Airport',
  '香港国际机场': 'Hong Kong International Airport, China',
  '札幌新千岁机场': 'Sapporo New Chitose Airport',
  '珠海金湾机场': 'Zhuhai Jinwan Airport',
  '湛江吴川机场': 'Zhanjiang Wuchuan Airport',
  '芝加哥米德威机场': 'Chicago Midway Airport',
  '芝加哥奥黑尔机场': 'Chicago O Hare Airport',
  '张家界荷花机场': 'Zhangjiajie Hehua Airport',
  '张家口宁远机场': 'Zhangjiakou Ningyuan Airport',
  '扎兰屯成吉思汗机场': 'Zhalantun Genghis Khan Airport',
  '斋浦尔国际机场': 'Jaipur International Airport',
  '重庆江北国际机场': 'Chongqing Jiangbei International Airport',
  '重庆武隆区仙女山机场': 'Fairy Mountain Airport, Wulong District, Chongqing',
  '长崎机场': 'Nagasaki Airport',
  '长沙黄花国际机场': 'Changsha Huanghua International Airport',
  '舟山普陀山机场': 'Zhoushan Putuoshan Airport',
  '昭苏天马机场': 'Zhaosu Tianma Airport',
  '中卫沙坡头机场': 'Zhongwei Shapotou Airport',
  '张掖甘州机场': 'Zhangye Ganzhou Airport',
  '遵义茅台机场': 'Zunyi Moutai Airport',
  '遵义新舟国际机场': 'Zunyi Xinzhou International Airport',
  '郑州新郑国际机场': 'Zhengzhou Xinzheng International Airport',
  '上海航空': 'Shanghai Airlines',
  '新西兰航空': 'Air New Zealand',
  '运营出票单查询': 'Ticketing',
  '运营退票单查询': 'Refund',
  '采购退票单查询': 'Refund',
  '供应退票单查询': 'Refund',
  '运营改签单查询': 'Exchange',
  '采购改签单查询': 'Exchange',
  '供应改签单查询': 'Exchange',
  '退票完成': 'Completed',
  '退票中': 'Processing ticket refund',
  '退票失败': 'Failed',
  '退票申请': 'Ticket refund application',
  '特殊': 'Special',
  '自愿': 'Voluntary',
  '非自愿': 'Involuntary',
  '航变': 'Flight Change',
  '病退': 'Retired from illness',
  '备降': 'Replacement',
  '重构全退': 'Refactoring full refund',
  '拒载': 'Reject',
  '超售': 'Oversold',
  '疫情': 'Epidemic',
  '特殊事件': 'Special event',
  '拒签': 'Visa refusal',
  '形式全退': 'Formal full refund',
  '废票': 'Void ticket‌',
  '降舱': 'Cabin downgrade',
  '病改': 'Apply for change due to illness',
  '孕改': 'Apply for change due to pregnancy',
  '其他': 'Other',
  '其它': 'Other',
  '改签完成': 'Completed',
  '改签失败': 'Failed',
  '改签选择航班': 'Change Select Flight',
  '新增政策': 'New Policy',
  '政策修改': 'Policy Modify',
  '身份证': 'ID card',
  '护照': 'Passport',
  '军官证': 'Officer certificate of the Chinese people’s Liberation Army',
  '回乡证': 'Mainland Travel Permit for Hong Kong and Macao Residents',
  '港澳通行证': 'Exit-Entry Permit for Travelling to and from Hong Kong and Macao',
  '台湾通行证': 'Taiwan Travel Permit for Mainland Residents',
  '台胞证': 'Mainland Travel Permit for Taiwan Residents',
  '士兵证': 'Chinese people’s Liberation Army soldier card',
  '警官证': 'Police officer certificate',
  'go trip': 'Depart',
  'depart': 'Depart',
  'return': 'Return',
  'return trip': 'Return',
  '默认岗位': 'Default',
  '改姓名或称谓': 'Name or title change',
  '提现记录': 'Withdrawal Record',
  rolemanage: {
    'Permission Control': 'Permission',
    'Add Role': 'Add Role',
    'Modify role': 'Modify role',
    'Specify user role': 'Specify user role',
    'User to be specified': 'User to be specified',
    'Selected Designated User': 'Selected Designated User',
    'Permission': 'Permission',
    'Please enter a role name': 'Please enter a role name',
    'Role management': 'Role management',
    '-Half selected': '-Half selected',
    'Modify permission successfully': 'Modify permission successfully',
    'New Character Success': 'New Character Success',
    'Assigned role success': 'Assigned role success'
  },
  shortmsglist: {
    'Ticket SMS': 'Ticket SMS',
    'Change SMS': 'Change SMS',
    'Refund SMS': 'Refund SMS',
    'Airchange SMS (including delay, cancellation, resumption)': 'Airchange SMS (including delay, cancellation, resumption)',
    'Service SMS': 'Service SMS',
    'Receive number': 'Receive number',
    'Send number': 'Send number',
    'Content': 'Content',
    'Time': 'Time',
    'The difference between the start date and the end date cannot be greater than 365 days': 'The difference between the start date and the end date cannot be greater than 365 days'
  },
  systemlog: {
    'HR file': 'HR file',
    'Deactivated': 'Deactivated',
    'Real name': 'Login Name',
    'Date': 'Date'
  },
  systemsetting: {
    'Setup name': 'Setup name',
    'Set content': 'Set content',
    'Modification time': 'Modification time',
    'Modifier': 'Modifier',
    'New system settings': 'New system settings',
    'Please select a setting name': 'Please select a setting name',
    'Please fill in the settings': 'Please fill in the settings',
    'Edit system settings': 'Edit system settings',
    'Added system settings successfully': 'Added system settings successfully',
    'Modified successfully': 'Modified successfully',
    'Delete system settings successfully': 'Delete system settings successfully',
    'System settings not found': 'System settings not found',
    'The difference between the start date and the end date cannot be greater than 31 days': 'The difference between the start date and the end date cannot be greater than 31 days'
  },
  orderdetail: {
    'Rescheduled Upgrade': 'Rescheduled Upgrade',
    'Loading desperately': 'Loading desperately...',
    'Ticket Details': 'Ticket Details',
    'Payment address': 'Payment address',
    'Are you sure to issue a ticket?': 'Are you sure to issue a ticket?',
    'Ticketing': 'Ticketing',
    'Booking Express Instructions': 'Booking Express Instructions',
    'Aviation monitoring': 'Aviation monitoring',
    'Ticket swipe': 'Ticket swipe',
    'Cancel Order': 'Cancel Order',
    'Convert to Appeal Form': 'Convert to Appeal Form',
    'Exception entry': 'Exception entry',
    'Refund form entry': 'Refund form entry',
    'Early pick-up': 'Early pick-up',
    'Unlock and close': 'Unlock and close',
    'Process and lock': 'Process and lock',
    'Close': 'Close',
    'Order information': 'Order Information',
    'Store name': 'Store name',
    'Platform ticket number': 'Platform ticket number',
    'Platform change order number': 'Platform change order number',
    'Platform refund order number': 'Platform refund order number',
    'Exception order number': 'Exception order number',
    'Appeal number': 'Appeal number',
    'Downloadable': 'Downloadable',
    'No downgrade': 'No downgrade',
    'Order sub-status': 'Order sub-status',
    'Fill failed': 'Fill failed',
    'Unticketed Refund Purchased': 'Unticketed Refund Purchased',
    'Reimbursement Type': 'Reimbursement Type',
    'Price reduction': 'Price reduction',
    'Price can be reduced': 'Price can be reduced',
    'No price reduction': 'No price reduction',
    'Latest ticket issuance time': 'Latest ticket issuance time',
    'Total Fare': 'Total Fare',
    'Total selling price': 'Total selling price',
    'Total Sales Price': 'Total Sales Price',
    'Total Tax': 'Total Tax',
    'Total machine cost': 'Total machine cost',
    'Total fuel cost': 'Total fuel cost',
    'Airport Construction Fee': 'Airport Construction Fee',
    'Fuel Surcharge': 'Fuel Surcharge',
    'Ticketing time': 'Ticketing Time',
    'ticketing time': 'Ticketing time',
    'Account verification time': 'Account verification time',
    'Mailing Itinerary': 'Mailing Itinerary',
    'Ticket Notes': 'Ticket Notes',
    'Return and change instructions': 'Return and change instructions',
    'Epidemics cannot enter': 'Epidemics cannot enter',
    'Untrustworthy': 'Untrustworthy',
    'No same cabin for external release': 'No same cabin for external release',
    'Enter the single upgrade': 'Enter the single upgrade',
    'Ticket reservation upgrade': 'Ticket reservation upgrade',
    'The freight does not match': 'The freight does not match',
    'Policy loss': 'Policy loss',
    'Flight Cancellation': 'Flight Cancellation',
    'Quick save': 'Quick save',
    'Flight date': 'Flight date',
    'Itinerary': 'Itinerary',
    'Flight number': 'Flight number',
    'Class': 'Class',
    'KN registration certification': 'KN registration certification',
    'Total sales price': 'Total sales price',
    'Purchase Amount': 'Purchase Amount',
    'Please enter the purchase amount': 'Please enter the purchase amount',
    'Please enter PNR': 'Please enter PNR',
    'Please enter large code': 'Please enter large code',
    'Ticket number format': 'Ticket number format',
    'Please enter ticket number': 'Please enter ticket number',
    'Ticket number verification': 'Ticket number verification',
    'Please enter profit': 'Please enter profit',
    'Are you sure to re-occupy the seat?': 'Are you sure to re-occupy the seat?',
    'Re-occupy the seat': 'Re-occupy the seat',
    'Are you sure to pay again?': 'Are you sure to pay again?',
    'Re-pay': 'Re-pay',
    'Are you sure about the booking code?': 'Are you sure about the booking code?',
    'Booking Code': 'Booking Code',
    'Out-of-pocket tickets': 'Out-of-pocket tickets',
    'Save Ticket': 'Save Ticket',
    'Unlock and deal with': 'Unlock and deal with',
    'Ticket purchase record': 'Ticket purchase record',
    'Expenditure': 'Expenditure',
    'Income': 'Income',
    'Passenger': 'Passenger',
    'Purchase channel': 'Purchase channel',
    'Payment Channel': 'Payment Channel',
    'Purchase Order Number': 'Purchase Order Number',
    'Procurement space': 'Procurement space',
    'Purchase Remarks': 'Purchase Remarks',
    'Agency Fee': 'Agency Fee',
    'Agency Rate': 'Agency Rate',
    'Please select the procurement channel': 'Please select the procurement channel',
    'Purchase Type': 'Purchase Type',
    'Please select type': 'Please select type',
    'Offer Type/Offer Logo': 'Offer Type/Offer Logo',
    'Stored Value Card': 'Stored Value Card',
    'Points': 'Points',
    'Agency Fee/Agency Fee': 'Agency Fee/Agency Fee',
    'New purchase record': 'New purchase record',
    'Keep Purchase Records': 'Keep Purchase Records',
    'Contact Phone': 'Contact Phone',
    'Account verification information': 'Account verification information',
    'Platform collection and verification amount': 'Platform collection and verification amount',
    'Platform collection and verification time': 'Platform collection and verification time',
    'Save the platform collection and verification information': 'Save the platform collection and verification information',
    'Purchase payment verification amount': 'Purchase payment verification amount',
    'Purchase Payment Billing Time': 'Purchase Payment Billing Time',
    'Save the purchase payment verification information': 'Save the purchase payment verification information',
    'Refund information': 'Refund information',
    'Please select purchase status': 'Please select purchase status',
    'Pending payment': 'Pending payment',
    'Payment in progress': 'Payment in progress',
    'Edit Purchase Record': 'Edit Purchase Record',
    'Purchase Fare': 'Purchase Fare',
    'Edit Order Remarks': 'Edit Order Remarks',
    'Shared flight': 'Shared flight',
    'Main flight': 'Main flight',
    'Childrens Booking Instructions': "Children's Booking Instructions",
    'One-click AV': 'One-click AV',
    'Product Details': 'Product Details',
    'Edit Product': 'Edit Product',
    'Product name': 'Product name',
    'NFD': 'NFD',
    'Clearance Products': 'Clearance Products',
    'Business travel products': 'Business travel products',
    'Transit': 'Transit',
    'Transit product': 'Transit product',
    'Charter': 'Charter',
    'Cut position': 'Cut position',
    'Airline VIP': 'Airline VIP',
    'General Policy': 'General Policy',
    'Prepayment Policy': 'Prepayment Policy',
    'Team Policy': 'Team Policy',
    'Special Offer Policy': 'Special Offer Policy',
    'K-bit policy': 'K-bit policy',
    'Fixed price': 'Fixed price',
    'Applicable class': 'Applicable class',
    'Sales Type': 'Sales Type',
    'Direct connection': 'Direct connection',
    'Fixed cabin': 'Fixed cabin',
    'See cabin': 'See cabin',
    'Policy Code Format': 'Policy Code Format',
    'Additional airline code': 'Additional airline code',
    'Additional delivery timetime and time': 'Additional delivery time (time and time)',
    'Delivery Type': 'Delivery Type',
    'Total + increment': 'Total + increment',
    'Full amount only': 'Full amount only',
    'Increment only': 'Increment only',
    'Delete policy on increment': 'Delete policy on increment',
    'Delete type': 'Delete type',
    'By Policy Code': 'By Policy Code',
    'By delivery time': 'By delivery time',
    'itinerary': 'Itinerary',
    'Invoice': 'Invoice',
    'Itinerary + difference invoice': 'Itinerary + difference invoice',
    'office number': 'office number',
    'IATA number': 'IATA number',
    'Drop the upper class': 'Drop the upper class',
    'Reservation': 'Reservation',
    'PAT': 'PAT',
    'Organic Wine Package': 'Organic Wine Package',
    'Support stop': 'Support stop',
    'Support children': 'Support children',
    'Tariff rules': 'Tariff rules',
    'Return and change ID': 'Return and change ID',
    'Placing Fare': 'Placing Fare',
    'Price Type': 'Price Type',
    'Official website price': 'Official website price',
    'Settlement price': 'Settlement price',
    'Specified Fare': 'Specified Fare',
    'Y cabin discount': 'Y cabin discount',
    'Special Ticket Instructions': 'Special Ticket Instructions',
    'Minimum age limit': 'Minimum age limit',
    'Maximum age limit': 'Maximum age limit',
    'Airline': 'Airline',
    'Departure airport code': 'Departure airport code',
    'Arrival airport code': 'Arrival airport code',
    'Adult cabin': 'Adult cabin',
    'Childrens Class': "Children's Class",
    'Select flight date': 'Select flight date',
    'Select departure time': 'Select departure time',
    'Select arrival time': 'Select arrival time',
    'Get payment address': 'Get payment address',
    'Purchase status': 'Purchase status',
    'Go to pay': 'Go to pay',
    'Ticket swiping rules': 'Ticket swiping rules',
    'Ticket swiping frequency': 'Ticket swiping frequency',
    'Ticket source': 'Ticket source',
    'Official website': 'Official website',
    'Ticket swiping channel': 'Ticket swiping channel',
    'Whether to account for': 'Whether to account for',
    'Brushing class': 'Brushing class',
    'Monitor the superior class': 'Monitor the superior class',
    'Superior class number reminder': 'Superior class number reminder',
    'Deadline for swiping tickets': 'Deadline for swiping tickets',
    'Select datetime': 'Select datetime',
    'Appeal Type': 'Appeal Type',
    'Platform Refund': 'Platform Refund',
    'Quality inspection': 'Quality inspection',
    'Our appeal': 'Our appeal',
    'Appeal amount': 'Appeal amount',
    'Appeal Remarks': 'Appeal Remarks',
    'reason': 'reason',
    'Ticketing channel': 'Ticketing channel',
    'Ticketing office': 'Ticketing office',
    'Lowest cabin': 'Lowest cabin',
    'No coupons': 'No coupons',
    'Coupons are useful or not': 'Coupons are useful or not',
    'Age': 'Age',
    'Invoicing': 'Invoicing',
    'Single settlement price': 'Single settlement price',
    'Ticketing gross profit': 'Ticketing gross profit',
    'Cashback + Cashback': 'Cashback + Cashback',
    'Rebate': 'Rebate',
    'Cash back': 'Cash back',
    'Par/Class': 'Par/Class',
    'Adult': 'Adult',
    'Offer': 'Offer',
    'Order and pay': 'Order and pay',
    'WONIU': 'WONIU',
    'Select Flight Person': 'Select Flight Person',
    'Verification Channel': 'Verification Channel',
    'Where to go': 'Where to go',
    'Ticket number status': 'Ticket number status',
    'Fare price': 'Fare price',
    'Modify ticket number': 'Modify ticket number',
    'Purchasing channel cannot be empty': 'Purchasing channel cannot be empty',
    'Purchase order number cannot be empty': 'Purchase order number cannot be empty',
    'The transaction serial number cannot be empty': 'The transaction serial number cannot be empty',
    'Payment amount cannot be empty': 'Payment amount cannot be empty',
    'The preferential amount cannot be empty, it can be 0': 'The preferential amount cannot be empty, it can be 0',
    'Airline cannot be empty': 'Airline cannot be empty',
    'Departure airport code cannot be empty': 'Departure airport code cannot be empty',
    'Arrival airport code cannot be empty ': 'Arrival airport code cannot be empty ',
    'Flight number cannot be empty': 'Flight number cannot be empty',
    'Adult cabin cannot be empty': 'Adult cabin cannot be empty',
    'Childrens cabin cannot be empty': "Children's cabin cannot be empty'",
    'Please select a flight date': 'Please select a flight date',
    'Please select departure time': 'Please select departure time',
    'Please select arrival time': 'Please select arrival time',
    'Please select the reason for cancellation': 'Please select the reason for cancellation',
    'Please select the frequency of swiping tickets': 'Please select the frequency of swiping tickets',
    'Please select the brush ticket source': 'Please select the brush ticket source',
    'Please select the ticket swiping channel': 'Please select the ticket swiping channel',
    'Please select whether to account for': 'Please select whether to account for',
    'Please enter the swiping class': 'Please enter the swiping class',
    'Please enter the monitoring superior class': 'Please enter the monitoring superior class',
    'Please enter the superior class number reminder': 'Please enter the superior class number reminder',
    'Please select the deadline for swiping tickets': 'Please select the deadline for swiping tickets',
    'Please enter the order remarks': 'Please enter the order remarks',
    'Please select the appeal type': 'Please select the appeal type',
    'Please fill in the appeal amount': 'Please fill in the appeal amount',
    'The specified class code cannot be empty': 'The specified class code cannot be empty',
    'Ticket number cannot be empty': 'Ticket number cannot be empty',
    'Easy to travel': 'Easy to travel',
    'No Data': 'No Data',
    'Flight Butler': 'Flight Butler',
    'Snail': 'Snail',
    'Return to the ticket list and try again after refreshing according to F5': 'Return to the ticket list and try again after refreshing according to F5',
    'Please enter the platform collection and verification amount': 'Please enter the platform collection and verification amount',
    'Please enter the platform collection and verification time': 'Please enter the platform collection and verification time',
    'Save the platform collection and verification successfully': 'Save the platform collection and verification successfully',
    'Failed to save the platform collection and verification account Reason:': 'Failed to save the platform collection and verification account Reason:',
    'Please enter the purchase payment verification amount': 'Please enter the purchase payment verification amount',
    'Please enter the purchase payment billing time': 'Please enter the purchase payment billing time',
    'Save the purchase payment verification successfully': 'Save the purchase payment verification successfully',
    'Failed to save the purchase payment verification account, Reason:': 'Failed to save the purchase payment verification account, Reason:',
    'Delete the platform collection and verification successfully': 'Delete the platform collection and verification successfully',
    'Delete the platform collection and verification failed. Reason:': 'Delete the platform collection and verification failed. Reason:',
    'Delete the purchase payment verification successfully': 'Delete the purchase payment verification successfully',
    'Delete the purchase payment verification failed, reason:': 'Delete the purchase payment verification failed, reason:',
    'REFUNDED Refunded': 'REFUNDED Refunded',
    'VOID voided': 'VOID voided',
    'SUSPENDED Suspended': 'SUSPENDED Suspended',
    'CHECKED IN checked in': 'CHECKED IN checked in',
    'LIFT/BOARDED has left port': 'LIFT/BOARDED has left port',
    'USED/FLOWN Used': 'USED/FLOWN Used',
    'OPENFORUSE': 'OPEN FOR USE',
    'Success~': 'Success~',
    'Modify the segment information successfully': 'Modify the segment information successfully',
    'Please enter the correct number': 'Please enter the correct number',
    'The current limit selects 9 files, this time it is selected': 'The current limit selects 9 files, this time it is selected',
    'Files selected in total': 'Files selected in total',
    'Converted to appeal form successfully': 'Converted to appeal form successfully',
    'Refund order number': 'Refund order number',
    'Successful early seat pick-up': 'Successful early seat pick-up',
    'Failed to take place early, reason:': 'Failed to take place early, reason:',
    'Failed to cancel the order, reason:': 'Failed to cancel the order, reason:',
    'Modify the remarks successfully': 'Modify the remarks successfully',
    'Senior Special': 'Senior Special',
    'The order does not exist click OK to close the label': 'The order does not exist, click OK to close the label.',
    'Payment channel cannot be empty': 'Payment channel cannot be empty',
    'Type cannot be empty': 'Type cannot be empty',
    'Purchase account cannot be empty': 'Purchase account cannot be empty',
    'Purchase password cannot be empty': 'Purchase password cannot be empty',
    'New purchase record successful': 'New purchase record successful',
    'Modify the purchase record successfully!': 'Modify the purchase record successfully!',
    'Delete the purchase record successfully': 'Delete the purchase record successfully',
    'The new ticket swiping order was successful': 'The new ticket swiping order was successful',
    'Are you sure to close the current page?': 'Are you sure to close the current page?',
    'Are you sure to unlock and close?': 'Are you sure to unlock and close?',
    'Unlocked and processed successfully': 'Unlocked and processed successfully',
    'Baby': 'Baby',
    'ID card': 'ID card',
    'Passport': 'Passport',
    'Product information is empty': 'Product information is empty',
    'Please fill in the passenger ticket number and try again': 'Please fill in the passenger ticket number and try again',
    'Incorrect ticket number': 'Incorrect ticket number',
    'Please fill in the passenger PNR and try again': 'Please fill in the passenger PNR and try again',
    'PNR is incorrect': 'PNR is incorrect',
    'Big encoding incorrect': 'Big encoding incorrect',
    'Purchase amount must be greater than 0': 'Purchase amount must be greater than 0',
    'Please enter': 'Please enter',
    'Successful ticket issuance!': 'Successful ticket issuance!',
    'The ticket has been issued': 'The ticket has been issued',
    'There is already a successful purchase record and the seat cannot be re-occupied. Please use ticketing to reset': 'There is already a successful purchase record and the seat cannot be re-occupied. Please use ticketing to reset',
    'Resumption Success': 'Resumption Success',
    'Ticket reset successful': 'Ticket reset successful',
    'Create an order and pay successfully, wait for asynchronous ticket issuance': 'Create an order and pay successfully, wait for asynchronous ticket issuance',
    'Ordinary standard': 'Ordinary standard',
    'Preferred': 'Preferred',
    'special Offer': 'Special Offer',
    'Special Products': 'Special Products',
    'Youth and Senior Special': 'Youth and Senior Special',
    'Multiplayer Offer': 'Multiplayer Offer',
    'Travel worry-free': 'Travel worry-free',
    'pa airline direct sales': 'pa airline direct sales',
    'pb standard official website': 'pb standard official website',
    'pd housekeeper self-operated': 'pd housekeeper self-operated',
    'PE Agent Standard': 'PE Agent Standard',
    'pj charter cut': 'pj charter cut',
    'PC official website special offer': 'PC official website special offer',
    'Ph Standard Special': 'Ph Standard Special',
    'pf agent special offer': 'pf agent special offer',
    'Py special low price': 'Py special low price',
    'pw shares the main flight': 'pw shares the main flight',
    'Official website this policy requires the passengers own mobile phone number': "Official website (this policy requires the passenger's own mobile phone number)",
    'Other': 'Other',
    'Not provided': 'Not provided',
    'Booking code successful': 'Booking code successful',
    'PNR cannot be empty': 'PNR cannot be empty',
    'Save the ticket successfully!': 'Save the ticket successfully!',
    'Unable to jump to the payment page, the payment address is empty!': 'Unable to jump to the payment page, the payment address is empty!',
    'The payment address is in the wrong format, please try again!': 'The payment address is in the wrong format, please try again!',
    'Was the payment successful?': 'Was the payment successful?',
    'Payment result': 'Payment result',
    'Payment successful': 'Payment successful',
    'International students': 'International students',
    'Date of Birth': 'Date of Birth',
    'Main fly': 'Main fly',
    'Stop': 'Stop',
    'First Class': 'First Class',
    'Business Cabin': 'Business Cabin',
    'walletPay': 'Wallet',
    'Alipay payment': 'Alipay payment',
    'Online Banking Payment': 'Online Banking Payment',
    'Credit Card Payment': 'Credit Card Payment',
    'Total order price': 'Total order price:',
    'Available Balance': 'Available Balance:',
    'The Deposit funds is insufficient please recharge': 'The balance of this wallet is insufficient',
    'Payment password': 'Payment password:',
    'Confirm payment': 'Confirm payment',
    'Are you sure you want to pay?': 'Are you sure you want to pay?',
    'Paying': 'Paying...',
    'Contact person': 'Contact person',
    'Passenger Name': 'Passenger Name',
    'Order total': 'Order Total',
    'Contact Information': 'Contact Information',
    'Reason': 'Reason'
  },
  organizationalStructure: {
    'Affiliated organization': 'Affiliated organization',
    'Please enter department name': 'Please enter department name',
    'Superior department': 'Superior department',
    'Please select the superior department': 'Please select the superior department',
    'Note': 'Note',
    'Please enter a note': 'Please enter a note',
    'Department Number': 'Department Number',
    'Please enter department number': 'Please enter department number',
    'By department': 'By department',
    'Department Management': 'Department Management',
    'Select Department': 'Select Department',
    'This action will permanently delete departments(': 'This action will permanently delete departments(',
    '), whether to continue ?': '), whether to continue ?',
    'Deleted successfully!': 'Deleted successfully!',
    'Delete failed!': 'Delete failed!',
    'The highest level department cannot be deleted!': 'The highest level department cannot be deleted!',
    'Please select the department to delete!': 'Please select the department to delete!',
    'Please fill in the department name': 'Please fill in the department name',
    'The new/modified department was successful!': 'The new/modified department was successful!',
    'Failed to add/modify department (': 'Failed to add/modify department (',
    '), please try again later !': '), please try again later !',
    'Department position': 'Department position',
    'Department Deputy': 'Department Deputy',
    'Department Secretary': 'Department Secretary',
    'Department data initialization failed, please try again later': 'Department data initialization failed, please try again later',
    'Data initialization failed, please try again later': 'Data initialization failed, please try again later'
  },
  generalManager: {
    'Description': 'Description',
    'Please fill in the job title': 'Please fill in the job title',
    'Up to 50 characters in length': 'Up to 50 characters in length',
    'Confirm deletion of selected posts?': 'Confirm deletion of selected posts?',
    'Operation successful': 'Operation successful'
  },
  announcementManage: {
    'Please fill in the title': 'Please fill in the title',
    'Sender': 'Sender',
    'New announcement ': 'New announcement ',
    'Please fill in the sender': 'Please fill in the sender',
    'Content': 'Content ',
    'Select file': 'Select file',
    'Only xlsx files can be uploaded, and each file does not exceed 20M ': 'Only .xlsx files can be uploaded, and each file does not exceed 20M ',
    'Please fill in the content': 'Please fill in the content',
    'Announcement released successfully': 'Announcement released successfully',
    'Delete announcement successful': 'Delete announcement successful'
  },
  menu: {
    'Parent menu': 'Parent menu',
    'Menu name': 'Name',
    'Menu state': 'Menu state',
    'Menu Level ': 'Level',
    'Level One': 'Level One',
    'Level Two': 'Level Two',
    'Level three ': 'Level three ',
    'Level Four': 'Level Four',
    'Menu type': 'Menu type',
    'Operations': 'Operations',
    'Supplier ': 'Supplier ',
    'Buyer': 'Buyer ',
    'Account Type': 'Account Type',
    'Menu level': 'Menu level',
    'Node link': 'Node link',
    'Menu order': 'Menu order',
    'Menu icon': 'Icon',
    'Button ID': 'Button ID',
    'Please select account type': 'Please select account type',
    'Administrator': 'Administrator ',
    'Please select menu level': 'Please select menu level',
    'Superior menu': 'Superior menu',
    'Please select the superior menu': 'Please select the superior menu',
    'New menu': 'New menu',
    'Please fill in the menu name': 'Please fill in the menu name',
    'Please fill in the menu order': 'Please fill in the menu order',
    'Node link cannot be empty, no connection can be filled in\\': 'Node link cannot be empty, no connection can be filled in\\',
    'Edit menu': 'Edit menu',
    'New menu successful': 'New menu successful',
    'Modified menu successfully': 'Modified menu successfully',
    'Level 1': 'Level 1',
    'Level 2': 'Level 2',
    'Level 3': 'Level 3',
    'Level 4': 'Level 4',
    'Level 5': 'Level 5',
    'Deleted menu successfully': 'Deleted menu successfully',
    'Please select': 'Please select'
  },
  dict: {
    'Encoding': 'Encoding',
    'Dictionary name': 'Dictionary name',
    'Open': 'Open',
    'Close': 'Close ',
    'Description': 'Description',
    'Dictionary configuration': 'Dictionary configuration',
    'Configure': 'Configure',
    'Dictionary list': 'Dictionary list',
    'Data name': 'Data name',
    'Data value': 'Data value',
    'Sort': 'Sort ',
    'Edit dictionary': 'Edit dictionary',
    'The smaller the value, the higher it is': 'The smaller the value, the higher it is',
    'New dictionary': 'New dictionary',
    'Add dictionary entry': 'Add dictionary entry',
    'Please fill in the dictionary code': 'Please fill in the dictionary code',
    'Please fill in the dictionary name': 'Please fill in the dictionary name',
    'Please fill in the data name': 'Please fill in the data name',
    'Please fill in the data value': 'Please fill in the data value',
    'New data dictionary successfully': 'New data dictionary successfully',
    'Modified data dictionary successfully': 'Modified data dictionary successfully',
    'Modified data dictionary status successfully': 'Modified data dictionary status successfully',
    'Delete data dictionary data successfully': 'Delete data dictionary data successfully',
    'Edit dictionary entry': 'Edit dictionary entry',
    'New data dictionary entry successful': 'New data dictionary entry successful',
    'Modified data dictionary entry successfully': 'Modified data dictionary entry successfully'
  },
  oftenPassenger: {
    'Surname': 'Surname',
    'Given name': 'Given name',
    'Nationality': 'Nationality',
    'Phone': 'Phone',
    'Document type': 'Document type',
    'ID Number': 'ID Number',
    'Sex': 'Gender',
    'Name': 'Name',
    'Man': 'Male',
    'Woman': 'Female',
    'Birthday': 'Birthday',
    'Select date': 'Select date',
    'Passenger type': 'Passenger type',
    'Please select passenger type': 'Please select passenger type',
    'Area code': 'Area code',
    'Expiry': 'Expiry',
    'Issuing Country': 'Issuing Country',
    'Please fill in the mobile phone number ': 'Please fill in the mobile phone number ',
    'Please fill in the correct mobile phone number': 'Please fill in the correct mobile phone number',
    'Please fill in your birthday': 'Please fill in your birthday',
    'Birthday cannot be greater than current date': 'Birthday cannot be greater than current date',
    'Please fill in the valid period of the certificate': 'Please fill in the valid period of the certificate',
    'Document expired': 'Document expired',
    'ID number cannot be empty': 'ID number cannot be empty',
    'The format of the certificate number is incorrect': 'The format of the certificate number is incorrect',
    'Please select nationality': 'Please select nationality',
    'Please select the country issuing the certificate': 'Please select the country issuing the certificate',
    'Please select area code': 'Please select area code',
    'Last name cannot be empty': 'Last name cannot be empty',
    'Only enter English': 'Only enter English',
    'First Name cannot be empty': 'First Name cannot be empty',
    'Adult': 'Adult',
    'Child': 'Child',
    'Infant': 'Infant',
    'Passport': 'Passport',
    'Please select gender': 'Please select gender',
    'Please select document type': 'Please select document type',
    'Operation failed': 'Operation failed',
    'Added/modified successfully': 'Added/modified successfully',
    'New frequent flyer': 'New frequent flyer',
    'Edit Frequent Flyer': 'Edit Frequent Flyer',
    'Please enter ID number': 'Please enter ID number',
    'Please enter document type': 'Please enter document type'
  },
  wallet: {
    '请上传打款凭证': 'Please upload the payment certificate',
    'Enterprise Name': 'Enterprise Name',
    'Opening Bank': 'Opening Bank',
    'Bank Name': 'Bank Name',
    'Bank Code': 'Bank Code',
    'Branch Code': 'Branch Code',
    '账户名称': 'Account Name',
    '银行账号': 'Account Number',
    'Account': 'Account',
    'SWIFT Code': 'SWIFT Code',
    'Bank Address': 'Bank Address',
    '应收账户': 'Receivable Account',
    '应付账户': 'Payable Account',
    '现金账户': 'Cash Account',
    '退票冻结账户': 'Refund Freeze Account',
    '出票冻结账户': 'Ticket Freeze Account',
    '风控冻结账户': 'Risk Freeze Account',
    '应收金额': 'Receivable Amount',
    '应付金额': 'Payable Amount',
    '预期结算日期': 'Expected Settlement Date',
    '结算日期': 'Settlement Date',
    '结算周期': 'Settle Cycle',
    '操作类型': 'Operation Type',
    '款项类型': 'Payment Type',
    '操作金额': 'Operation Amount',
    '批次号': 'Batch No',
    '冻结时间': 'Frozen Time',
    '固定冻结金额': 'Fixed frozen amount',
    'Wallet': 'Wallet',
    '余额': 'Balance',
    '乘客人数': 'Passenger Count',
    '结算设置': 'Settlement Settings',
    '是否解冻': '是否解冻',
    '已解冻': 'Unfrozen',
    '未解冻': 'Not Unfrozen',
    '打款状态': 'Payment Status',
    '已打款': 'Paid',
    '确认已打款吗': 'Are you sure you have paid?',
    '打款': 'Paid',
    '未打款': 'Not paid',
    '打款日期': 'Payment Date',
    '打款人': 'Payment Person',
    'Deposit funds': 'Deposit funds',
    'Total account assets': 'Total account assets',
    'Note: Total account assets =(cash + frozen + red packet) amount': 'Note: Total account assets =(cash + frozen + red packet) amount',
    'Available deposit balance': 'Available deposit balance',
    'Unwithdrawable amount': 'Unwithdrawable amount',
    'Frozen Amount': 'Frozen',
    'red envelope balance': 'red envelope balance',
    'type': 'type',
    'Level': 'Level',
    'state': 'state',
    'query': 'query',
    'Reviewer id': 'Reviewer id',
    'Balance': 'Balance',
    'Withdrawn Amount': 'Withdrawn',
    'Freezing ratio': 'Freezing Ratio',
    'Security deposit': 'Security Deposit',
    'credit amount': 'credit amount',
    'operation': 'OP',
    'View': 'View',
    'DWR': 'DWR',
    '出票结算周期': 'Ticket Settle Cycle',
    '结算比例': 'Settle Ratio',
    '尾款结算周期': 'Balance Settle Cycle',
    '退票结算周期': 'Refund Settle Cycle',
    '改签结算周期': 'Exchange Settle Cycle',
    '充提记录': 'DWR',
    'Please select': 'Please select',
    'Exempt Auditor id': 'Exempt Auditor id',
    'Credit ratio': 'Credit ratio',
    'Total credit balance': 'Total credit balance',
    'Pay password': 'Pay password',
    'Bankcard': 'Bankcard',
    'Please enter the recharge amount': 'Please enter the recharge amount',
    'Recharge amount must be a number with a maximum of two decimal places': 'Recharge amount must be a number with a maximum of two decimal places',
    'Please fill in the amount withdrawn, default 0': 'Please fill in the amount withdrawn, default 0',
    'Please fill in the freeze ratio, default 0': 'Please fill in the freeze ratio, default 0',
    'The amount withdrawn must be a number with a maximum of two decimal places': 'The amount withdrawn must be a number with a maximum of two decimal places',
    'The frozen proportion must be a number with a maximum of two decimal places': 'The frozen proportion must be a number with a maximum of two decimal places',
    'Please fill in the frozen amount, default 0': 'Please fill in the frozen amount, default 0',
    'The frozen amount must be a number with a maximum of two decimal places': 'The frozen amount must be a number with a maximum of two decimal places',
    'Please fill in the total credit balance, default 0': 'Please fill in the total credit balance, default 0',
    'Please fill in margin, default 0': 'Please fill in margin, default 0',
    'The margin must be a number with a maximum of two decimal places': 'The margin must be a number with a maximum of two decimal places',
    'Please fill in the credit amount, default 0': 'Please fill in the credit amount, default 0',
    'The credit amount must be a number with a maximum of two decimal places': 'The credit amount must be a number with a maximum of two decimal places',
    'Please fill in the credit scale, default 0': 'Please fill in the credit scale, default 0',
    'The credit proportion must be numerical and have a maximum of two decimal places': 'The credit proportion must be numerical and have a maximum of two decimal places',
    'The total credit balance must be a number with a maximum of two decimal places': 'The total credit balance must be a number with a maximum of two decimal places',
    'Please fill in the payment password': 'Please fill in the payment password',
    'Payment password must be a number': 'Payment password must be a number',
    'Please fill in the bank card number': 'Please fill in the bank card number',
    'Card number must be a number': 'Card number must be a number',
    'Please select type': 'Please select type',
    'Please select level': 'Please select level',
    'Please select Status': 'Please select Status',
    'Please fill in the reviewer id': 'Please fill in the reviewer id',
    'Please fill in the audit Exemption id': 'Please fill in the audit Exemption id',
    'Operation failed': 'Operation failed',
    'Added/modified successfully': 'Added/modified successfully',
    'New Details': 'New Details',
    'Edit Details': 'Edit Details',
    'Transaction status': 'Status',
    'Transaction type': 'Transaction Type',
    'Income': 'Income',
    'expenditure': 'expenditure',
    'Transaction mode': 'Mode',
    'Payment method': 'Payment method',
    'Audit status': 'Audit status',
    'Order number': 'Order number',
    'Transaction No': 'Transaction No',
    'Trading hours': 'Trading hours',
    'Third party Transaction No': 'Third Party Transaction No',
    'Transaction Amount': 'Transaction',
    'Deposit balance': 'Deposit balance',
    'Operator': 'Operator',
    'Original order Number': 'Original order Number',
    'Third-Party Payee Id': 'Third-Party Payee Id',
    'Third party Account': 'Third party Account',
    'Remarks': 'Remarks',
    'Review': 'Review',
    'isAudit': 'Audited',
    'Transaction name': 'Transaction name',
    'Credit repayment status': 'Credit repayment status',
    'third-party payer Id': 'third-party payer Id',
    'third-party Payment Account': 'third-party payment Account',
    'Third party unrefunded amount': 'Third party unrefunded amount',
    'Please fill in the transaction amount': 'Please fill in the transaction amount',
    'The amount must be greater than 0 and can have up to two decimal places': 'The amount must be greater than 0 and can have up to two decimal places',
    'The third party unreturned amount must be a number with a maximum of two decimal places': 'The third party unreturned amount must be a number with a maximum of two decimal places',
    'Third party payee Id must be numeric': 'Third party payee Id must be numeric',
    'Third Party payer Id must be numeric': 'Third party payer Id must be numeric',
    'Reviewer id cannot be empty': 'Reviewer id cannot be empty',
    'Reviewer id must be a number': 'Reviewer id must be a number',
    'in trade': 'in trade',
    'Transaction success': 'Transaction success',
    'deal failed': 'deal failed',
    'Please fill in the transaction serial number': 'Please fill in the transaction serial number',
    'Please select mode': 'Please select mode',
    'Please select Audit status': 'Please select Audit Status',
    'Please select credit repayment status': 'Please select credit repayment status',
    'Please select Transaction type': 'Please select transaction type',
    'Please fill in the original order number': 'Please fill in the original order number',
    'Please select Transaction status': 'Please select Transaction status',
    'Please select trading time': 'Please select trading time',
    'Please fill in operator': 'Please fill in operator',
    'Please select operation type': 'Please select operation type',
    'Audit details': 'Audit Details',
    'accountId': 'Payment Account',
    'Add wallet': 'Add wallet',
    'Return': 'Return',
    'Details': 'Details',
    'Recharge': 'Recharge',
    'Withdrawal': 'Withdrawal',
    'Recharge method': 'Recharge method',
    'Recharge amount': 'Recharge amount',
    'Payment account name': 'Payment account name',
    'Payment serial number': 'Payment serial number',
    'Withdrawal amount': 'Withdrawal amount',
    'Receiving account name': 'Receiving account name',
    'Receiving account number': 'Receiving account number',
    'Please select the recharge method': 'Please select the recharge method',
    'Please enter account name': 'Please enter account name',
    'Please enter account number': 'Please enter account number',
    'Please enter serial number': 'Please enter serial number',
    'Account Name': 'Account Name',
    'Account number': 'Account number',
    'Pass': 'Pass',
    'Reject': 'Reject',
    'Are you sure to reject it?': 'Are you sure to reject it?'
  },
  orderPolicy: {
    'Original Tax': 'Original Tax',
    'Sales Price Formula': 'Sales Price Formula',
    'Supplier Fare Formula': 'Supplier Fare Formula',
    'Supplier Tax Formula': 'Supplier Tax Formula',
    'Baggage Type': 'Baggage Type',
    'Baggage Number': 'Baggage Number',
    'Baggage Weight': 'Baggage Weight',
    'Route': 'Route',
    'No matching policy': 'No matching policy',
    'Adult Count': 'Adult Count',
    'Child Count': 'Child Count',
    'Total order price': 'Total order price',
    'Supplier Total Price': 'Supplier Total Price',
    'Supplier Fare': 'Supplier Fare',
    'Supplier Tax': 'Supplier Tax',
    'Total Supplier Fare': 'Total Supplier Fare',
    'Total Supplier Tax': 'Total Supplier Tax',
    'Policy Start Date': 'Policy Start Date',
    'Policy End Date': 'Policy End Date',
    'Policy effective period': 'Policy effective period',
    'Countrys two-letter code': 'Countrys two-letter code',
    'Example:FR/DE': 'Example:FR/DE',
    'People': 'People',
    'The rebate supports both positive and negative values,Entering a positive value indicates a discount from the original price,while a negative value represents a price increase, For example:Inputting a rebate value of ‌10‌ adjusts the price to ‌90%‌ of the original；Inputting a rebate value of ‌10‌ adjusts the price to ‌90%‌ of the original': 'The rebate supports both positive and negative values,Entering a positive value indicates a discount from the original price,while a negative value represents a price increase, For example:Inputting a rebate value of ‌10‌ adjusts the price to ‌90%‌ of the original；Inputting a rebate value of ‌10‌ adjusts the price to ‌90%‌ of the original',
    'Adult rebate': 'Adult rebate',
    'Child rebate': 'Child rebate',
    'Adult price increase': 'Adult price increase',
    'Child price increase': 'Child price increase',
    'Adult Tax rebate': 'Adult Tax rebate',
    'Child Tax rebate': 'Child Tax rebate',
    'Adult Tax increase': 'Adult Tax increase',
    'Child Tax increase': 'Child Tax increase',
    'Applicable fare basis': 'Applicable fare basis',
    'Lowest fare': 'Lowest fare',
    'Highest fare': 'Highest fare',
    'Example: Suppose the travel date is filled in as 5/1 - 5/30, and the `Includes travel days` is set to 1-7, This means that the price adjustment only applies to tickets for travel dates that fall within the 7-day period starting from `the current day + 1` to `the current day + 7`, This 7-day window will be extended day by day until the calculated date falls outside the specified travel date range': 'Example: Suppose the travel date is filled in as 5/1 - 5/30, and the `Includes travel days` is set to 1-7, This means that the price adjustment only applies to tickets for travel dates that fall within the 7-day period starting from `the current day + 1` to `the current day + 7`, This 7-day window will be extended day by day until the calculated date falls outside the specified travel date range.',
    'Includes travel days': 'Includes travel days',
    'Identity': 'Identity',
    'Baggage Allowance': 'Baggage Allowance',
    'When left blank, it matches all flights, When set to 0, it matches all flights without baggage': 'When left blank, it matches all flights, When set to 0, it matches all flights without baggage',
    'Exclude transit airports': 'Exclude transit airports',
    'Included': 'Included',
    'Excluded': 'Excluded',
    'Passenger type': 'Passenger type',
    'Origin airport': 'Origin airport',
    'Arrival airport': 'Arrival airport',
    'Transit airport': 'Transit airport',
    'Example:1/3/5': 'Example: 1/3/5',
    'Included flight schedule': 'Included flight schedule',
    'Exclude route': 'Exclude route',
    'Exclude flights': 'Exclude flights',
    'Included flights': 'Included flights',
    'Exclude travel date': 'Exclude travel date',
    'Travel date': 'Travel date',
    'Stay duration': 'Stay duration',
    'Sales date': 'Sales date',
    'Working hours': 'Working hours',
    'Example:1-100, the larger the value, the higher the weight': 'Example: 1-100, the larger the value, the higher the weight',
    'Weight': 'Weight',
    'Stop sell time': 'Stop sell time',
    'The stop sell time for this route is xx hours before departure': 'The stop sell time for this route is xx hours before departure',
    'All airports: ALL': 'All airports: ALL',
    'Publication of Tariff Policy': 'Publication of Tariff Policy',
    'Private Configuration Policy': 'private configuration Policy',
    'B2T policy': 'B2T policy',
    'Travel type': 'travel type',
    'all': 'all',
    'Airlines': 'Airlines',
    'Policy Code': 'Policy Code',
    'Point of departure': 'point of departure',
    'arrival point': 'arrival point',
    'Policy source': 'Policy source',
    'Policy type': 'Policy type',
    'Policy state': 'Policy state',
    'Policy State': 'Policy State',
    'Cabin': 'Cabin',
    'Invoicing OFFICE': 'Invoicing OFFICE',
    'Automatic issue': 'Automatic issue',
    'No Tickets Last Week': 'No Tickets Last Week',
    'Start time': 'Start time',
    'End time': 'end time',
    'End time cannot be less than start time': 'End time cannot be less than start time',
    'ticket type': 'ticket type',
    'Policy Alias': 'Policy Alias',
    'Change Encoding': 'Change Encoding',
    'Same GDS code': 'Same GDS code',
    'Document Number': 'Document Number',
    'Fare Lower': 'Fare Lower',
    'Policy id/Policy Type': 'Id/Type',
    'One way': 'one way',
    'Round trip': 'round trip',
    'One way/round trip': 'one way/round trip',
    'Flight type': 'Flight type',
    'Start & End': 'Start & End',
    'To': 'to',
    'return to': 'return to',
    'Originating': 'originating',
    'arrive': 'arrive',
    'Deduction rate': 'Deduction Rate',
    'Quick Fix': 'Quick fix',
    'state': 'state',
    'Automatic ticketing': 'Automatic Ticketing',
    'Last date': 'Last Date',
    'Modify': 'modify',
    'Enable': 'Enable',
    'Suspend': 'Suspend',
    'Agency fee': 'agency fee',
    'Reward': 'reward',
    'Billing fee': 'billing fee',
    'one-way direct reduction': 'One way discount',
    'Round trip subtraction': 'round trip subtraction',
    'expiry date': 'expiry date',
    'Policy valid period': 'Policy valid period',
    'return expiry date': 'return expiry date',
    'invoicing period': 'invoicing period',
    'Method of issue': 'method of issue',
    'par limit is higher than': 'par limit is higher than',
    'Appointed agency fee': 'appointed agency fee',
    'Priority BSP': 'priority BSP',
    'priority BOP': 'priority BOP',
    'Designated baggage amount': 'designated baggage amount',
    'Settlement method': 'settlement method',
    'Please fill in the agency fee, default 0': 'Please fill in the agency fee, default 0',
    'The agency fee must be a number with a maximum of two decimal places': 'The agency fee must be a number with a maximum of two decimal places',
    'Please fill in reward, default 0': 'Please fill in reward, default 0',
    'Reward must be a number with a maximum of two decimal places': 'Reward must be a number with a maximum of two decimal places',
    'Please fill in the billing fee, default 0': 'Please fill in the billing fee, default 0',
    'Billing fee must be a number with a maximum of two decimal places': 'Billing fee must be a number with a maximum of two decimal places',
    'Please fill in one-way direct deduction, default 0': 'Please fill in one-way direct deduction, default 0',
    'One-way direct subtraction must be a number with a maximum of two decimal places': 'one-way direct subtraction must be a number with a maximum of two decimal places',
    'Please fill in round trip deduction, default 0': 'Please fill in round trip deduction, default 0',
    'Round trip straight subtraction must be a number with a maximum of two decimal places': 'Round trip straight subtraction must be a number with a maximum of two decimal places',
    'Face limit must be a number': 'Face limit must be a number',
    'The appointed agency fee must be a number with a maximum of two decimal places': 'The appointed agency fee must be a number with a maximum of two decimal places',
    'Specified baggage allowance must be a number': 'Specified baggage allowance must be a number',
    'domestic origin': 'domestic origin',
    'Direct SOTO': 'Direct SOTO',
    'Domestic origin Add-On': 'domestic origin Add-On',
    'Foreign origin Add-On': 'foreign origin Add-On',
    'From abroad to abroad': 'from abroad to abroad',
    'domestic originating transit': 'domestic originating transit',
    'foreign originating transit': 'foreign originating transit',
    'offshore offshore': 'offshore offshore offshore',
    'outside China': 'outside China',
    'Globe to globe': 'Globe to globe',
    'Global to global': 'Global to global',
    'System hang': 'System hang',
    'Unusable': 'unusable',
    'Pending review': 'Pending review',
    'Audit failed': 'Audit failed',
    'under review': 'under review',
    'Offshore electron': 'offshore electron',
    'No need to change code': 'No need to change code',
    'change code issue': 'change code issue',
    'Big ticket issue (no need to change)': 'Big ticket issue (no need to change)',
    'Big ticket issue (need to change)': 'Big ticket issue (need to change)',
    'No need to change the arrangement out of the ticket (no place outside)': 'No need to change the arrangement out of the ticket (no place outside)',
    'Original draft': 'original draft',
    'Change out of ticket': 'Change out of ticket',
    'The same region configuration can be originally issued': 'The same region configuration can be originally issued',
    'Yes': 'Yes',
    'No': 'No',
    'Cash': 'cash',
    'Check': 'check',
    'Credit card': 'credit card',
    'New policy': 'New policy',
    'NDC(Foreign Airlines)': 'NDC(foreign airlines)',
    'official website type': 'official website type',
    'Official website of B': 'official website of B',
    'official website of C': 'official website of C',
    'C terminal website': 'C terminal website',
    'Invoicing GDS': 'invoicing GDS',
    'Place of bill': 'place of bill',
    'Ticket rescheduling': 'Ticket rescheduling',
    'No time difference': 'No time difference',
    'Time difference': 'Time difference',
    'Audit after 9am schedul ': " Audit after 9am schedul ",
    'Audit after 15pm schedul ': " Audit after 15pm schedul ",
    'Audit after 16pm schedul': 'Audit after 16pm schedul',
    'Audit after 20pm schedul ': " Audit after 20pm schedul ",
    '24h ahead of schedule': '24h ahead of schedule',
    '48h ahead of schedule': '48h ahead of schedule',
    'Holiday sales': 'Holiday sales',
    'Applicable airlines': 'Applicable airlines',
    'Unified group airlines': 'Unified Group Airlines',
    'Example:MU/CA': 'Example: MU/CA',
    'Supplier OFFICE': 'Supplier OFFICE',
    'Example :SHA889': 'Example :SHA889',
    'Invoicing PCC': 'Invoicing PCC',
    'Example53': 'Example :5.3',
    'Example :200': 'Example :200',
    'Extra Refund Service': 'Extra Refund service',
    'There is a refund service charge': 'There is a refund service charge',
    'Refund Service': 'Refund Service',
    'Example:3': 'Example: 3',
    'Airlines & Express GDS Policy': 'Airlines & Express GDS Policy',
    'Protocol type of policy': 'Protocol type of policy',
    'Please enter': 'Please enter',
    'Advance issuance days': 'Advance issuance days',
    'Minimum stay days': 'Minimum stay days',
    'usual billing time': 'usual billing time',
    'Maximum stay days': 'Maximum stay days',
    'Saturday billing time': 'Saturday billing time',
    'No bill': 'no bill',
    'Sunday billing time': 'Sunday billing time',
    'Auto Ticketing Special Settings': 'Auto ticketing special Settings',
    'Please enter Airport 3 code': 'Please enter Airport 3 code',
    'Transit': 'transit',
    'Example :A/B/C': 'Example :A/B/C',
    'Not applicable to connecting airports': 'Not applicable to connecting airports',
    'Applicable age': 'Applicable age',
    'Optional': 'Optional',
    'Year': 'Age',
    'Applicable number': 'Applicable number',
    'Man': 'man',
    'day': 'day',
    'Child ticket': 'Child ticket',
    'Child and adult congruence': 'Child and adult congruence',
    'Open no reward': 'Open no reward',
    'Do not open': 'do not open',
    'Specify reward': 'Specify reward',
    'Do not open without agency fee': 'Do not open without agency fee',
    'Children do not open': 'Children do not open',
    'Children do not enjoy direct deductions': 'Children do not enjoy direct deductions',
    'Baby ticket': 'Baby ticket',
    'Additional service charge': 'additional service charge',
    'Large code issue (no need to change the encoding)': 'Large code issue (no need to change the encoding)',
    'Large code issue (need to Change Encoding)': 'Large code issue (need to Change Encoding)',
    'No bit no ticket (change when there is a bit outside)': 'No bit no ticket (change when there is a bit outside)',
    'Auto change': 'auto-change',
    'Does no bit accept short editing': 'Does no bit accept short editing',
    'Change code does not authorize': 'change code does not authorize',
    'Specify Office number location': 'Specify Office number location',
    'original code issue': 'original code issue',
    'Not applicable': 'not applicable',
    'Destination notch': 'Destination notch',
    'Gaps in applicable policies': 'Gaps in applicable policies',
    'Gap in applicable country': 'Gap in applicable country',
    'Designated country': 'designated country',
    'unavailable': 'unavailable',
    'Shared flight': 'Shared flight',
    'Operating flights': 'Operating flights',
    'No reward for the whole journey': 'No reward for the whole journey',
    'Full designated reward': 'full designated reward',
    'Shared segment no reward': 'Shared segment no reward',
    'Shared segment specified reward': 'Shared segment specified reward',
    'Partial sharing required for review': 'Partial sharing required for review',
    'Do not open with sharing': 'Do not open with sharing',
    'Give all rewards': 'Give all rewards',
    'Reward all when shared with the following airlines only': 'Reward all when shared with the following airlines only',
    'Example :FM or FM/AF(separated by/for multiple airlines)': 'Example :FM or FM/AF(separated by/for multiple airlines)',
    'SPA/ combined transport gives all rewards': 'SPA/ combined transport gives all rewards',
    'If :CZ/HU': 'If :CZ/HU',
    'Air Department': 'Air Department',
    'such as :PVG/SHA/CN': 'such as :PVG/SHA/CN',
    'If :CN/HK': 'If :CN/HK',
    'Must be the first paragraph': 'Must be the first paragraph',
    'Any segment contains': 'any segment contains',
    'Allow mixing 1/2RT': 'Allow mixing 1/2RT',
    'Only the same document number can be mixed 1/2RT': 'Only the same document number can be mixed 1/2RT',
    'Tariff base to be consistent': 'Tariff base to be consistent',
    'Warm reminder: Check the box slightly lower will reduce the chance of the policy being selected, please verify the policy!': 'Warm reminder: the ticked slightly lower will reduce the chance of the policy being selected, please verify the policy!',
    'TOUR CODE contains': 'TOUR CODE contains',
    'For example :CHN5300F/*(* denotes any tourcode)': 'For example :CHN5300F/*(* denotes any tourcode)',
    'No agency fee': 'No agency fee',
    'No reward': 'No reward',
    'Only applies to the following TOUR CODE': 'Only applies to the following TOUR CODE',
    'CHN5300F/SHAR001 or CHN* (beginning of CHN) or *F01 (ending of F01) or 8HN53* (baohan NH53)': 'CHN5300F/SHAR001 or CHN* (beginning of CHN) or *F01 (ending of F01) or 8HN53* (baohan NH53)',
    'Does the agency fee apply when the system COMMISSION is 0': 'Does the agency fee apply when the system COMMISSION is 0',
    'Round-trip must include accommodation': 'Round-trip must include accommodation',
    'high space, such as: H/B/E/M/D/C/P/Y/M/F': 'high space, such as: H/B/E/M/D/C/P/Y/M/F',
    'Face value (excluding tax)': 'Face value (excluding tax)',
    'above': 'above',
    'Invokes only if it is greater than or equal to the amount': 'invokes only if it is greater than or equal to the amount',
    'below': 'below',
    'Invoicing is required for less than or equal to the amount': 'invoicing is required for less than or equal to the amount',
    'included in tariff base': 'included in tariff base',
    'Format :PR/WX/WR': 'Format :PR/WX/WR',
    'Only applicable to the following tariff bases': 'Only applicable to the following tariff bases',
    'Q3M6CN/A3M5TR or Q3*(beginning with Q3M) or *CN(ending with CN) or *R6R*(including R6R) or J(for single base rate only)': 'Q3M6CN/A3M5TR or Q3*(beginning with Q3M) or *CN(ending with CN) or *R6R*(including R6R) or J(for single base rate only)',
    'outbound applicable flight': 'outbound applicable flight',
    'Example:CA123/CA234/TG001-TG999': 'Example: CA123/CA234/TG001-TG999',
    'return applicable Flight': 'return applicable flight',
    'Not applicable Flights': 'Not applicable flights',
    'Format :CA123/CA234/CA7*/CA27*/TG001-TG999/ No limit': 'Format :CA123/CA234/CA7*/CA27*/TG001-TG999/ No limit',
    'Not applicable route': 'Not applicable route',
    'Example:PVG-BKK/PEK-LHR': 'Example: PVG-BKK/PEK-LHR',
    'Go cycle not applicable': 'go cycle not applicable',
    'Monday': 'Monday',
    'Tuesday': 'Tuesday',
    'Wednesday': 'Wednesday',
    'Thursday': 'Thursday',
    'Friday': 'Friday',
    'Saturday': 'Saturday',
    'Sunday': 'Sunday',
    'Return not applicable period': 'return not applicable period',
    'outbound date not applicable': 'outbound date not applicable',
    'Return No applicable Date': 'return no applicable date',
    'Other remarks': 'Other remarks',
    'reset': 'reset',
    'Confirm': 'confirm',
    'Refund service fee must be a number with a maximum of two decimal places': 'Refund service fee must be a number with a maximum of two decimal places',
    'Baggage allowance must be a number': 'Baggage allowance must be a number',
    'Days must be numbers': 'Days must be numbers',
    'Abacus or Sabre': 'Abacus or Sabre',
    'International Student': 'International Student',
    'Immigrant': 'immigrant',
    'Labour': 'Labour',
    'Seafarer': 'Seafarer',
    'Youth': 'Youth',
    'Old age': 'Old age',
    'to visit family': 'to visit family',
    'Hong Kong, Macao and Taiwan': 'Hong Kong, Macao and Taiwan',
    'Foreign': 'foreign',
    'non-Chinese name': 'non-Chinese name',
    'Add-On': 'Add-On',
    'offshore transit': 'offshore transit',
    'OPEN': 'OPEN',
    'Tripartite Agreement': 'Tripartite Agreement',
    'Set of ticket': 'Set of tickets',
    'whole lump': 'whole lump',
    'Little tuan': 'Little tuan',
    'Please select Policy type': 'Please select Policy type',
    'Please select the ticket type': 'Please select the ticket type',
    'Please select website type': 'Please select website type',
    'Please select billing type': 'Please select billing type',
    'Please reschedule': 'Please reschedule',
    'Please select': 'Please select',
    'Please fill in the airline': 'Please fill in the airline',
    'Please fill in suppliers OFFICE number ': " Please fill in supplier's OFFICE number ",
    'Please fill in the invoice OFFICE number': 'Please fill in the invoice OFFICE number',
    'Please fill in the drawing PCC number': 'Please fill in the drawing PCC number',
    'Please select time': 'Please select time',
    'website': 'website',
    'Please enter the minimum value': 'Please enter the minimum value',
    'Please enter the maximum value': 'Please enter the maximum value',
    'Number of people must be numbers': 'Number of people must be numbers',
    'Minimum number of people applicable': 'Minimum number of people applicable',
    'Applicable to up to 9 people': 'Applicable to up to 9 people',
    'Minimum number of people up to 8 people': 'Minimum number of people up to 8 people',
    'Maximum number of people Minimum 2 people': 'Maximum number of people Minimum 2 people',
    'The minimum number of people cannot exceed the maximum number of people': 'The minimum number of people cannot exceed the maximum number of people'
  },
  adminLang: {
    'New': 'New',
    'Status': 'Status',
    'Query': 'Query',
    'Reset': 'Reset',
    'Number of threads': 'Number of threads',
    'Proxy ip': 'Proxy ip',
    'Remarks': 'Remarks',
    'Creation time': 'Creation time',
    'Operation': 'OP',
    'Disable': 'Disable',
    'Edit': 'Edit',
    'Are you sure to delete?': 'Are you sure to delete?',
    'Delete': 'Delete',
    'Log': 'Log',
    'Cancel': 'Cancel',
    'Save': 'Save',
    'Please fill in the number of threads': 'Please fill in the number of threads',
    'Import': 'Import',
    'Reptile Number': 'Reptile Number',
    'Airline': 'Airline',
    'Yes': 'Yes',
    'No': 'No',
    'Edit policy crawler configuration': 'Edit policy crawler configuration',
    'Task start time': 'Task start time',
    'Task end time': 'Task end time',
    'Click to upload': 'Click to upload',
    'Only xlsx files can be uploaded': 'Only xlsx files can be uploaded',
    'Download Template': 'Download Template',
    'Please fill in the crawler number': 'Please fill in the crawler number',
    'Please fill in the airline': 'Please fill in the airline',
    'Please select task start time': 'Please select task start time',
    'Please select task end time': 'Please select task end time',
    'Added policy crawler configuration': 'Added policy crawler configuration',
    'Added/modified policy crawler configuration successful': 'Added/modified policy crawler configuration successful',
    'Please select airline': 'Please select airline',
    'Are you sure to export the data?': 'Are you sure to export the data?',
    'Tip': 'Tip',
    'OK': 'OK',
    'Please select the uploaded file': 'Please select the uploaded file',
    'Deleted successfully': 'Deleted successfully',
    'Please fill in the mobile phone number': 'Please fill in the mobile phone number',
    'Please fill in the correct mobile phone number': 'Please fill in the correct mobile phone number',
    'Modify': 'Modify',
    'Status Success': 'Status Success',
    'Status failed': 'Status failed',
    'Level': 'Level',
    'Ready': 'Ready',
    'Running': 'Running',
    'Disabled': 'Disabled',
    'Task Code': 'Task Code',
    'Task name': 'Task name',
    'Task class name': 'Task class name',
    'Task Cron/Update Cron': 'Task Cron/Update Cron',
    'Parameter': 'Parameter',
    'Task timeout': 'Task timeout',
    'Number of failed retries': 'Number of failed retries',
    'Are you sure it is enabled?': 'Are you sure it is enabled?',
    'Enable': 'Enable',
    'Are you sure it is disabled?': 'Are you sure it is disabled?',
    'New task scheduling': 'New task scheduling',
    'Edit Task Scheduling': 'Edit Task Scheduling',
    'Mission Cron': 'Mission Cron',
    'Cron to perform the task': 'Cron to perform the task',
    'Update Cron': 'Update Cron',
    'Cron that regularly updates task content': 'Cron that regularly updates task content',
    '0 is the unlimited timeout time, unit: minutes': '0 is the unlimited timeout time, unit: minutes',
    '0 is the number of unlimited retries': '0 is the number of unlimited retries',
    'Please fill in the task code': 'Please fill in the task code',
    'Please fill in the task name': 'Please fill in the task name',
    'Please fill in the task class name': 'Please fill in the task class name',
    'Please fill in the task Cron': 'Please fill in the task Cron',
    'Please enter the correct Cron expression': 'Please enter the correct Cron expression',
    'Please fill in the update Cron': 'Please fill in the update Cron',
    'Please fill in the task timeout time': 'Please fill in the task timeout time',
    'Please fill in the number of failed retries': 'Please fill in the number of failed retries',
    'Task Scheduling Log -': 'Task Scheduling Log -',
    'Please enter a positive integer': 'Please enter a positive integer',
    'New task scheduling successful': 'New task scheduling successful',
    'Modified task scheduling successful': 'Modified task scheduling successful',
    'Enabled successfully': 'Enabled successfully',
    'Disable success': 'Disable success',
    'Delete task scheduling successful': 'Delete task scheduling successful',
    'Valid': 'Valid',
    'Invalid': 'Invalid',
    'Export': 'Export',
    'Channel': 'Channel',
    'Crawl type': 'Crawl type',
    'Flight date range': 'Flight date range',
    'Route range': 'Route range',
    'Request interval': 'Request interval',
    'Whether to cache/warehousing': 'Whether to cache/warehousing',
    'Task time range': 'Task time range',
    'Create/last update time': 'Create/last update time',
    'Total': 'Total',
    'Increment': 'Increment',
    'Class': 'Class',
    'Incremental number of seats': 'Incremental number of seats',
    'Crawling space': 'Crawling space',
    'Multiple People/Separation': 'Multiple People/Separation',
    'Flight date start number': 'Flight date start number',
    'Start from 1, the day is 1': 'Start from 1, the day is 1',
    'Number of flight date ends': 'Number of flight date ends',
    'End number -1 is the end date': 'End number -1 is the end date',
    'Route start number': 'Route start number',
    '0 for all': '0 for all',
    'Number of route ends': 'Number of route ends',
    'Unit: milliseconds': 'Unit: milliseconds',
    'Increase the number of people when inquiring': 'Increase the number of people when inquiring',
    'Whether to cache': 'Whether to cache',
    'Cache address': 'Cache address',
    'Cache time': 'Cache time',
    'Unit: minutes': 'Unit: minutes',
    'Whether to put into storage': 'Whether to put into storage',
    'Delete type': 'Delete type',
    'Delete by day': 'Delete by day',
    'Delete by route': 'Delete by route',
    'Warehousing increase time': 'Warehousing increase time',
    'Please select channel': 'Please select channel',
    'Please select crawl type': 'Please select crawl type',
    'Please fill in the incremental number of seats': 'Please fill in the incremental number of seats',
    'Please fill in the crawling space': 'Please fill in the crawling space',
    'Please fill in the starting number of the flight date': 'Please fill in the starting number of the flight date',
    'Please fill in the number of flight date ends': 'Please fill in the number of flight date ends',
    'Please fill in the starting number of routes': 'Please fill in the starting number of routes',
    'Please fill in the number of route ends': 'Please fill in the number of route ends',
    'Please fill in the request interval': 'Please fill in the request interval',
    'Please fill in the inquiry to increase the number of people': 'Please fill in the inquiry to increase the number of people',
    'Please choose whether to cache': 'Please choose whether to cache',
    'Please fill in the cache address': 'Please fill in the cache address',
    'Please fill in the cache time': 'Please fill in the cache time',
    'Please select whether to put into storage': 'Please select whether to put into storage',
    'Please select deletion type': 'Please select deletion type',
    'Please fill in the warehousing increase time': 'Please fill in the warehousing increase time',
    'Modified status successfully': 'Modified status successfully',
    'Failed to modify state': 'Failed to modify state',
    'The number of flight date ends must be greater than the number of flight date starts': 'The number of flight date ends must be greater than the number of flight date starts',
    'Airline configuration not found': 'Airline configuration not found',
    'Policy crawler log -': 'policy crawler log -',
    'Wrong oh, this is an error message': 'Wrong oh, this is an error message',
    'Shop': 'Shop',
    'Store Code': 'Store Code',
    'Occupy space': 'Occupy space',
    'Pause time': 'Pause time',
    'Abnormal airline code': 'Abnormal airline code',
    'Exception policy code': 'Exception policy code',
    'Filter Policy Code': 'Filter Policy Code',
    'Creation time/modification time': 'Creation time/modification time',
    'Multiple times | separated, including judgments respectively': 'Multiple times | separated, including judgments respectively',
    'Do not account for childrens policy code': "Do not account for children's policy code",
    'Active cache interface': 'Active cache interface',
    'Cache name': 'Cache name',
    'Cache URL': 'Cache URL',
    'Added seat-occupying crawler configuration': 'Added seat-occupying crawler configuration',
    'Please fill in the active cache interface': 'Please fill in the active cache interface',
    'Please fill in the cache name': 'Please fill in the cache name',
    'Please fill in the cache URL': 'Please fill in the cache URL',
    'Deleted data successfully': 'Deleted data successfully',
    'Added success Check the result later': 'Added success Check the result later',
    'Occupy crawler log -': 'Occupy crawler log -',
    'Payment channel configuration not found': 'Payment channel configuration not found',
    'Please select a level': 'Please select a level',
    'Module': 'Module',
    'Event': 'Event',
    'Source': 'Source',
    'Title': 'Title',
    'Operator': 'Operator',
    'Start date': 'Start date',
    'End date': 'End date',
    'Clear data': 'Clear data',
    'Content': 'Content',
    'Time': 'Time',
    'Operate Time': 'Operate Time',
    'Type': 'Type',
    'Confirm that the data is cleared according to the query conditions?': 'Confirm that the data is cleared according to the query conditions?',
    'Start and end dates cannot be empty': 'Start and end dates cannot be empty',
    'End date must be greater than or equal to start date': 'End date must be greater than or equal to start date',
    'The difference between the start date and the end date cannot be greater than seven days': 'The difference between the start date and the end date cannot be greater than seven days',
    'Module configuration not found': 'Module configuration not found',
    'Event configuration not queried': 'Event configuration not queried',
    'Airline cannot be empty': 'Airline cannot be empty',
    'Bar data': 'Bar data',
    'Query cache': 'Query cache',
    'Sync cache': 'Sync cache',
    'Cache key': 'Cache key',
    'Confirm sync cache?': 'Confirm sync cache?',
    'Synchronization cache successful': 'Synchronization cache successful',
    'Merchant Name': 'Merchant Name',
    'Merchant Code': 'Merchant Code',
    'Merchant Type': 'Merchant Type',
    'Supplier': 'Supplier',
    'Purchaser': 'Purchaser',
    'Open': 'Open',
    'Close': 'Close',
    'Enterprise Type': 'Enterprise Type',
    'Full name of the company': 'Full name of the company',
    'Company abbreviation': 'Company abbreviation',
    'Company Code': 'Company Code',
    'Address': 'Address',
    'Contact person': 'Contact person',
    'Contact FirstName': 'First name',
    'Contact LastName': 'Last name',
    'Contact number': 'Contact number',
    'Contact email': 'Contact email',
    'Contact tel': 'Area code',
    'Authorization time': 'Authorization time',
    'Permission Control': 'Permission Control',
    'Select date': 'Select date',
    'Select time': 'Select time',
    'Permission': 'Permission',
    'Home': 'Home',
    'Please select at least one type': 'Please select at least one type',
    'Please select at least one level': 'Please select at least one level',
    'Please select at least one state': 'Please select at least one state',
    'Please fill in the full name of the company': 'Please fill in the full name of the company',
    'Please fill in the company abbreviation': 'Please fill in the company abbreviation',
    'Please fill in the company code': 'Please fill in the company code',
    'Please fill in the company address': 'Please fill in the company address',
    'Please fill in the contact person name': 'Please fill in the contact person name',
    'Please fill in the contact email': 'Please fill in the contact email',
    'Please fill in the contact area code': 'Please fill in the contact area code',
    'Please select a date': 'Please select a date',
    'Please select time': 'Please select time',
    'New merchant': 'New merchant',
    'Agent Management': 'Agent Management',
    'Add/modify merchant successfully': 'Add/modify merchant successfully',
    'Edit Merchant': 'Edit Merchant',
    'Added/modified merchant successfully!': 'Added/modified merchant successfully!',
    'Deleted company data successfully': 'Deleted company data successfully',
    'admin': 'Operation',
    'Merchant': 'Merchant',
    'Real name': 'Real name',
    'Login name': 'Login name',
    'Contact information': 'Contact information',
    'Job number': 'Job number',
    'Administrator': 'Administrator',
    'Role name': 'Role name',
    'Department Name': 'Department Name',
    'Job Title': 'Job Title',
    'Mailbox': 'Mailbox',
    'Gender': 'Gender',
    'Reset-pw': 'Reset-pw',
    'Login must be a letter or number': 'Login must be a letter or number',
    'Password': 'Password',
    'Confirm password': 'Confirm password',
    'Male': 'Male',
    'Female': 'Female',
    'Confidentiality': 'Confidentiality',
    'Department': 'Department',
    'Please select a department': 'Please select a department',
    'Post': 'Post',
    'Please select a position': 'Please select a position',
    'Character name': 'Character name',
    'Please select a role': 'Please select a role',
    'Normal': 'Normal',
    'Security Question': 'Security Question',
    'Secret Answer': 'Secret Answer',
    'Please fill in the account number': 'Please fill in the account number',
    'Account number must be a combination of numbers and letters': 'Account number must be a combination of numbers and letters',
    'Please fill in the password': 'Please fill in the password',
    'Please fill in the password again': 'Please fill in the password again',
    'The password filled in twice is inconsistent!': 'The password filled in twice is inconsistent!',
    'Please fill in your real name': 'Please fill in your real name',
    'Please fill in the job number': 'Please fill in the job number',
    'Please select a role name': 'Please select a role name',
    'Please select a department name': 'Please select a department name',
    'Please fill in the job title': 'Please fill in the job title',
    'Deleted': 'Deleted',
    'Are you sure the reset password is 123456 ?': 'Are you sure the reset password is 123456 ?',
    'Reset password to 123456': 'Reset password to 123456.',
    'Failed to reset password': 'Failed to reset password,',
    'Operation failed': 'Operation failed',
    'The mailbox format is incorrect': 'The mailbox format is incorrect',
    'Inconsistent password filled in twice': 'Inconsistent password filled in twice',
    'New account': 'New account',
    'Edit account': 'Edit account',
    'Agent account management': 'Agent account management',
    'Please select the payment time limit': 'Please select the payment time limit',
    'Change payment time limit': 'Change payment time limit',
    'Change processing time limit': 'Change processing time limit',
    'Change ticketing time limit': 'Change ticketing time limit',
    'Refund confirmation limit': 'Refund confirmation limit'
  },
  zsCurrencyList: {
    'Country name': 'Country name',
    'Please enter country name': 'Please enter country name',
    'Currency name': 'Currency name',
    'Currency symbol': 'Currency symbol',
    'Currency Code': 'Currency Code',
    'Bank of China Exchange Rate': 'Bank of China Exchange Rate',
    'Middle Rate': 'Middle Rate',
    'Custom Exchange Rate': 'Custom Exchange Rate',
    'Status': 'Status',
    'Update time': 'Update time',
    'Central Bank': 'Central Bank',
    'URL': 'URL'
  },
  flight: {
    '未知': 'Unknown',
    'Search again': 'The page stay time is too long, the ticket price may have been changed, please search again',
    'Subject to airline regulations': 'Subject to airline regulations',
    'Click ‘BOOK’ to view the detailed rules': 'Click ‘BOOK’ to view the detailed rules',
    'For more information, please visit the homepage': 'For more information, please visit the homepage',
    'Unlimited': 'Unlimited',
    'Not included': 'Not included',
    'piece': 'piece',
    'size': 'Size',
    'weight': 'Weight',
    'Carry-on': 'Carry-on baggage',
    'Checked': 'Checked baggage',
    'B2O': 'Channel Distribution',
    'OSS': 'Channel Exclusive',
    'B2O_QNS': 'Channel Express ticket',
    'FPP_F': 'First Class',
    'CFP': 'Discounted Ticket',
    'BPP_B': 'Business Class',
    'FXP': 'Special Fare',
    'B2O_NMP': 'Flagship Store',
    'B2O_CPC': 'Flagship Store',
    'B2O_ASA': 'Premium Product',
    'COB': 'Bundled Pricing',
    'B2O_JWP': 'Great Value Price',
    'B2O_LPG': 'Preferred Selection',
    'Return and change': 'Flight Cancellation & Change',
    'Baggage Allowance': 'Baggage Allowance',
    'Reimbursement voucher': 'Reimbursement voucher',
    'Reservation Instructions': 'Reservation Instructions',
    'Fare': 'Fare',
    'Tax': 'Tax',
    'Re-search flight': 'Re-search flight',
    'Passenger': 'Passenger',
    'PassengerType': 'Passenger type',
    'Adult': 'Adult',
    'Age 12 and older': 'Age 12 and older',
    '2~12 years old (excluding)': '2~12 years old (excluding)',
    'Please select passenger gender': 'Please select passenger gender',
    'Male': 'Male',
    'Female': 'Female',
    'Last name': 'Last name',
    'First name': 'First name',
    'Nationality': 'Nationality',
    'Select date of birth': 'Select date of birth',
    'Please select ID type': 'Please select ID type',
    'Passport': 'Passport',
    'Hong Kong and Macau Pass': 'Hong Kong and Macau Pass',
    'Taiwan Travel Permit for Mainland Residents': 'Taiwan Travel Permit for Mainland Residents',
    'ID Number': 'ID Number',
    'Select the valid period': 'Select the valid period',
    'Telephone No': 'Telephone No.',
    'Children': 'Children',
    'Gender': 'Gender',
    'Contact person': 'Contact Details',
    'Email for emergency contact, please fill in correctly': 'Email (for emergency contact, please fill in correctly)',
    'Next step': 'Next step',
    'Order Confirmation': 'Order Confirmation',
    'Date of birth': 'Date of birth',
    'Pay': 'Pay',
    'day': 'd',
    'hour': 'h',
    'minute': 'm',
    'seconds': 's',
    'Place of issue': 'Place of issue',
    'Please enter passenger last name': 'Please enter passenger last name',
    'Please enter passenger name': 'Please enter passenger name',
    'Please enter passenger nationality': 'Please enter passenger nationality',
    'Please select Passenger Document Type': 'Please select Passenger Document Type',
    'Please enter passenger Credential No': 'Please enter passenger Credential No',
    'Please select the issuing country of the document': 'Please select the issuing country of the document',
    'Please select the valid period of the passenger document': 'Please select the valid period of the passenger document',
    'Please select passenger birthday': 'Please select passenger birthday',
    'Passengers must be over 12 years old': 'Passengers must be over 12 years old',
    'Please enter the passengers mobile phone number ': "Please enter the passenger 's mobile phone number",
    'Please enter child passenger last name': 'Please enter child passenger last name',
    'Please enter child passenger name': 'Please enter child passenger name',
    'Please select child passenger gender': 'Please select child passenger gender',
    'Please enter the nationality of the child passenger': 'Please enter the nationality of the child passenger',
    'Please select Child Passenger Document Type': 'Please select Child Passenger Document Type',
    'Please enter Child Passenger Credential No': 'Please enter Child Passenger Credential No',
    'Please select the valid period of the child passenger document': 'Please select the valid period of the child passenger document',
    'Please select Child Passenger Birthday': 'Please select Child Passenger Birthday',
    'Please enter the child passenger mobile phone number': 'Please enter the child passenger mobile phone number',
    'FIT Booking': 'Search Flights',
    'One way': 'One way',
    'Round trip': 'Round trip',
    'Departure': 'Departure',
    'Destination': 'Destination',
    'Departure date': 'Departure date',
    'Return date': 'Return date',
    'Search': 'Search',
    'Departure city cannot be empty': 'Departure city cannot be empty',
    'Arrival city cannot be empty': 'Arrival city cannot be empty',
    'Please select a voyage type': 'Please select a voyage type',
    'Please select a departure date': 'Please select a departure date',
    'Please select arrival date': 'Please select arrival date',
    'Please select the number of passengers': 'Please select the number of passengers',
    'Filter': 'Filter',
    'Clear all': 'Clear all',
    'Direct flight': 'Nonstop',
    'Transfer': 'Transfer',
    'DptArrTime': 'Departure - Arrival time',
    'Am': '{time} am',
    'Pm': '{time} pm',
    'Night': '{time} pm',
    'PriceToHigh': 'Lowest price',
    'PriceToLow': 'Highest price',
    'FlightTimeToLate': 'Departure(Earliest)',
    'FlightTimeToMorning': 'Departure(Lastest)',
    'ElapsedTimeToLong': 'Fastest',
    'ElapsedTimeToShort': 'Slowest',
    'Elapsed Time': 'Elapsed Time',
    'Departure Time': 'Departure Time',
    'Airline': 'Airline',
    'Transit city': 'Transit city',
    'You have enough reasons to choose us': 'You have enough reasons to choose us',
    'Service Guarantee': 'Service Guarantee',
    'One-to-one account manager 7 * 24 hours service': 'One-to-one account manager 7 * 24 hours service',
    'Ticket guarantee': 'Ticket guarantee',
    '100% ticket issued after payment': '100% ticket issued after payment',
    'Travel guarantee': 'Travel guarantee',
    'If the passenger cannot handle the flight normally due to the ticket problem, the platform will bear the loss': 'If the passenger cannot handle the flight normally due to the ticket problem, the platform will bear the loss',
    'Turn': 'Turn',
    'Times': 'Times',
    'SELECT': 'SELECT',
    'Class': 'Class',
    'Refund': 'Refund',
    'Change': 'Exchange',
    'Refund&Change': 'Refund & Change',
    'Price': 'Price',
    'People': 'People',
    'Baby': 'Baby',
    'Avg tax-inclusive': 'Avg tax-inclusive',
    'Reservation': 'BOOK',
    'Flight information is empty': 'Flight information is empty',
    'Total duration': 'Total duration',
    'First Class': 'First Class',
    'Business Class': 'Business Class',
    'Economy Class': 'Economy Class',
    'Business/First Class': 'Business/First Class',
    'Economy/Excess Class': 'Economy/Excess Class',
    'from': 'from',
    'Flight details': 'Detail',
    'go trip': 'Depart',
    'return trip': 'Return',
    'Transfer from': '{time} in {city}',
    'stopover': 'Stopover in {city}',
    'Previous step': 'Previous step',
    'Final Confirmation': 'Final Confirmation',
    'Please select passenger nationality': 'Please select passenger nationality',
    'Please select a passenger area code': 'Please select a passenger area code',
    'Please enter contact last name': 'Please enter contact last name',
    'Please enter contact name': 'Please enter contact name',
    'Please select a contact area code': 'Please select a contact area code',
    'Please enter the contact mobile phone number': 'Please enter the contact mobile phone number',
    'Please enter contact email': 'Please enter contact email',
    'Subject to the revised flight time': 'Subject to the revised flight time'
  },
  refundList: {
    'Reviewer': 'Reviewer',
    'Confirm Ticket Refund': 'Confirm Ticket Refund',
    'Are you sure you want to refund the ticket?': 'Are you sure you want to refund the ticket?',
    'Downloading, do not close or refresh the page': 'Downloading, do not close or refresh the page...',
    'Refund form status': 'Refund status',
    'Refund Type': 'Refund Type',
    'Special': 'Special',
    'Voluntary': 'Voluntary',
    'Involuntary': 'Involuntary',
    'Flight change': 'Flight change',
    'Refund due to illness': 'Refund due to illness',
    'Diversion': 'Diversion',
    'Refactor full refund': 'Refactor full refund',
    'Deny boarding': 'Deny boarding',
    'Oversold': 'Oversold',
    'Epidemic': 'Epidemic',
    'Special event': 'Special event',
    'Visa refused': 'Visa refused',
    'Formal full refund': 'Formal full refund',
    'Void ticket‌': 'Void ticket‌',
    'Other': 'Other',
    'Platform ticket number': 'Ticket number',
    'Platform refund order number': 'Refund number',
    'Flight number': 'Flight number',
    'Passenger': 'Passenger',
    'Start date': 'Start date',
    'End date': 'End date',
    'Auto refresh': 'Auto refresh',
    'Query': 'Query',
    'Reset': 'Reset',
    'Refund time': 'Refund Time',
    'Refund Date': 'Refund Date',
    'Abnormal refund': 'Abnormal refund',
    'Abnormal reject': 'Abnormal reject',
    'Refund passenger card has been changed': 'Refund passenger card has been changed',
    'PNR/Route': 'PNR/Route',
    'Refund Fee': 'Refund Fee',
    'Ticket Refund Amount': 'Ticket Refund Amount',
    'Receivable Amount': 'Receivable Amount',
    'Refund Type/Reason': 'Refund Type/Reason',
    'Source/Latest Refund': 'Source/Latest Refund',
    'Refund profit': 'Refund profit',
    'Lock single': 'Lock single',
    'Unlock': 'Unlock',
    'View': 'View',
    'Handle': 'Handle',
    'Refund slip log': 'Refund slip log',
    'Order number': 'Order number',
    'Operator': 'Operator',
    'Refund Applicant': 'Refund Applicant',
    'Refund Persons': 'Refund Persons',
    'Dispatch': 'Dispatch',
    'Account number': 'Account number',
    'Cancel': 'Cancel',
    'Pending process': 'Pending process',
    'Completed': 'Completed',
    'Failed': 'Failed',
    'Please select an account': 'Please select an account',
    'Please select the verification type': 'Please select the verification type',
    'Refund remarks:': 'Refund remarks:',
    'Refund Remarks': 'Refund Remarks',
    'Is ExChange': 'Is ExChange',
    'Financial Notes:': 'Financial Notes:',
    'The refund slip has been approved': 'The refund slip has been approved',
    'Lock': 'Lock',
    'Unlocked successful': 'Unlocked successful',
    'Unlock failed': 'Unlock failed',
    'Start and end dates cannot be null': 'Start and end dates cannot be null',
    'The verification end date must be greater than or equal to the start date': 'The verification end date must be greater than or equal to the start date',
    'The difference between the start date and the end date cannot be greater than 365 days': 'The difference between the start date and the end date cannot be greater than 365 days',
    'Order dispatched successfully': 'Order dispatched successfully',
    'Please wait': 'Please wait...',
    'Ticket Refund Application': 'Ticket Refund Application',
    'Submit request': 'Submit request',
    'Save ticket refund': 'Save ticket refund',
    'Refund Order Information': 'Refund Order Information',
    'Ticket number': 'Ticket number',
    'Refund order number': 'Refund order number',
    'Query Interface': 'Query Interface',
    'Segment Information': 'Segment Information',
    'Ticketing segment information': 'Ticketing segment information',
    'Segment': 'Segment',
    'Type': 'Type',
    'Status': 'Status',
    'Airlines': 'Airlines',
    'Itinerary': 'Itinerary',
    'Flight date': 'Flight date',
    'Cabin': 'Cabin',
    'Refund flight info': 'Refund flight info',
    'Passenger Information': 'Passenger Information',
    'Original passenger info': 'Original passenger info',
    'Passenger status': 'Passenger status',
    'Passenger name': 'Passenger name',
    'Sex': 'Sex',
    'Male': 'Male',
    'Female': 'Female',
    'Price': 'Price',
    'Taxes and Fees': 'Taxes and Fees',
    'Total selling price': 'Total selling price',
    'Please enter a refund fee': 'Please enter a refund fee',
    'Please enter the refund amount': 'Please enter the refund amount',
    'Refund passenger info': 'Refund passenger info',
    'Refund Information': 'Refund Information',
    'Please select': 'Please select',
    'Reason for refund': 'Reason for refund',
    'Please enter content': 'Please enter content',
    'Total refund fee': 'Total refund fee',
    'Total refund': 'Total refund',
    'Refund flight segment cannot be empty': 'Refund flight segment cannot be empty',
    'Refund passengers cannot be empty': 'Refund passengers cannot be empty',
    'Please enter': 'Please enter',
    'Platform refund fee': 'Platform refund fee',
    'Platform Refund': 'Platform Refund',
    'Purchase refund fee': 'Purchase refund fee',
    'Purchase recovery': 'Purchase recovery',
    'Profit': 'Profit',
    'Please enter the total refund charge': 'Please enter the total refund charge',
    'Please select a refund type': 'Please select a refund type',
    'Please enter the total refund amount': 'Please enter the total refund amount',
    'Refund form submitted successfully': 'Refund form submitted successfully',
    'Tips': 'Tips',
    'Successfully obtained ticketing information': 'Successfully obtained ticketing information',
    'Successfully obtained refund information': 'Successfully obtained refund information',
    'Please enter the correct number': 'Please enter the correct number',
    'Normal': 'Normal',
    'Issue tickets': 'Issue tickets',
    'Refund': 'Refund',
    'Change book': 'Exchange',
    'Changed': 'Changed',
    'Exception': 'Exception',
    'Ticket refund': 'Ticket refund',
    'Ticket refund application': 'Ticket refund application',
    'Refund Details': 'Refund Details',
    'Modification': 'Modification',
    'Secondary Reason for Reject': 'Secondary Reason for Reject',
    'Total ticket price': 'Total ticket price',
    'Ticket time': 'Ticket time',
    'Children': 'Children',
    'Operation': 'OP',
    'Purchase Amount': 'Purchase Amount',
    'Change': 'Exchange',
    'Ticket number verification': 'Ticket number verification',
    'Refund rejected': 'Refund rejected',
    'Unlock and handle': 'Unlock and handle',
    'Airline refund rules': 'Airline refund rules',
    'Please enter the refund order number': 'Please enter the refund order number',
    'Total refund amount': 'Total refund amount',
    'Ticket Remarks': 'Ticket Remarks',
    'Save refund notes': 'Save refund notes',
    'Save Ticket Notes': 'Save Ticket Notes',
    'Save financial notes': 'Save financial notes',
    'Order log': 'Order log',
    'Edit Products': 'Edit Products',
    'Policy Type': 'Policy Type',
    'Clearance Products': 'Clearance Products',
    'Business travel products': 'Business travel products',
    'Transit': 'Transit',
    'Transit products': 'Transit products',
    'Charter airline': 'Charter airline',
    'Cut position': 'Cut position',
    'Airline VIP': 'Airline VIP',
    'General Policy': 'General Policy',
    'Prepayment Policy': 'Prepayment Policy',
    'Team Policy': 'Team Policy',
    'Special Policy': 'Special Policy',
    'K-bit policy': 'K-bit policy',
    'Fixed price': 'Fixed price',
    'Applicable spaces': 'Applicable spaces',
    'Directly connected': 'Directly connected',
    'Type of sale': 'Type of sale',
    'Solid hatch': 'Solid hatch',
    'See hatch': 'See hatch',
    'Policy code format': 'Policy code format',
    'None': 'None',
    'Additional airline code': 'Additional airline code',
    'Additional delivery time (time and space)': 'Additional delivery time (time and space)',
    'Delivery Type': 'Delivery Type',
    'Total + increment': 'Total + increment',
    'Full quantity only': 'Full quantity only',
    'Increment only': 'Increment only',
    'Delete policy on increment': 'Delete policy on increment',
    'Yes': 'Yes',
    'No': 'No',
    'Delete type': 'Delete type',
    'By policy code': 'By policy code',
    'By delivery time': 'By delivery time',
    'Reimbursement Type': 'Reimbursement Type',
    'Invoice': 'Invoice',
    'Itinerary + Difference Invoice': 'Itinerary + Difference Invoice',
    'Office number': 'Office number',
    'IATA number': 'IATA number',
    'Drop in superior cabinet': 'Drop in superior cabinet',
    'Reservation': 'Reservation',
    'Machine Wine Package': 'Machine Wine Package',
    'Sharing': 'Sharing',
    'Support stopping': 'Support stopping',
    'Support children': 'Support children',
    'Tariff rules': 'Tariff rules',
    'Return and Change ID': 'Return and Change ID',
    'Place a Fare': 'Place a Fare',
    'Price Type': 'Price Type',
    'Official website price': 'Official website price',
    'Settlement price': 'Settlement price',
    'Specify Fare': 'Specify Fare',
    'Y cabin discount': 'Y cabin discount',
    'Special Ticket Instructions': 'Special Ticket Instructions',
    'Minimum age limit': 'Minimum age limit',
    'Maximum age limit': 'Maximum age limit',
    'Refund Review': 'Refund Review',
    'Audit Results': 'Audit Results',
    'Do not pass': 'Do not pass',
    'Reason for rejection': 'Reason for rejection',
    'Please select a reason for rejection': 'Please select a reason for rejection',
    'Provide involuntary supporting materials': 'Provide involuntary supporting materials',
    'Cancel Retention Change': 'Cancel Retention Change',
    'Ticket number is not OPEN status': 'Ticket number is not OPEN status',
    'The policy does not match and cannot be refunded': 'The policy does not match and cannot be refunded',
    'Exchange for a refund': 'Exchange for a refund',
    'Partial refund': 'Partial refund',
    'Secondary Reason for Rejection': 'Secondary Reason for Rejection',
    'Please select a secondary reason for rejection': 'Please select a secondary reason for rejection',
    'Insufficient materials for involuntary refunds': 'Insufficient materials for involuntary refunds',
    'The content of the involuntary refund materials': 'The content of the involuntary refund materials',
    'The supplier contacts the airline to change the visa and needs a refund from the airline': 'The supplier contacts the airline to change the visa and needs a refund from the airline.',
    'The guest contacts the airline to change the booking and needs a refund from the airline': 'The guest contacts the airline to change the booking and needs a refund from the airline.',
    'The changed ticket number is required': 'The changed ticket number is required.',
    'Does not comply with special policies': 'Does not comply with special policies',
    'Does not meet the rules of aeronautical change': 'Does not meet the rules of aeronautical change',
    'Protection flight confirmed': 'Protection flight confirmed',
    'Ticket used': 'Ticket used',
    'Ticket checked in': 'Ticket checked in',
    'Airline has retreated': 'Airline has retreated',
    'Need to unhook': 'Need to unhook',
    'Follow the used segment ticket number USED': 'Follow the used segment ticket number USED',
    'Can t refund a single paragraph ': 'Can t refund a single paragraph',
    'Wrong payment amount': 'Wrong payment amount',
    'No refund policy needs to be cancelled and changed': 'No refund policy needs to be cancelled and changed',
    'Itinerary to be voided': 'Itinerary to be voided',
    'Ctrip asks to refuse an order': 'Ctrip asks to refuse an order',
    'Vulnerable ticket': 'Vulnerable ticket',
    'Associated child and infant tickets cannot be refundable single': 'Associated child and infant tickets cannot be refundable single',
    'Only vouchers can be refunded': 'Only vouchers can be refunded',
    'Charter flights are non-refundable': 'Charter flights are non-refundable.',
    'Ticket has expirated': 'Ticket has expirated',
    'Ticket desk collapse/airline bankruptcy': 'Ticket desk collapse/airline bankruptcy',
    'Remarks': 'Remarks',
    'Affirmation': 'Affirmation',
    'Turn to an appeal': 'Turn to an appeal',
    'Type of appeal': 'Type of appeal',
    'Quality inspection': 'Quality inspection',
    'Our company appeals': 'Our company appeals',
    'Appeal Amount': 'Appeal Amount',
    'Appeal Remarks': 'Appeal Remarks',
    'Attachments': 'Attachments',
    'Click to upload': 'Click to upload',
    'Save': 'Save',
    'Abnormal verification': 'Abnormal verification',
    'Please enter the purchase refund fee': 'Please enter the purchase refund fee',
    'Please enter purchase rebate': 'Please enter purchase rebate',
    'Rejected verification': 'Rejected verification.',
    'Has the ticket been refunded': 'Has the ticket been refunded',
    'Please enter airline refund charge': 'Please enter airline refund charge',
    'Please enter airline return': 'Please enter airline return',
    'Exception Note': 'Exception Note',
    'Submit': 'Submit',
    'Verification channel': 'Verification channel',
    'Where to go': 'Where to go',
    'Departure airport code': 'Departure airport code',
    'Arrival airport code': 'Arrival airport code',
    'Departure time': 'Departure time',
    'Ticket number status': 'Ticket number status',
    'Fare price': 'Fare price',
    'China Eastern Airlines NDC Refund': 'China Eastern Airlines NDC Refund',
    'Is it refundable?': 'Is it refundable?',
    'Refundable': 'Refundable',
    'Non-refundable': 'Non-refundable',
    'Non-refundable cause': 'Non-refundable cause',
    'Refund confirmation': 'Refund confirmation',
    'Adult cabin': 'Adult cabin',
    'Children s Cabin ': 'Children s Cabin',
    'Select flight date': 'Select flight date',
    'Select departure time': 'Select departure time',
    'Arrival time': 'Arrival time',
    'Select time of arrival': 'Select time of arrival',
    'Modify the latest refund time': 'Modify the latest refund time',
    'Latest refund time': 'Latest refund time',
    'Please select profit type': 'Please select profit type',
    'Airline cannot be empty': 'Airline cannot be empty',
    'Departure airport code cannot be empty': 'Departure airport code cannot be empty',
    'Arrival airport code cannot be empty': 'Arrival airport code cannot be empty',
    'Flight number cannot be empty': 'Flight number cannot be empty',
    'Adult cabin cannot be empty': 'Adult cabin cannot be empty',
    'Children s cabin cannot be empty ': 'Children s cabin cannot be empty',
    'Please select a flight date': 'Please select a flight date',
    'Please select departure time': 'Please select departure time',
    'Please select an arrival time': 'Please select an arrival time',
    'The latest refund time cannot be empty': 'The latest refund time cannot be empty',
    'Please select the refund form status': 'Please select the refund form status',
    'Please select appeal type': 'Please select appeal type',
    'Please select a passenger': 'Please select a passenger',
    'Please fill in the appeal amount': 'Please fill in the appeal amount',
    'Please fill in the remarks': 'Please fill in the remarks',
    'Please fill in the reason for rejection': 'Please fill in the reason for rejection',
    'Please select whether the ticket has been refunded': 'Please select whether the ticket has been refunded',
    'Please fill in the exception notes': 'Please fill in the exception notes',
    'Voyage': 'Voyage',
    'Segment back': 'Segment back',
    'Material return': 'Material return',
    'Voluntary refund': 'Voluntary refund',
    'Modify the latest refund time successfully': 'Modify the latest refund time successfully',
    'Modified segment information successfully': 'Modified segment information successfully',
    'Switched off': 'Switched off',
    'Passenger is boarding': 'Passenger is boarding',
    'Checking in': 'Checking in',
    'Ticket Valid': 'Ticket Valid',
    'The ticket has been exchanged for a paper ticket': 'The ticket has been exchanged for a paper ticket',
    'Ticket has been refunded': 'Ticket has been refunded',
    'Ticket has been suspended': 'Ticket has been suspended',
    'Void': 'Void',
    'The format of the ticket number is wrong, it can only be 6, 7, and 13': 'The format of the ticket number is wrong, it can only be 6, 7, and 13',
    'Deleted attachment successful': 'Deleted attachment successful',
    'Failed to delete attachment, reason:': 'Failed to delete attachment, reason:',
    'Exceptionally successful verification': 'Exceptionally successful verification',
    'The verification was rejected successfully': 'The verification was rejected successfully.',
    'The verification failed due to:': 'The verification failed due to:',
    'Airline Refund Fee': 'Airline Refund Fee',
    'Airline returns': 'Airline returns',
    'The abnormal operation of the refund was successful': 'The abnormal operation of the refund was successful',
    'The abnormal operation of refund failed. Reason:': 'The abnormal operation of refund failed. Reason:',
    'Abnormal rejection operation successful': 'Abnormal rejection operation successful',
    'Abnormal rejection operation failed, reason:': 'Abnormal rejection operation failed, reason:',
    'Please select the passenger who needs to refund the ticket': 'Please select the passenger who needs to refund the ticket',
    'Select the passenger, please enter the refund fee': 'Select the passenger, please enter the refund fee',
    'Select the passenger, please enter the refund amount': 'Select the passenger, please enter the refund amount',
    'Please select the flight segment that needs to be refunded': 'Please select the flight segment that needs to be refunded',
    'Please enter the reason for the refund': 'Please enter the reason for the refund',
    'Please enter a refund rates': 'Please enter a refund rates',
    'Please enter refund and return': 'Please enter refund and return',
    'Please enter refund profit': 'Please enter refund profit',
    'Submit refund successfully': 'Submit refund successfully',
    'Modified the refund form successfully': 'Modified the refund form successfully',
    'Confirm the refund form status to change': 'Confirm the refund form status to change',
    'Is it?': 'Is it?',
    'Modified the status of the refund form successfully': 'Modified the status of the refund form successfully',
    'Failed to modify the status of the refund form. Reason:': 'Failed to modify the status of the refund form. Reason:',
    'Modify the refund form status and the order is successful': 'Modify the refund form status and the order is successful',
    'The order failed to modify the status of the refund form. Reason:': 'The order failed to modify the status of the refund form. Reason:',
    'Modify the refund status successfully': 'Modify the refund status successfully',
    'Failed to modify the refund status, reason:': 'Failed to modify the refund status, reason:',
    'Are you sure you want to return the order?': 'Are you sure you want to return the order?',
    'Are you sure the status of the refund order is changed to refund and cancel?': 'Are you sure the status of the refund order is changed to refund and cancel?',
    'Good to go': 'Good to go',
    'The refund review failed. Reason:': 'The refund review failed. Reason:',
    'Refund completed successfully': 'Refund completed successfully',
    'Refund completion failed, reason:': 'Refund completion failed, reason:',
    'Confirm that the refund is complete?': 'Confirm that the refund is complete?',
    'Refund successful': 'Refund successful',
    'Refund failed, reason:': 'Refund failed, reason:',
    'Confirm review confirmation?': 'Confirm review confirmation?',
    'Review confirmed successful': 'Review confirmed successful',
    'Review confirmation failed, reason:': 'Review confirmation failed, reason:',
    'Confirm the verification of the refund?': 'Confirm the verification of the refund?',
    'Successful verification of refund': 'Successful verification of refund',
    'The verification of the refund failed. Reason:': 'The verification of the refund failed. Reason:',
    'Please enter the platform refund verification amount': 'Please enter the platform refund verification amount',
    'Please enter the platform refund verification time': 'Please enter the platform refund verification time',
    'Save the platform refund and verify the account successfully': 'Save the platform refund and verify the account successfully',
    'The save platform refund verification failed. Reason:': 'The save platform refund verification failed. Reason:',
    'Please enter the purchase refund verification amount': 'Please enter the purchase refund verification amount',
    'Please enter the time of the purchase refund bill': 'Please enter the time of the purchase refund bill',
    'Save the purchase receipt and verify the account successfully': 'Save the purchase receipt and verify the account successfully',
    'Failed to save the purchase receipt for verification. Reason:': 'Failed to save the purchase receipt for verification. Reason:',
    'Delete the platform refund and verify the account successfully': 'Delete the platform refund and verify the account successfully',
    'Delete platform refund verification failed, reason:': 'Delete platform refund verification failed, reason:',
    'Delete the purchase receipt and verify the account successfully': 'Delete the purchase receipt and verify the account successfully',
    'Delete the purchase receipt verification failed. Reason:': 'Delete the purchase receipt verification failed. Reason:',
    'The platform refund amount and time cannot be empty!': 'The platform refund amount and time cannot be empty!',
    'The purchase refund amount and time cannot be empty!': 'The purchase refund amount and time cannot be empty!',
    'Settlement was abnormally successful': 'Settlement was abnormally successful',
    'Settlement failed abnormally, reason:': 'Settlement failed abnormally, reason:',
    'Settlement exception handled successfully': 'Settlement exception handled successfully',
    'The settlement exception has been handled and failed. Reason:': 'The settlement exception has been handled and failed. Reason:',
    'The refund amount and time cannot be empty!': 'The refund amount and time cannot be empty!',
    'Payment successful': 'Payment successful',
    'The refund failed. Reason:': 'The refund failed. Reason:',
    'Are you sure you want to close the current page?': 'Are you sure you want to close the current page?',
    'Are you sure to unlock and close?': 'Are you sure to unlock and close?',
    'Unlocked and processed successfully': 'Unlocked and processed successfully',
    'Modify the remarks form successfully': 'Modify the remarks form successfully',
    'Failed to modify the remarks on the refund form. Reason:': 'Failed to modify the remarks on the refund form. Reason:',
    'The remarks on the refund form cannot be empty!': 'The remarks on the refund form cannot be empty!',
    'Modify the ticket and note successfully': 'Modify the ticket and note successfully',
    'Failed to modify the remarks on the ticket. Reason:': 'Failed to modify the remarks on the ticket. Reason:',
    'Failed to modify the ticketing remarks. Reason: The ticketing remarks cannot be empty!': 'Failed to modify the ticketing remarks. Reason: The ticketing remarks cannot be empty!',
    'Modified Financial Remarks Successfully': 'Modified Financial Remarks Successfully',
    'Failed to modify financial remarks, reason:': 'Failed to modify financial remarks, reason:',
    'Failed to modify financial remarks. Reason: Financial remarks cannot be empty!': 'Failed to modify financial remarks. Reason: Financial remarks cannot be empty!',
    'Product information is empty': 'Product information is empty',
    'China Eastern Airlines NDC refund successfully': 'China Eastern Airlines NDC refund successfully',
    'China Eastern Airlines NDC refund failed, reason:': 'China Eastern Airlines NDC refund failed, reason:',
    'Parameter error, please resubmit': 'Parameter error, please resubmit.',
    'Normal refund': 'Normal refund',
    'Repeat/Cancel Refund': 'Repeat/Cancel Refund',
    'Special operation refund': 'Special operation refund',
    'Refund Reissue': 'Refund Reissue',
    'No refund reminder time set': 'No time set',
    'After flight': 'After flight',
    'Confirm': 'Confirm',
    'Refund time has passed': 'Refund time has passed',
    'Confirmation Countdown': 'Confirmation Countdown'
  },
  change: {
    'Up to three files can be chosen': 'Up to three files can be chosen',
    'Timed out': 'Timed out',
    'Countdown': 'Countdown',
    'Re-Submit': 'Re-Submit',
    'Deadline': 'Deadline',
    'Pending review': 'Pending review',
    'Pending ticket issuance': 'Pending ticket issuance',
    'Pending payment': 'Pending payment',
    'Completed': 'Completed',
    'Exchange Status': 'Exchange Status',
    'Exchange Type': 'Exchange Type',
    'Ticket number': 'Ticket number',
    'Exchange No': 'Exchange No',
    'Original PNR': 'Original PNR',
    'Flight number': 'Flight number',
    'Passenger': 'Passenger',
    'Change Start': 'Change Start',
    'Change End': 'Change End',
    'Auto refresh': 'Auto refresh',
    'Query': 'Query',
    'Reset': 'Reset',
    'Exchange Time': 'Exchange Time',
    'New ticket number': 'New ticket number',
    'Latest Exchange': 'Latest Exchange',
    'Change flight information': 'Change flight information',
    'Exchange Type/Reason': 'Exchange Type/Reason',
    'Exchange Amount': 'Exchange Amount',
    'Lock single': 'Lock single',
    'Unlock': 'Unlock',
    'View': 'View',
    'Handle': 'Handle',
    'Go to pay': 'Go to pay',
    'Change the signing log': 'Change the signing log',
    'Order number': 'Order number',
    'Operator': 'Operator',
    'Exchange Account': 'Exchange Account',
    'Dispatch': 'Dispatch',
    'Account number': 'Account number',
    'Cancel': 'Cancel',
    'Please select the verification type': 'Please select the verification type',
    'Please select an account': 'Please select an account',
    'Unknown': 'Unknown',
    'Voluntary': 'Voluntary',
    'Involuntary': 'Involuntary',
    'Failed': 'Failed',
    'The order has been changed': 'The order has been changed.',
    'Lock': 'Lock',
    'Unlocked successful': 'Unlocked successful',
    'Unlock failed': 'Unlock failed!',
    'Start and end dates cannot be null': 'Start and end dates cannot be null',
    'The verification end date must be greater than or equal to the start date': 'The verification end date must be greater than or equal to the start date',
    'Inquire about abnormal employee dispatch orders': 'Inquire about abnormal employee dispatch orders.',
    'The difference between the start date and the end date cannot be greater than 365 days': 'The difference between the start date and the end date cannot be greater than 365 days',
    'Change details': 'Change details',
    'Exchange Order Information': 'Exchange Order Information',
    'Please select': 'Please select',
    'Change PNR': 'Change PNR',
    'Modification': 'Modification',
    'Segment Information': 'Segment Information',
    'Original flight info': 'Original flight info',
    'Original passenger': 'Original passenger',
    'Exchanged passenger': 'Exchanged passenger',
    'Segment': 'Segment',
    'Type': 'Type',
    'Status': 'Status',
    'Itinerary': 'Itinerary',
    'Flight date': 'Flight date',
    'Cabin': 'Cabin',
    'Adult': 'Adult',
    'Children': 'Children',
    'Operation': 'OP',
    'Exchanged flight info': 'Exchanged flight info',
    'Passenger Information': 'Passenger Information',
    'Change method': 'Change method',
    'Not changed': 'Not changed',
    'Normal change': 'Normal change',
    'Special change': 'Special change',
    'Refund return': 'Refund return',
    'Passenger name': 'Passenger name',
    'Price': 'Price',
    'Taxes and Fees': 'Taxes & Fees',
    'Total selling price': 'Total selling price',
    'Purchase Amount': 'Purchase Amount',
    'Original PNR/New PNR': 'Original PNR/New PNR',
    'Please enter a new PNR': 'Please enter a new PNR',
    'Original ticket number/new ticket number': 'Original ticket number/new ticket number',
    'Please enter a new ticket number': 'Please enter a new ticket number',
    'Rescheduling Fee': 'Rescheduling Fee',
    'Please enter rescheduling charge': 'Please enter rescheduling charge',
    'Fare difference': 'Fare difference',
    'Please enter the fare difference': 'Please enter the fare difference',
    'Profit': 'Profit',
    'Please enter purchase rebate': 'Please enter purchase rebate',
    'Save the change': 'Save the change',
    'Change Review': 'Change Review',
    'Refuse to change': 'Refuse to change',
    'Refuse to ticket': 'Refuse to ticket',
    'Change Information': 'Change Information',
    'Confirm change': 'Confirm change',
    'Please enter the order number': 'Please enter the order number',
    'Reason for change': 'Reason for change',
    'Total Rescheduling Fee': 'Total Rescheduling Fee',
    'Total fare difference': 'Total fare difference',
    'Change the amount receivable': 'Change the amount receivable',
    'Change the total settlement price': 'Change the total settlement price',
    'After adding the purchase record, the payment amount is automatically assigned to this field': 'After adding the purchase record, the payment amount is automatically assigned to this field',
    'Please enter content': 'Please enter content',
    'Change total profit': 'Change total profit',
    'Exchange Remarks': 'Exchange Remarks',
    'Save exchange remarks': 'Save exchange remarks',
    'Order log': 'Order log',
    'Please select a passenger': 'Please select a passenger',
    'Procurement channels': 'Procurement channels',
    'Please select a purchasing channel': 'Please select a purchasing channel',
    'Payment Channels': 'Payment Channels',
    'Please select a payment channel': 'Please select a payment channel',
    'Please select a type': 'Please select a type',
    'Expenditure': 'Expenditure',
    'Income': 'Income',
    'Purchase space': 'Purchase space',
    'Purchase order number': 'Purchase order number',
    'Purchase account': 'Purchase account',
    'Purchase Password': 'Purchase Password',
    'Payment Password': 'Payment Password',
    'Transaction No': 'Transaction No',
    'Purchase Fare': 'Purchase Fare',
    'Payment Amount': 'Payment Amount',
    'Offer Type': 'Offer Type',
    'Please select offer type': 'Please select offer type',
    'Red Packet': 'Red Packet',
    'Coupon': 'Coupon',
    'Stored value card': 'Stored value card',
    'Integral': 'Integral',
    'Discount Amount': 'Discount Amount',
    'Offer logo': 'Offer logo',
    'Purchase Remarks': 'Purchase Remarks',
    'Agency Fee': 'Agency Fee',
    'Agency rates': 'Agency rates',
    'Save': 'Save',
    'Product name': 'Product name',
    'Policy Type': 'Policy Type',
    'Clearance Products': 'Clearance Products',
    'Business travel products': 'Business travel products',
    'Transit': 'Transit',
    'Transit products': 'Transit products',
    'Charter airline': 'Charter airline',
    'Cut position': 'Cut position',
    'Airline VIP': 'Airline VIP',
    'Special': 'Special',
    'General Policy': 'General Policy',
    'Prepayment Policy': 'Prepayment Policy',
    'Team Policy': 'Team Policy',
    'Special Policy': 'Special Policy',
    'K-bit policy': 'K-bit policy',
    'Fixed price': 'Fixed price',
    'Applicable spaces': 'Applicable spaces',
    'Directly connected': 'Directly connected',
    'Type of sale': 'Type of sale',
    'Solid hatch': 'Solid hatch',
    'See hatch': 'See hatch',
    'Policy code': 'Policy code',
    'Policy code format': 'Policy code format',
    'None': 'None',
    'Additional airline code': 'Additional airline code',
    'Additional delivery time (time and space)': 'Additional delivery time (time and space)',
    'Delivery Type': 'Delivery Type',
    'Total + increment': 'Total + increment',
    'Full quantity only': 'Full quantity only',
    'Increment only': 'Increment only',
    'Delete policy on increment': 'Delete policy on increment',
    'Yes': 'Yes',
    'No': 'No',
    'Delete type': 'Delete type',
    'By policy code': 'By policy code',
    'By delivery time': 'By delivery time',
    'Reimbursement Type': 'Reimbursement Type',
    'Invoice': 'Invoice',
    'Itinerary + Difference Invoice': 'Itinerary + Difference Invoice',
    'Office number': 'Office number',
    'IATA number': 'IATA number',
    'Drop in superior cabinet': 'Drop in superior cabinet',
    'Reservation': 'Reservation',
    'Machine Wine Package': 'Machine Wine Package',
    'Share': 'Share',
    'Support stopping': 'Support stopping',
    'Support children': 'Support children',
    'Tariff rules': 'Tariff rules',
    'Return and Change ID': 'Return and Change ID',
    'Place a Fare': 'Place a Fare',
    'Price Type': 'Price Type',
    'Official website price': 'Official website price',
    'Settlement price': 'Settlement price',
    'Specify Fare': 'Specify Fare',
    'Y cabin discount': 'Y cabin discount',
    'Special Ticket Instructions': 'Special Ticket Instructions',
    'Minimum age limit': 'Minimum age limit',
    'Maximum age limit': 'Maximum age limit',
    'Turn to an appeal': 'Turn to an appeal',
    'Type of appeal': 'Type of appeal',
    'Platform Refund': 'Platform Refund',
    'Quality inspection': 'Quality inspection',
    'Our company appeals': 'Our company appeals',
    'Appeal Amount': 'Appeal Amount',
    'Appeal Remarks': 'Appeal Remarks',
    'Attachments': 'Attachments',
    'Click to upload': 'Click to upload',
    'Only supports': 'Only supports',
    'Upload up to 3 files': 'Upload up to 3 files',
    'Change Cancel': 'Change Cancel',
    'Reject reason': 'Reject reason',
    'Affirmation': 'Affirmation',
    'Airlines': 'Airlines',
    'Departure airport code': 'Departure airport code',
    'Arrival airport code': 'Arrival airport code',
    'Adult cabin': 'Adult cabin',
    'Children s Cabin': 'Children s Cabin',
    'Select flight date': 'Select flight date',
    'Departure time': 'Departure time',
    'Select departure time': 'Select departure time',
    'Arrival time': 'Arrival time',
    'Select time of arrival': 'Select time of arrival',
    'Reason for rejection': 'Reason for rejection',
    'Verification channel': 'Verification channel',
    'Where to go': 'Where to go',
    'Ticket number status': 'Ticket number status',
    'Fare price': 'Fare price',
    'Modify the latest change time': 'Modify the latest change time',
    'Purchase channel cannot be empty': 'Purchase channel cannot be empty',
    'Type cannot be null': 'Type cannot be null',
    'Purchase order number cannot be null': 'Purchase order number cannot be null',
    'The transaction serial number cannot be null': 'The transaction serial number cannot be null',
    'Payment amount cannot be empty': 'Payment amount cannot be empty',
    'The discount amount cannot be empty, it can be 0': 'The discount amount cannot be empty, it can be 0',
    'Please select a refund method': 'Please select a refund method',
    'Please fill in the reason for rejection': 'Please fill in the reason for rejection',
    'Please select appeal type': 'Please select appeal type',
    'Please fill in the appeal amount': 'Please fill in the appeal amount',
    'Airline cannot be empty': 'Airline cannot be empty',
    'please enter a number': 'please enter a number',
    'Charge': 'Charge',
    'Please Fill in': 'Please Fill in',
    'Departure airport code cannot be empty': 'Departure airport code cannot be empty',
    'Arrival airport code cannot be empty': 'Arrival airport code cannot be empty',
    'Flight number cannot be empty': 'Flight number cannot be empty',
    'Adult cabin cannot be empty': 'Adult cabin cannot be empty',
    'Children s cabin cannot be empty': 'Children s cabin cannot be empty',
    'Please select a flight date': 'Please select a flight date',
    'Please select departure time': 'Please select departure time',
    'Please select an arrival time': 'Please select an arrival time',
    'Please select the latest change time': 'Please select the latest change time',
    'Please select flight segment': 'Please select flight segment',
    'Modify the latest change time successfully': 'Modify the latest change time successfully',
    'Success~': 'Success~',
    'Please enter the correct number': 'Please enter the correct number',
    'Are you sure you want to close the current page?': 'Are you sure you want to close the current page?',
    'Tips': 'Tips',
    'Are you sure to unlock and close?': 'Are you sure to unlock and close?',
    'Flight number cannot be less than three': 'Flight number cannot be less than three',
    'Departure airport code must be three digitals': 'Departure airport code must be three digitals',
    'Arrival airport code must be three digitals': 'Arrival airport code must be three digitals',
    'Selected passengers and flight segments have been changed, please select again': 'Selected passengers and flight segments have been changed, please select again!',
    'New PNR': 'New PNR',
    'Platform rescheduling fee': 'Platform rescheduling fee',
    'Platform Upgrade Fee': 'Platform Upgrade Fee',
    'Purchase Rescheduling Fee': 'Purchase Rescheduling Fee',
    'Purchase fare difference': 'Purchase fare difference',
    'Purchase refund fee': 'Purchase refund fee',
    'Purchase recovery': 'Purchase recovery',
    'Please enter the total platform rescheduling fee': 'Please enter the total platform rescheduling fee',
    'Please enter the total platform fare difference': 'Please enter the total platform fare difference',
    'Please enter the change amount receivable': 'Please enter the change amount receivable',
    'Please enter the total settlement price': 'Please enter the total settlement price',
    'Please enter the total profit of the change': 'Please enter the total profit of the change',
    'Change the signature and save it successfully': 'Change the signature and save it successfully',
    'Confirm that the review is complete?': 'Confirm that the review is complete?',
    'Submit': 'Submit',
    'Review completed successfully': 'Review completed successfully',
    'Audit completion failed, reason:': 'Audit completion failed, reason:',
    'Change rejected successfully': 'Change rejected successfully',
    'Change rejection failed, reason:': 'Change rejection failed, reason:',
    'The platform refund amount and time cannot be empty': 'The platform refund amount and time cannot be empty!',
    'Settlement was abnormally successful': 'Settlement was abnormally successful',
    'Settlement failed abnormally, reason:': 'Settlement failed abnormally, reason:',
    'Settlement exception handled successfully': 'Settlement exception handled successfully',
    'The settlement exception has been handled and failed. Reason:': 'The settlement exception has been handled and failed. Reason:',
    'Audit completed successfully': 'Audit completed successfully',
    'The verification failed. Reason:': 'The verification failed. Reason:',
    'Payment successful': 'Payment successful',
    'The refund failed. Reason:': 'The refund failed. Reason:',
    'Please fill in the reason for cancelation': 'Please fill in the reason for cancelation',
    'Reject successfully': 'Reject successfully',
    'Unable to perform rejection，reason：': 'Unable to perform rejection，reason：',
    'Converted to appeal form successfully': 'Converted to appeal form successfully',
    'Please select the passenger who needs to be rescheduled': 'Please select the passenger who needs to be rescheduled',
    'Please enter the rescheduling fee': 'Please enter the rescheduling fee',
    'Please enter the upgrade fee for the selected passenger': 'Please enter the upgrade fee for the selected passenger',
    'Please select the flight segment to be rebooked': 'Please select the flight segment to be rebooked',
    'Please enter the': 'Please enter the',
    'Flight number to change flight information': 'Flight number to change flight information',
    'Departure point for changing flight information': 'Departure point for changing flight information',
    'Arrival place for changing flight information': 'Arrival place for changing flight information',
    'Flight dates for changing flight information': 'Flight dates for changing flight information',
    'Take-off and landing time for changing flight information': 'Take-off and landing time for changing flight information',
    'Class code for changing flight information': 'Class code for changing flight information',
    'Please enter the change order number': 'Please enter the change order number',
    'Please enter Change PNR': 'Please enter Change PNR',
    'Please select a change type': 'Please select a change type',
    'Please enter the reason for the change': 'Please enter the reason for the change',
    'Please enter the total rescheduling charge': 'Please enter the total rescheduling charge',
    'Please enter the total fare difference': 'Please enter the total fare difference',
    'Please enter the amount receivable': 'Please enter the amount receivable',
    'Please enter the change ticket settlement price': 'Please enter the change ticket settlement price',
    'Please enter change profit': 'Please enter change profit',
    'Submit change successfully': 'Submit change successfully',
    'New purchase record successful': 'New purchase record successful!',
    'Deleted purchase record successfully': 'Deleted purchase record successfully',
    'Modify the remarks form successfully': 'Modify the remarks form successfully',
    'Failed to modify the remarks on the refund form. Reason:': 'Failed to modify the remarks on the refund form. Reason:',
    'The remarks on the refund form cannot be empty': 'The remarks on the refund form cannot be empty!',
    'Modified Financial Remarks Successfully': 'Modified Financial Remarks Successfully',
    'Failed to modify financial remarks, reason:': 'Failed to modify financial remarks, reason:',
    'Failed to modify financial remarks. Reason: Financial remarks cannot be empty': 'Failed to modify financial remarks. Reason: Financial remarks cannot be empty!',
    'Modify and change the order status and the order is successful': 'Modify and change the order status and the order is successful',
    'The order failed to modify and change the signing status. Reason:': 'The order failed to modify and change the signing status. Reason:',
    'Modified segment information successfully': 'Modified segment information successfully',
    'Product information is empty': 'Product information is empty',
    'Parameter error, please resubmit': 'Parameter error, please resubmit',
    'Ticket Change Application': 'Ticket Change Application',
    'Get change information': 'Get change information',
    'Ticketing segment information': 'Ticketing segment information',
    'Original passenger info': 'Original passenger info',
    'Change passenger info': 'Change passenger info',
    'Next step': 'Next step',
    'The passenger cannot be empty': 'The passenger cannot be empty',
    'Payment channel cannot be empty': 'Payment channel cannot be empty',
    'Purchase account cannot be empty': 'Purchase account cannot be empty',
    'Purchase password cannot be null': 'Purchase password cannot be null',
    'The discount amount cannot be empty': 'The discount amount cannot be empty',
    'Change flight segment cannot be empty': 'Change flight segment cannot be empty',
    'Change the passenger cannot be empty': 'Change the passenger cannot be empty',
    'The new ticket number is incorrect': 'The new ticket number is incorrect',
    'Please enter the total platform change fee': 'Please enter the total platform change fee',
    'Save and change the order successfully': 'Save and change the order successfully',
    'Successfully obtained ticketing information': 'Successfully obtained ticketing information',
    'Get the change information successfully': 'Get the change information successfully',
    'Purchase type cannot be empty': 'Purchase type cannot be empty!',
    'The purchasing channel cannot be empty': 'The purchasing channel cannot be empty!',
    'The payment channel cannot be empty': 'The payment channel cannot be empty!',
    'The purchase account cannot be empty': 'The purchase account cannot be empty!',
    'Purchase password cannot be empty': 'Purchase password cannot be empty!',
    'The purchase order number cannot be empty': 'The purchase order number cannot be empty!',
    'The transaction serial number cannot be empty': 'The transaction serial number cannot be empty!'
  },
  tableHeader: {
    'Pax': 'Pax',
    'Order No': 'Order No.',
    'Total Amount': 'Total Amount',
    'Route': 'Route',
    'Status': 'Status',
    'Locker': 'Locker',
    'Departure Airport': 'Departure Airport',
    'Arrival Airport': 'Arrival Airport',
    'Airport': 'Airport',
    'Country': 'Country',
    'Currency': 'Currency',
    'Symbol': 'Symbol',
    'CNY': 'CNY',
    'Exchange Rate': 'Exchange Rate',
    'Full Name': 'Full Name',
    'Abbreviation': 'Abbreviation',
    'Refund No': 'Refund No',
    'Cabin': 'Cabin',
    'Departure\/Arrival': 'Departure\/Arrival'
  },
  adjustPrice: {
    'Target Purchasers': 'Target Purchasers',
    'Departure City': 'Departure City',
    'Arrival City': 'Arrival City',
  },
  flightChange: {
    'City': 'City',
    'Departure city code': 'Departure city code',
    'Arrival city code': 'Arrival city code',
    'Original Flight': 'Original Flight',
    'New Flight': 'New Flight',
    'Flight Change': 'Flight Change',
    'Flight Change Date': 'Flight Change Date',
    'Batch OP': 'Batch OP',
    'Original Departure\\Arrival Time': 'Original Departure\\Arrival Time',
    'New Departure\\Arrival Time': 'New Departure\\Arrival Time',
    'Original Flight No': 'Original Flight No',
    'New Flight No': 'New Flight No',
    'Original Departure\\Arrival City': 'Original Departure\\Arrival City',
    'New Departure\\Arrival City': 'New Departure\\Arrival City',
    'Original Departure\\Arrival Tower': 'Original Departure\\Arrival Tower',
    'New Departure\\Arrival Tower': 'New Departure\\Arrival Tower',
    'Original Flight Date': 'Original Flight Date',
    'New Flight Date': 'New Flight Date',
    'Operating Time': 'Operating time',
    'Operator': 'Operator',
    '未知': 'Unknow',
    '取消': 'Cancelled',
    '更改': 'Change',
    '保护': 'Protect',
    '航班变更': 'Flight change',
    '出发时间变更': 'Departure time change',
    '到达时间变更': 'Arrival time change',
    '出发机场变更': 'Departure airport change',
    '到达机场变更': 'Arrival airport change',
    '航班号变更': 'Flight number change',
    '无航变': 'No change',
    '出发航站楼变更': 'Departure tower change',
    '到达航站楼变更': 'Arrival tower change',
    '取消后恢复': 'Resume after cancel',
    '取消错误的航变通知': 'Cancellation of erroneous aerial change notification',
    '待通知': 'To Be Notified',
    '通知成功': 'Notification Successful',
    '通知失败': 'Notification Failed',
    '已过期': 'Expired',
    '人工已处理': 'Manually Processed',
    '人工已删除': 'Manually Deleted',
    '系统处理状态': 'Notification Status',
    '正常通知': 'Normal Notification',
    '拒绝通知': 'Refuse Notification'
  }
}



// WEBPACK FOOTER //
// ./src/language/myEn.js